{
  "decorations": [
    {
      "id": "warfish-logo-outline",
      "shape": "M 77.86 6.21 C 77.70 6.26 77.28 6.46 76.91 6.64 C 76.54 6.83 76.11 7.02 75.96 7.06 C 75.65 7.15 74.84 7.68 74.07 8.26 C 73.06 9.05 72.05 10.59 71.63 11.99 C 71.31 13.13 70.89 13.44 69.82 13.35 C 69.11 13.29 68.81 13.32 68.17 13.51 C 67.43 13.75 67.19 13.76 63.47 13.74 C 60.16 13.72 59.47 13.74 59.06 13.88 C 58.45 14.11 57.92 14.11 57.21 13.89 C 56.52 13.68 51.96 13.66 50.57 13.86 C 49.77 13.97 49.54 13.97 48.83 13.80 C 48.39 13.69 47.54 13.55 46.95 13.47 C 45.40 13.26 45.16 13.05 45.32 12.07 C 45.70 9.64 45.18 8.32 43.67 7.84 C 42.71 7.53 35.05 7.41 34.13 7.68 C 33.00 8.02 32.70 8.04 31.66 7.81 C 30.79 7.62 30.23 7.60 27.64 7.62 C 24.53 7.65 24.05 7.70 23.19 8.14 C 22.61 8.44 22.35 8.41 21.35 7.93 C 20.23 7.40 13.29 7.30 11.99 7.79 C 11.30 8.05 10.55 8.77 10.27 9.44 C 9.96 10.18 10.17 16.21 10.56 18.09 C 10.72 18.79 10.85 20.11 10.95 21.90 C 11.06 24.00 11.16 24.94 11.39 25.88 C 11.58 26.75 11.69 27.63 11.75 28.90 C 11.87 31.74 12.42 32.70 14.20 33.17 C 15.34 33.48 22.09 33.38 23.26 33.04 C 24.45 32.70 24.46 32.70 25.57 33.05 C 26.55 33.36 26.38 33.36 33.63 33.05 C 35.03 33.00 36.08 32.23 36.71 30.81 C 37.20 29.72 37.50 29.74 38.41 30.94 C 40.11 33.20 43.71 34.34 46.28 33.43 C 47.36 33.05 47.74 33.03 48.82 33.26 C 50.01 33.50 53.92 33.43 55.05 33.15 C 55.84 32.96 55.99 32.95 56.67 33.10 C 58.59 33.48 64.10 33.35 65.15 32.89 C 66.30 32.38 66.90 30.85 67.21 27.61 C 67.40 25.71 67.78 24.92 68.52 24.92 C 69.16 24.92 69.29 25.87 68.83 27.24 C 67.46 31.44 68.53 33.19 72.54 33.30 C 75.32 33.37 78.74 33.17 79.74 32.86 C 80.54 32.62 80.57 32.62 81.14 32.81 C 82.56 33.29 87.50 33.40 90.40 33.02 C 91.91 32.82 92.23 32.85 94.49 33.40 C 95.88 33.74 98.55 33.68 100.14 33.28 C 101.68 32.88 102.79 32.84 104.52 33.13 C 105.97 33.37 110.43 33.40 111.67 33.19 C 112.34 33.08 112.60 33.09 113.44 33.24 C 115.10 33.58 120.67 33.28 122.44 32.76 C 122.77 32.67 123.04 32.71 124.23 33.05 C 125.99 33.57 127.48 33.64 128.45 33.23 C 129.16 32.94 129.95 32.92 131.02 33.17 C 131.70 33.32 132.10 33.33 134.97 33.19 C 138.57 33.02 138.75 33.02 143.51 33.21 C 147.61 33.38 148.31 33.29 149.15 32.52 C 150.11 31.63 150.44 31.61 151.61 32.37 C 152.02 32.65 152.55 32.90 152.76 32.93 C 152.99 32.98 153.57 33.13 154.06 33.29 C 155.54 33.78 158.80 33.80 160.28 33.35 C 160.86 33.15 161.52 32.98 161.73 32.94 C 161.94 32.90 162.41 32.70 162.77 32.47 C 163.90 31.78 164.41 31.77 165.17 32.43 C 166.24 33.37 172.94 33.85 174.78 33.11 C 176.09 32.58 176.93 31.55 177.08 30.28 C 177.14 29.85 177.31 29.09 177.46 28.59 C 177.62 28.08 177.80 27.19 177.87 26.60 C 177.92 26.02 178.00 25.43 178.04 25.29 C 178.11 24.88 178.75 24.25 179.39 23.95 C 180.47 23.44 181.00 22.60 181.20 21.05 C 181.26 20.56 181.45 19.66 181.61 19.06 C 182.17 16.88 182.03 15.88 181.04 14.82 C 180.38 14.13 180.39 14.19 180.43 12.86 C 180.47 11.44 179.42 9.91 178.22 9.59 C 177.42 9.39 169.92 9.61 169.46 9.85 C 168.45 10.38 167.67 11.31 167.67 11.98 C 167.66 12.58 167.27 13.20 166.30 14.14 C 165.19 15.22 164.89 15.31 164.13 14.76 C 162.94 13.91 161.93 13.60 159.46 13.39 C 158.00 13.27 155.58 13.53 154.71 13.91 C 154.48 14.01 154.02 14.17 153.69 14.30 C 153.36 14.41 152.76 14.75 152.36 15.04 C 150.76 16.21 150.78 16.21 149.79 15.25 C 148.93 14.40 147.89 13.78 147.03 13.63 C 145.90 13.42 143.69 13.35 143.03 13.50 C 142.61 13.60 141.09 13.65 138.05 13.66 C 133.71 13.68 133.67 13.68 133.18 13.94 C 131.41 14.86 130.92 15.97 130.43 20.24 C 130.30 21.49 129.68 21.88 128.72 21.32 C 128.14 20.98 128.03 20.96 126.81 20.93 C 125.17 20.89 124.96 20.73 124.83 19.47 C 124.50 16.09 122.66 14.01 119.63 13.55 C 117.69 13.27 117.32 12.85 117.72 11.42 C 118.26 9.50 117.95 8.07 116.81 7.25 C 115.39 6.24 108.34 6.21 106.69 7.23 C 106.03 7.63 105.52 8.54 105.40 9.49 C 105.29 10.30 104.49 13.73 104.33 13.96 C 104.13 14.29 103.72 14.29 102.95 13.96 C 101.83 13.47 100.59 13.33 98.36 13.49 C 95.88 13.66 95.94 13.69 95.71 12.05 C 95.28 8.95 94.12 7.58 90.90 6.37 C 90.11 6.07 88.27 6.21 87.38 6.65 C 86.35 7.15 85.71 7.14 84.59 6.59 C 83.75 6.18 78.81 5.90 77.86 6.21 Z",
      "fill": "#0057b8",
      "role": "warfish-logo"
    },
    {
      "id": "warfish-logo-lettering",
      "shape": "M 78.95 9.25 C 76.58 9.67 74.91 11.70 74.21 14.99 C 73.96 16.16 73.81 16.38 72.99 16.75 C 72.05 17.18 71.97 17.33 71.54 19.84 C 71.45 20.40 71.67 20.94 72.16 21.39 C 72.82 22.00 72.87 22.21 72.61 23.35 C 72.48 23.87 72.33 24.89 72.25 25.60 C 72.18 26.30 72.00 27.37 71.86 27.95 C 71.32 30.09 71.44 30.19 74.77 30.25 C 77.86 30.31 77.88 30.29 78.15 27.93 C 78.24 27.12 78.43 26.00 78.59 25.44 C 78.73 24.88 78.90 23.95 78.96 23.37 C 79.10 21.89 79.40 21.55 80.70 21.34 C 81.83 21.16 82.03 20.92 82.22 19.44 C 82.27 18.91 82.36 18.26 82.41 17.98 C 82.50 17.30 82.22 16.94 81.44 16.75 C 79.88 16.37 80.20 14.50 81.89 14.23 C 82.94 14.06 83.02 13.97 83.50 12.16 C 84.20 9.53 84.02 9.30 81.16 9.20 C 80.23 9.17 79.24 9.19 78.95 9.25 Z M 87.64 9.37 C 85.96 9.86 84.85 12.39 85.63 14.00 C 87.28 17.37 92.14 15.95 92.13 12.10 C 92.13 9.83 90.17 8.64 87.64 9.37 Z M 108.79 9.65 C 108.42 9.91 108.32 10.17 108.14 11.30 C 108.05 11.87 107.90 12.61 107.81 12.95 C 107.72 13.30 107.57 14.29 107.48 15.14 C 107.38 16.00 107.18 17.20 107.03 17.81 C 106.88 18.43 106.71 19.52 106.64 20.22 C 106.57 20.93 106.37 22.14 106.19 22.91 C 106.02 23.68 105.82 24.77 105.75 25.34 C 105.69 25.90 105.51 26.85 105.35 27.43 C 104.68 30.01 104.86 30.19 108.08 30.19 C 111.22 30.19 111.12 30.30 111.90 25.71 C 112.46 22.40 113.18 21.25 114.32 21.80 C 115.03 22.14 115.03 22.58 114.36 26.50 C 113.75 30.14 113.67 30.01 116.53 30.13 C 119.30 30.24 119.86 30.09 120.02 29.08 C 120.06 28.85 120.21 28.23 120.37 27.68 C 120.51 27.14 120.71 26.23 120.81 25.66 C 120.90 25.10 121.11 24.03 121.26 23.29 C 121.95 19.90 121.50 17.78 119.93 16.91 C 119.00 16.39 116.57 16.41 115.42 16.95 C 113.86 17.69 113.58 17.38 113.91 15.27 C 114.03 14.52 114.19 13.31 114.25 12.61 C 114.32 11.90 114.41 11.14 114.45 10.93 C 114.58 10.40 114.43 9.87 114.12 9.73 C 113.67 9.50 109.08 9.45 108.79 9.65 Z M 37.15 10.36 C 35.12 10.46 34.81 10.65 34.23 12.19 C 34.06 12.64 33.72 13.55 33.45 14.23 C 33.19 14.90 32.92 15.69 32.84 15.97 C 32.31 18.12 31.59 19.59 31.13 19.53 C 30.65 19.46 30.60 19.15 30.60 15.29 C 30.60 10.10 30.77 10.39 27.77 10.38 C 24.76 10.38 24.76 10.38 23.56 13.78 C 21.94 18.41 21.66 19.07 21.23 19.17 C 20.79 19.28 20.62 19.00 20.57 18.14 C 20.54 17.71 20.45 16.36 20.36 15.13 C 20.27 13.89 20.18 12.52 20.16 12.06 C 20.10 10.62 20.02 10.59 16.65 10.59 C 13.05 10.59 12.93 10.68 13.40 13.17 C 13.49 13.63 13.59 14.43 13.64 14.96 C 13.67 15.48 13.77 16.51 13.86 17.25 C 13.94 17.99 14.04 18.94 14.08 19.38 C 14.12 19.81 14.22 20.87 14.31 21.73 C 14.47 23.24 14.86 27.42 14.97 28.78 C 15.08 30.10 15.43 30.22 18.98 30.17 C 21.62 30.13 21.62 30.13 21.94 29.85 C 22.43 29.39 23.85 26.34 24.68 23.92 C 25.41 21.79 26.23 22.07 26.36 24.49 C 26.66 30.18 26.61 30.09 29.54 30.20 C 30.60 30.24 31.69 30.31 31.94 30.36 C 33.17 30.56 33.46 30.21 35.08 26.49 C 35.26 26.09 35.83 24.82 36.36 23.67 C 36.89 22.53 37.32 21.55 37.32 21.52 C 37.32 21.49 37.65 20.79 38.04 19.98 C 39.04 17.91 40.25 15.23 40.77 13.89 C 41.02 13.28 41.35 12.48 41.51 12.11 C 42.28 10.36 41.71 10.13 37.15 10.36 Z M 171.28 12.77 C 170.80 12.99 170.63 13.29 170.41 14.40 C 170.14 15.75 169.90 16.17 169.02 16.63 C 168.29 17.01 168.00 17.41 168.00 18.00 C 168.00 18.15 167.87 18.71 167.71 19.25 C 167.34 20.50 167.40 20.84 168.04 21.41 C 168.86 22.15 168.93 22.42 168.56 23.80 C 168.44 24.26 168.26 25.27 168.17 26.04 C 168.07 26.82 167.90 27.78 167.78 28.19 C 167.23 30.02 167.36 30.10 170.65 30.05 C 173.97 30.01 173.62 30.31 174.43 26.88 C 174.64 25.95 174.90 24.64 175.01 23.97 C 175.29 22.08 175.61 21.60 176.74 21.35 C 177.81 21.12 177.96 20.93 178.24 19.44 C 178.33 18.91 178.47 18.27 178.55 18.00 C 178.74 17.33 178.55 17.02 177.78 16.73 C 176.76 16.36 176.55 15.78 176.85 14.15 C 177.01 13.36 176.87 12.99 176.35 12.77 C 175.81 12.54 171.81 12.54 171.28 12.77 Z M 68.78 16.41 C 68.62 16.46 68.07 16.68 67.56 16.92 L 66.62 17.34 L 65.72 17.04 C 64.62 16.68 60.76 16.59 60.00 16.91 C 59.37 17.18 59.05 18.46 58.21 24.08 C 58.05 25.13 57.82 26.70 57.68 27.58 C 57.30 30.09 57.33 30.12 60.57 30.13 C 62.72 30.13 62.87 30.12 63.08 29.90 C 63.38 29.61 64.02 27.43 64.24 25.99 C 64.74 22.74 65.83 21.45 67.83 21.77 C 69.30 22.00 69.70 21.40 69.90 18.61 C 70.01 17.09 69.93 16.63 69.51 16.44 C 69.19 16.29 69.18 16.29 68.78 16.41 Z M 156.37 16.53 C 150.91 17.71 148.23 24.89 151.81 28.71 C 153.51 30.55 157.21 31.20 160.05 30.19 C 161.88 29.53 162.68 28.96 163.51 27.72 C 164.36 26.44 164.12 25.94 162.54 25.81 C 160.35 25.62 159.90 25.66 158.80 26.17 C 157.62 26.70 157.14 26.66 156.79 25.95 C 156.23 24.86 157.26 24.57 162.18 24.41 C 165.40 24.30 165.63 24.04 165.05 20.97 C 164.39 17.51 160.66 15.61 156.37 16.53 Z M 159.28 20.55 C 159.91 21.18 159.56 21.73 158.54 21.72 C 157.42 21.70 157.01 21.09 157.71 20.51 C 158.20 20.10 158.84 20.11 159.28 20.55 Z M 45.05 16.64 C 40.22 17.40 37.73 26.09 41.38 29.46 C 42.96 30.92 44.48 31.12 46.51 30.10 C 47.87 29.41 48.15 29.39 49.04 29.86 C 50.11 30.42 53.88 30.23 54.22 29.59 C 54.42 29.19 54.99 27.05 55.23 25.75 C 55.35 25.08 55.56 24.15 55.69 23.69 C 55.81 23.23 55.97 22.19 56.03 21.40 C 56.09 20.59 56.25 19.49 56.38 18.96 C 56.82 17.03 56.67 16.90 54.06 16.81 C 51.68 16.72 51.49 16.75 50.76 17.38 C 50.05 17.97 49.81 17.99 49.18 17.47 C 48.16 16.62 46.85 16.35 45.05 16.64 Z M 48.74 21.73 C 50.11 22.44 49.74 24.66 48.13 25.42 C 46.80 26.06 45.46 24.15 46.16 22.62 C 46.57 21.70 47.84 21.26 48.74 21.73 Z M 97.25 16.64 C 95.32 16.91 93.57 18.78 93.45 20.71 C 93.32 22.60 94.19 23.98 96.03 24.88 C 96.93 25.31 97.12 25.50 97.12 25.95 C 97.12 26.63 96.37 26.66 95.09 26.04 C 93.53 25.29 93.37 25.35 92.13 27.05 C 90.97 28.63 91.25 29.15 93.83 30.15 C 97.39 31.55 101.60 30.59 103.09 28.05 C 104.50 25.64 103.35 22.19 100.96 21.67 C 99.94 21.43 99.43 20.84 99.87 20.40 C 100.13 20.13 100.58 20.19 101.21 20.56 C 102.26 21.18 102.70 20.94 103.56 19.25 C 104.25 17.89 104.22 17.76 103.13 17.25 C 101.79 16.64 99.18 16.37 97.25 16.64 Z M 143.70 16.59 C 143.02 16.72 142.49 16.91 142.06 17.21 C 141.30 17.74 141.00 17.75 140.28 17.24 C 139.65 16.81 139.65 16.81 137.32 16.77 C 134.01 16.73 133.93 16.77 133.73 19.02 C 133.67 19.71 133.47 20.90 133.28 21.68 C 133.10 22.45 132.84 23.73 132.73 24.53 C 132.61 25.33 132.38 26.72 132.23 27.60 C 131.77 30.15 131.80 30.19 135.17 30.19 C 138.14 30.19 137.88 30.40 138.54 27.44 C 138.72 26.64 138.90 25.69 138.94 25.32 C 139.20 22.82 139.73 21.79 140.76 21.79 C 141.91 21.79 142.08 22.51 141.58 25.20 C 140.87 28.88 140.83 29.56 141.27 29.96 C 141.67 30.33 146.25 30.30 146.67 29.93 C 147.01 29.64 147.77 26.98 147.90 25.60 C 147.95 25.19 148.14 24.16 148.32 23.30 C 149.35 18.56 147.52 15.91 143.70 16.59 Z M 86.57 16.74 C 85.13 16.90 84.80 17.52 84.35 21.12 C 84.29 21.70 84.09 22.91 83.91 23.80 C 82.56 30.77 82.37 30.19 86.02 30.19 C 89.25 30.19 89.26 30.18 89.56 27.67 C 89.66 26.81 89.89 25.42 90.07 24.59 C 90.24 23.76 90.42 22.75 90.46 22.35 C 90.50 21.95 90.66 21.06 90.79 20.39 C 91.31 17.94 91.27 17.16 90.65 16.86 C 90.30 16.68 87.72 16.62 86.57 16.74 Z M 125.45 24.16 C 123.61 24.68 122.60 26.88 123.42 28.56 C 124.82 31.40 128.64 31.16 130.12 28.15 C 131.39 25.60 128.64 23.26 125.45 24.16 Z",
      "fill": "#ffffff",
      "role": "warfish-logo"
    }
  ],
  "id": "crescent-isle",
  "name": "Crescent Isle",
  "legacy": "warfish",
  "addedOn": "2026-11-02",
  "backgroundImage": "crescent-isle",
  "opaqueTerritoryFills": true,
  "regionColoredInternalBorders": true,
  "hideAdjacencyLines": true,
  "viewBox": {
    "x": 0,
    "y": 0,
    "width": 1216,
    "height": 1235
  },
  "edgeConfig": {
    "internalBorderWidth": 3,
    "regionBorderWidth": 12.8,
    "bridgeStrokeWidth": 0
  },
  "selectionInnerGlow": true,
  "backdropColor": {
    "light": "#a49058",
    "dark": "#4a3f27",
    "topBar": true
  },
  "gameLayout": {
    "playerBarPosition": "right"
  },
  "regions": [
    {
      "id": "stormcrown",
      "name": "Stormcrown",
      "bonus": 7,
      "color": "#E8262B",
      "territoryIds": [
        "cloudbreak",
        "crownhaven",
        "galecliff",
        "highwatch",
        "lightning-ford",
        "ravenspire",
        "skyreach",
        "stormhold",
        "tempest-vale",
        "thunderpeak"
      ],
      "shape": "M 683.0 207.0 L 686.0 209.0 L 688.0 214.0 L 691.0 217.0 L 708.0 217.0 L 711.0 214.0 L 717.0 203.0 L 725.0 203.0 L 727.0 205.0 L 733.0 204.0 L 736.0 204.0 L 738.0 200.0 L 737.0 190.0 L 731.0 187.0 L 728.0 182.0 L 725.0 180.0 L 725.0 177.0 L 728.0 173.0 L 727.0 168.0 L 722.0 166.0 L 714.0 157.0 L 713.0 153.0 L 719.0 147.0 L 729.0 147.0 L 732.0 142.0 L 732.0 137.0 L 735.0 133.0 L 741.0 130.0 L 742.0 124.0 L 740.0 120.0 L 736.0 120.0 L 731.0 117.0 L 731.0 107.0 L 725.0 103.0 L 719.0 101.0 L 719.0 99.0 L 714.0 94.0 L 714.0 84.0 L 706.0 84.0 L 698.0 87.0 L 703.0 81.0 L 704.0 76.0 L 712.0 67.0 L 712.0 64.0 L 715.0 60.0 L 716.0 52.0 L 712.0 48.0 L 698.0 48.0 L 695.0 50.0 L 695.0 55.0 L 692.0 57.0 L 685.0 57.0 L 678.0 61.0 L 677.0 64.0 L 677.0 74.0 L 673.0 79.0 L 670.0 86.0 L 663.0 86.0 L 658.0 81.0 L 649.0 81.0 L 647.0 83.0 L 645.0 76.0 L 638.0 72.0 L 634.0 66.0 L 630.0 64.0 L 610.0 64.0 L 606.0 67.0 L 605.0 73.0 L 603.0 74.0 L 602.0 67.0 L 599.0 62.0 L 595.0 60.0 L 587.0 60.0 L 583.0 63.0 L 580.0 69.0 L 580.0 79.0 L 578.0 81.0 L 578.0 78.0 L 576.0 75.0 L 576.0 61.0 L 571.0 57.0 L 577.0 51.0 L 577.0 44.0 L 566.0 38.0 L 563.0 35.0 L 560.0 35.0 L 556.0 31.0 L 548.0 31.0 L 544.0 34.0 L 543.0 38.0 L 536.0 45.0 L 536.0 39.0 L 533.0 36.0 L 523.0 36.0 L 518.0 41.0 L 509.0 37.0 L 509.0 36.0 L 490.0 36.0 L 484.0 40.0 L 482.0 48.0 L 478.0 50.0 L 476.0 54.0 L 476.0 63.0 L 461.0 63.0 L 455.0 65.0 L 448.0 70.0 L 448.0 81.0 L 452.0 86.0 L 453.0 90.0 L 444.0 90.0 L 442.0 91.0 L 442.0 82.0 L 437.0 77.0 L 428.0 77.0 L 425.0 76.0 L 419.0 80.0 L 415.0 81.0 L 401.0 81.0 L 397.0 83.0 L 396.0 92.0 L 389.0 92.0 L 385.0 96.0 L 385.0 104.0 L 388.0 109.0 L 398.0 116.0 L 398.0 121.0 L 391.0 120.0 L 382.0 114.0 L 382.0 108.0 L 377.0 102.0 L 370.0 102.0 L 366.0 106.0 L 360.0 105.0 L 351.0 105.0 L 347.0 109.0 L 347.0 114.0 L 338.0 107.0 L 329.0 107.0 L 324.0 112.0 L 319.0 113.0 L 318.0 120.0 L 319.0 123.0 L 311.0 123.0 L 305.0 128.0 L 301.0 128.0 L 295.0 131.0 L 292.0 135.0 L 292.0 150.0 L 287.0 150.0 L 284.0 153.0 L 284.0 160.0 L 291.0 172.0 L 294.0 173.0 L 294.0 176.0 L 291.0 178.0 L 284.0 168.0 L 283.0 164.0 L 274.0 160.0 L 267.0 165.0 L 268.0 155.0 L 264.0 152.0 L 250.0 152.0 L 247.0 155.0 L 246.0 163.0 L 243.0 167.0 L 243.0 179.0 L 245.0 181.0 L 239.0 187.0 L 239.0 200.0 L 235.0 195.0 L 235.0 191.0 L 232.0 189.0 L 227.0 189.0 L 221.0 193.0 L 217.0 198.0 L 217.0 204.0 L 212.0 204.0 L 208.0 207.0 L 207.0 215.0 L 198.0 219.0 L 196.0 222.0 L 196.0 230.0 L 194.0 231.0 L 201.0 238.0 L 203.0 238.0 L 208.0 245.0 L 212.0 247.0 L 212.0 256.0 L 223.0 266.0 L 234.0 271.0 L 241.0 280.0 L 241.0 291.0 L 248.0 297.0 L 249.0 301.0 L 255.0 306.0 L 258.0 312.0 L 259.0 312.0 L 259.0 328.0 L 259.0 331.0 L 272.0 336.0 L 280.0 341.0 L 286.0 341.0 L 288.0 335.0 L 298.0 334.0 L 303.0 328.0 L 310.0 328.0 L 317.0 332.0 L 320.0 336.0 L 323.0 337.0 L 332.0 337.0 L 336.0 343.0 L 338.0 343.0 L 343.0 349.0 L 358.0 354.0 L 361.0 347.0 L 371.0 347.0 L 377.0 344.0 L 380.0 341.0 L 386.0 341.0 L 386.0 342.0 L 390.0 345.0 L 391.0 349.0 L 399.0 357.0 L 402.0 363.0 L 402.0 371.0 L 405.0 374.0 L 405.0 377.0 L 409.0 384.0 L 418.0 388.0 L 422.0 392.0 L 426.0 393.0 L 429.0 398.0 L 430.0 398.0 L 431.0 409.0 L 430.0 409.0 L 430.0 419.0 L 436.0 426.0 L 436.0 432.0 L 428.0 436.0 L 427.0 444.0 L 418.0 447.0 L 409.0 447.0 L 404.0 454.0 L 404.0 456.0 L 399.0 456.0 L 397.0 454.0 L 391.0 454.0 L 387.0 457.0 L 381.0 458.0 L 374.0 454.0 L 365.0 455.0 L 365.0 458.0 L 361.0 465.0 L 362.0 471.0 L 364.0 471.0 L 368.0 477.0 L 371.0 479.0 L 375.0 487.0 L 383.0 491.0 L 389.0 498.0 L 389.0 508.0 L 393.0 513.0 L 400.0 514.0 L 404.0 513.0 L 405.0 517.0 L 412.0 521.0 L 424.0 521.0 L 432.0 514.0 L 432.0 507.0 L 430.0 504.0 L 435.0 504.0 L 438.0 501.0 L 438.0 495.0 L 444.0 493.0 L 447.0 490.0 L 446.0 478.0 L 453.0 472.0 L 455.0 465.0 L 461.0 469.0 L 467.0 469.0 L 471.0 467.0 L 475.0 460.0 L 475.0 453.0 L 478.0 449.0 L 478.0 439.0 L 482.0 438.0 L 484.0 435.0 L 487.0 435.0 L 493.0 445.0 L 495.0 446.0 L 495.0 454.0 L 500.0 458.0 L 507.0 458.0 L 510.0 455.0 L 511.0 465.0 L 517.0 468.0 L 523.0 468.0 L 529.0 473.0 L 534.0 473.0 L 537.0 471.0 L 537.0 463.0 L 541.0 462.0 L 545.0 458.0 L 545.0 452.0 L 542.0 448.0 L 539.0 447.0 L 535.0 439.0 L 523.0 431.0 L 521.0 428.0 L 529.0 428.0 L 533.0 433.0 L 541.0 435.0 L 546.0 431.0 L 548.0 425.0 L 554.0 424.0 L 553.0 432.0 L 558.0 440.0 L 558.0 444.0 L 562.0 447.0 L 567.0 447.0 L 572.0 444.0 L 573.0 450.0 L 580.0 452.0 L 585.0 449.0 L 589.0 450.0 L 589.0 462.0 L 593.0 465.0 L 596.0 465.0 L 595.0 468.0 L 595.0 478.0 L 601.0 482.0 L 608.0 482.0 L 615.0 479.0 L 619.0 482.0 L 618.0 484.0 L 622.0 487.0 L 623.0 492.0 L 622.0 496.0 L 618.0 497.0 L 615.0 501.0 L 615.0 504.0 L 610.0 509.0 L 610.0 513.0 L 607.0 515.0 L 604.0 521.0 L 604.0 531.0 L 597.0 531.0 L 593.0 534.0 L 593.0 549.0 L 590.0 552.0 L 590.0 555.0 L 594.0 558.0 L 601.0 559.0 L 603.0 557.0 L 608.0 557.0 L 614.0 553.0 L 624.0 554.0 L 631.0 550.0 L 631.0 544.0 L 636.0 540.0 L 636.0 530.0 L 645.0 529.0 L 648.0 532.0 L 657.0 533.0 L 661.0 529.0 L 661.0 517.0 L 655.0 512.0 L 661.0 505.0 L 661.0 513.0 L 665.0 518.0 L 675.0 518.0 L 679.0 514.0 L 679.0 509.0 L 683.0 504.0 L 695.0 504.0 L 699.0 499.0 L 701.0 494.0 L 705.0 496.0 L 711.0 496.0 L 718.0 493.0 L 718.0 483.0 L 712.0 476.0 L 712.0 471.0 L 717.0 471.0 L 720.0 469.0 L 720.0 464.0 L 721.0 459.0 L 724.0 455.0 L 725.0 450.0 L 730.0 447.0 L 732.0 444.0 L 736.0 443.0 L 736.0 438.0 L 734.0 431.0 L 749.0 422.0 L 753.0 419.0 L 753.0 415.0 L 750.0 411.0 L 750.0 403.0 L 752.0 400.0 L 751.0 397.0 L 751.0 395.0 L 751.0 393.0 L 752.0 388.0 L 750.0 382.0 L 749.0 382.0 L 744.0 378.0 L 739.0 370.0 L 729.0 362.0 L 725.0 362.0 L 721.0 359.0 L 720.0 356.0 L 709.0 356.0 L 706.0 355.0 L 702.0 345.0 L 697.0 344.0 L 683.0 344.0 L 677.0 339.0 L 676.0 332.0 L 671.0 330.0 L 668.0 327.0 L 668.0 318.0 L 671.0 312.0 L 671.0 306.0 L 669.0 302.0 L 661.0 302.0 L 654.0 309.0 L 653.0 312.0 L 646.0 312.0 L 641.0 306.0 L 634.0 303.0 L 635.0 289.0 L 627.0 286.0 L 626.0 284.0 L 625.0 284.0 L 626.0 280.0 L 633.0 275.0 L 633.0 270.0 L 627.0 265.0 L 627.0 261.0 L 631.0 256.0 L 631.0 249.0 L 638.0 241.0 L 639.0 237.0 L 637.0 235.0 L 636.0 223.0 L 637.0 221.0 L 648.0 220.0 L 656.0 213.0 L 662.0 211.0 L 672.0 200.0 L 672.0 199.0 L 680.0 199.0 L 683.0 207.0 Z"
    },
    {
      "id": "kraken-reach",
      "name": "Kraken Reach",
      "bonus": 6,
      "color": "#2167E8",
      "territoryIds": [
        "abyss-gate",
        "blackbrine",
        "coilhaven",
        "deepgrasp",
        "inkwater",
        "krakenhold",
        "squidmoor",
        "suckerstone",
        "tentacle-point"
      ],
      "shape": "M 719.0 101.0 L 725.0 103.0 L 731.0 107.0 L 731.0 117.0 L 736.0 120.0 L 740.0 120.0 L 742.0 124.0 L 741.0 130.0 L 735.0 133.0 L 732.0 137.0 L 732.0 142.0 L 729.0 147.0 L 719.0 147.0 L 713.0 153.0 L 714.0 157.0 L 722.0 166.0 L 727.0 168.0 L 728.0 173.0 L 725.0 177.0 L 725.0 180.0 L 728.0 182.0 L 731.0 187.0 L 737.0 190.0 L 738.0 200.0 L 736.0 204.0 L 735.0 204.0 L 733.0 204.0 L 727.0 205.0 L 725.0 203.0 L 717.0 203.0 L 711.0 214.0 L 708.0 217.0 L 691.0 217.0 L 688.0 214.0 L 686.0 209.0 L 683.0 207.0 L 680.0 199.0 L 672.0 199.0 L 672.0 200.0 L 662.0 211.0 L 656.0 213.0 L 648.0 220.0 L 637.0 221.0 L 636.0 223.0 L 637.0 235.0 L 639.0 237.0 L 638.0 241.0 L 631.0 249.0 L 631.0 256.0 L 627.0 261.0 L 627.0 265.0 L 633.0 270.0 L 633.0 275.0 L 626.0 280.0 L 625.0 284.0 L 626.0 284.0 L 627.0 286.0 L 635.0 289.0 L 634.0 303.0 L 641.0 306.0 L 646.0 312.0 L 653.0 312.0 L 654.0 309.0 L 661.0 302.0 L 669.0 302.0 L 671.0 306.0 L 671.0 312.0 L 668.0 318.0 L 668.0 327.0 L 671.0 330.0 L 676.0 332.0 L 677.0 339.0 L 683.0 344.0 L 697.0 344.0 L 702.0 345.0 L 706.0 355.0 L 709.0 356.0 L 720.0 356.0 L 721.0 359.0 L 725.0 362.0 L 729.0 362.0 L 739.0 370.0 L 744.0 378.0 L 749.0 382.0 L 750.0 382.0 L 752.0 388.0 L 751.0 393.0 L 751.0 397.0 L 752.0 400.0 L 750.0 403.0 L 750.0 411.0 L 753.0 415.0 L 753.0 419.0 L 749.0 422.0 L 734.0 431.0 L 736.0 438.0 L 736.0 443.0 L 732.0 444.0 L 730.0 447.0 L 725.0 450.0 L 724.0 455.0 L 721.0 459.0 L 720.0 464.0 L 720.0 470.0 L 723.0 472.0 L 724.0 476.0 L 728.0 479.0 L 734.0 479.0 L 739.0 476.0 L 742.0 480.0 L 749.0 482.0 L 755.0 480.0 L 756.0 476.0 L 761.0 478.0 L 760.0 488.0 L 764.0 491.0 L 770.0 490.0 L 772.0 487.0 L 778.0 489.0 L 785.0 489.0 L 789.0 486.0 L 790.0 480.0 L 797.0 475.0 L 798.0 478.0 L 807.0 482.0 L 815.0 478.0 L 818.0 474.0 L 816.0 483.0 L 811.0 486.0 L 808.0 490.0 L 808.0 499.0 L 813.0 502.0 L 812.0 504.0 L 807.0 505.0 L 804.0 508.0 L 803.0 514.0 L 804.0 519.0 L 810.0 523.0 L 818.0 522.0 L 824.0 527.0 L 830.0 527.0 L 833.0 530.0 L 836.0 530.0 L 838.0 539.0 L 834.0 543.0 L 828.0 543.0 L 824.0 547.0 L 824.0 555.0 L 827.0 559.0 L 827.0 567.0 L 829.0 571.0 L 833.0 574.0 L 843.0 574.0 L 848.0 571.0 L 848.0 581.0 L 854.0 584.0 L 853.0 599.0 L 856.0 601.0 L 862.0 601.0 L 865.0 598.0 L 873.0 598.0 L 874.0 600.0 L 881.0 598.0 L 889.0 590.0 L 892.0 583.0 L 899.0 583.0 L 901.0 587.0 L 910.0 595.0 L 915.0 594.0 L 919.0 587.0 L 922.0 585.0 L 925.0 576.0 L 932.0 576.0 L 936.0 579.0 L 941.0 579.0 L 946.0 576.0 L 952.0 576.0 L 954.0 581.0 L 957.0 584.0 L 957.0 587.0 L 960.0 591.0 L 964.0 592.0 L 964.0 591.0 L 968.0 590.0 L 970.0 583.0 L 973.0 577.0 L 985.0 566.0 L 990.0 565.0 L 990.0 560.0 L 984.0 555.0 L 984.0 547.0 L 984.0 546.0 L 985.0 545.0 L 998.0 545.0 L 1002.0 543.0 L 1013.0 543.0 L 1018.0 541.0 L 1025.0 541.0 L 1028.0 543.0 L 1038.0 543.0 L 1047.0 533.0 L 1050.0 527.0 L 1050.0 514.0 L 1053.0 510.0 L 1065.0 507.0 L 1067.0 503.0 L 1074.0 498.0 L 1082.0 489.0 L 1083.0 487.0 L 1077.0 484.0 L 1074.0 479.0 L 1071.0 477.0 L 1069.0 471.0 L 1074.0 466.0 L 1074.0 456.0 L 1071.0 450.0 L 1068.0 449.0 L 1061.0 441.0 L 1065.0 440.0 L 1068.0 437.0 L 1068.0 429.0 L 1060.0 425.0 L 1062.0 421.0 L 1067.0 421.0 L 1071.0 418.0 L 1072.0 412.0 L 1062.0 404.0 L 1060.0 404.0 L 1057.0 399.0 L 1048.0 393.0 L 1048.0 384.0 L 1047.0 378.0 L 1043.0 375.0 L 1037.0 375.0 L 1031.0 373.0 L 1031.0 364.0 L 1036.0 367.0 L 1045.0 368.0 L 1053.0 363.0 L 1053.0 355.0 L 1050.0 350.0 L 1053.0 346.0 L 1052.0 337.0 L 1057.0 333.0 L 1057.0 326.0 L 1046.0 320.0 L 1043.0 313.0 L 1031.0 308.0 L 1029.0 304.0 L 1024.0 301.0 L 1018.0 291.0 L 1015.0 291.0 L 1017.0 288.0 L 1020.0 288.0 L 1031.0 296.0 L 1038.0 298.0 L 1042.0 301.0 L 1047.0 302.0 L 1052.0 308.0 L 1061.0 310.0 L 1065.0 309.0 L 1065.0 302.0 L 1055.0 295.0 L 1050.0 286.0 L 1048.0 285.0 L 1047.0 280.0 L 1042.0 275.0 L 1036.0 273.0 L 1034.0 270.0 L 1028.0 267.0 L 1021.0 267.0 L 1015.0 264.0 L 1011.0 260.0 L 1011.0 256.0 L 993.0 246.0 L 989.0 246.0 L 982.0 250.0 L 982.0 245.0 L 980.0 241.0 L 970.0 236.0 L 970.0 222.0 L 962.0 214.0 L 956.0 213.0 L 953.0 210.0 L 946.0 211.0 L 946.0 206.0 L 940.0 201.0 L 947.0 192.0 L 947.0 186.0 L 942.0 181.0 L 942.0 179.0 L 937.0 176.0 L 933.0 170.0 L 927.0 165.0 L 918.0 165.0 L 914.0 168.0 L 913.0 174.0 L 908.0 172.0 L 897.0 172.0 L 892.0 177.0 L 892.0 184.0 L 889.0 184.0 L 889.0 178.0 L 887.0 171.0 L 884.0 168.0 L 884.0 164.0 L 881.0 162.0 L 875.0 162.0 L 873.0 164.0 L 866.0 161.0 L 866.0 152.0 L 863.0 148.0 L 857.0 145.0 L 839.0 145.0 L 835.0 147.0 L 830.0 154.0 L 823.0 152.0 L 820.0 153.0 L 820.0 145.0 L 824.0 136.0 L 824.0 128.0 L 818.0 123.0 L 817.0 118.0 L 823.0 112.0 L 823.0 100.0 L 818.0 96.0 L 814.0 91.0 L 812.0 86.0 L 807.0 84.0 L 790.0 84.0 L 784.0 86.0 L 781.0 90.0 L 775.0 94.0 L 763.0 94.0 L 760.0 97.0 L 743.0 97.0 L 738.0 91.0 L 732.0 90.0 L 721.0 84.0 L 714.0 84.0 L 714.0 94.0 L 719.0 99.0 L 719.0 101.0 Z"
    },
    {
      "id": "mistmarch",
      "name": "Mistmarch",
      "bonus": 5,
      "color": "#8E1FB0",
      "territoryIds": [
        "duskfen",
        "fogmere",
        "gloamridge",
        "greyveil",
        "hazewood",
        "shroud-hollow",
        "vaporholt"
      ],
      "shape": "M 374.0 454.0 L 381.0 458.0 L 387.0 457.0 L 391.0 454.0 L 397.0 454.0 L 399.0 456.0 L 404.0 456.0 L 404.0 454.0 L 409.0 447.0 L 418.0 447.0 L 427.0 444.0 L 428.0 436.0 L 436.0 432.0 L 436.0 426.0 L 430.0 419.0 L 430.0 409.0 L 431.0 409.0 L 430.0 398.0 L 429.0 398.0 L 426.0 393.0 L 422.0 392.0 L 418.0 388.0 L 409.0 384.0 L 405.0 377.0 L 405.0 374.0 L 402.0 371.0 L 402.0 363.0 L 399.0 357.0 L 391.0 349.0 L 390.0 345.0 L 386.0 342.0 L 386.0 341.0 L 380.0 341.0 L 377.0 344.0 L 371.0 347.0 L 361.0 347.0 L 358.0 354.0 L 343.0 349.0 L 338.0 343.0 L 336.0 343.0 L 332.0 337.0 L 323.0 337.0 L 320.0 336.0 L 317.0 332.0 L 310.0 328.0 L 303.0 328.0 L 298.0 334.0 L 288.0 335.0 L 286.0 341.0 L 280.0 341.0 L 272.0 336.0 L 259.0 331.0 L 259.0 328.0 L 259.0 312.0 L 258.0 312.0 L 255.0 306.0 L 249.0 301.0 L 248.0 297.0 L 241.0 291.0 L 241.0 280.0 L 234.0 271.0 L 223.0 266.0 L 212.0 256.0 L 212.0 247.0 L 208.0 245.0 L 203.0 238.0 L 201.0 238.0 L 194.0 231.0 L 189.0 232.0 L 189.0 237.0 L 186.0 240.0 L 183.0 240.0 L 171.0 248.0 L 171.0 253.0 L 174.0 263.0 L 169.0 259.0 L 168.0 256.0 L 162.0 255.0 L 159.0 257.0 L 159.0 265.0 L 156.0 269.0 L 156.0 280.0 L 158.0 283.0 L 167.0 291.0 L 164.0 292.0 L 147.0 283.0 L 141.0 277.0 L 134.0 277.0 L 130.0 281.0 L 130.0 287.0 L 127.0 291.0 L 121.0 291.0 L 117.0 294.0 L 117.0 312.0 L 116.0 317.0 L 114.0 318.0 L 113.0 326.0 L 118.0 335.0 L 121.0 337.0 L 116.0 338.0 L 114.0 333.0 L 106.0 326.0 L 95.0 320.0 L 80.0 320.0 L 78.0 322.0 L 73.0 321.0 L 57.0 321.0 L 52.0 320.0 L 49.0 323.0 L 49.0 328.0 L 51.0 330.0 L 51.0 338.0 L 55.0 342.0 L 55.0 346.0 L 64.0 358.0 L 64.0 360.0 L 58.0 360.0 L 54.0 362.0 L 51.0 367.0 L 35.0 367.0 L 31.0 370.0 L 31.0 381.0 L 35.0 386.0 L 32.0 386.0 L 28.0 389.0 L 27.0 396.0 L 28.0 400.0 L 38.0 404.0 L 39.0 406.0 L 46.0 408.0 L 44.0 413.0 L 44.0 420.0 L 54.0 426.0 L 59.0 427.0 L 58.0 440.0 L 59.0 443.0 L 64.0 446.0 L 64.0 449.0 L 58.0 451.0 L 54.0 458.0 L 54.0 468.0 L 56.0 474.0 L 65.0 478.0 L 69.0 485.0 L 78.0 486.0 L 81.0 491.0 L 85.0 493.0 L 91.0 493.0 L 89.0 498.0 L 89.0 506.0 L 94.0 511.0 L 101.0 511.0 L 103.0 515.0 L 102.0 525.0 L 110.0 531.0 L 101.0 538.0 L 100.0 548.0 L 105.0 553.0 L 109.0 562.0 L 104.0 562.0 L 101.0 564.0 L 101.0 587.0 L 107.0 593.0 L 110.0 593.0 L 120.0 601.0 L 128.0 600.0 L 131.0 594.0 L 142.0 594.0 L 144.0 589.0 L 144.0 580.0 L 145.0 578.0 L 146.0 578.0 L 148.0 578.0 L 150.0 579.0 L 158.0 593.0 L 161.0 597.0 L 166.0 598.0 L 171.0 593.0 L 177.0 593.0 L 192.0 609.0 L 197.0 617.0 L 206.0 618.0 L 209.0 616.0 L 218.0 616.0 L 221.0 619.0 L 226.0 619.0 L 230.0 615.0 L 242.0 615.0 L 244.0 616.0 L 244.0 618.0 L 251.0 627.0 L 252.0 631.0 L 252.0 637.0 L 256.0 642.0 L 260.0 653.0 L 263.0 655.0 L 272.0 654.0 L 277.0 658.0 L 284.0 658.0 L 293.0 653.0 L 295.0 649.0 L 295.0 640.0 L 292.0 636.0 L 281.0 633.0 L 282.0 627.0 L 290.0 627.0 L 295.0 621.0 L 299.0 618.0 L 306.0 618.0 L 312.0 614.0 L 316.0 606.0 L 316.0 594.0 L 324.0 587.0 L 324.0 574.0 L 323.0 571.0 L 327.0 567.0 L 329.0 558.0 L 336.0 558.0 L 339.0 554.0 L 345.0 552.0 L 349.0 553.0 L 360.0 543.0 L 362.0 538.0 L 362.0 529.0 L 369.0 536.0 L 369.0 539.0 L 373.0 541.0 L 382.0 541.0 L 392.0 535.0 L 395.0 530.0 L 395.0 518.0 L 393.0 513.0 L 389.0 508.0 L 389.0 498.0 L 383.0 491.0 L 375.0 487.0 L 371.0 479.0 L 368.0 477.0 L 364.0 471.0 L 362.0 471.0 L 361.0 465.0 L 365.0 458.0 L 365.0 455.0 L 374.0 454.0 Z"
    },
    {
      "id": "kelpwold",
      "name": "Kelpwold",
      "bonus": 4,
      "color": "#16801E",
      "territoryIds": [
        "fernshallow",
        "greenmarsh",
        "kelpdown",
        "mossbank",
        "seagrass-lea",
        "weedwater"
      ],
      "shape": "M 265.0 789.0 L 268.0 786.0 L 268.0 777.0 L 267.0 772.0 L 276.0 773.0 L 280.0 770.0 L 280.0 759.0 L 279.0 756.0 L 269.0 747.0 L 272.0 744.0 L 272.0 735.0 L 263.0 728.0 L 260.0 724.0 L 260.0 708.0 L 259.0 705.0 L 266.0 698.0 L 266.0 692.0 L 273.0 692.0 L 278.0 687.0 L 278.0 679.0 L 280.0 677.0 L 285.0 677.0 L 290.0 673.0 L 290.0 665.0 L 287.0 663.0 L 279.0 664.0 L 259.0 664.0 L 256.0 666.0 L 247.0 665.0 L 244.0 662.0 L 248.0 654.0 L 247.0 643.0 L 252.0 639.0 L 252.0 631.0 L 251.0 627.0 L 244.0 618.0 L 244.0 616.0 L 242.0 615.0 L 230.0 615.0 L 226.0 619.0 L 221.0 619.0 L 218.0 616.0 L 209.0 616.0 L 206.0 618.0 L 197.0 617.0 L 192.0 609.0 L 177.0 593.0 L 171.0 593.0 L 166.0 598.0 L 161.0 597.0 L 158.0 593.0 L 150.0 579.0 L 148.0 578.0 L 145.0 578.0 L 144.0 580.0 L 144.0 589.0 L 142.0 594.0 L 131.0 594.0 L 128.0 600.0 L 120.0 601.0 L 110.0 593.0 L 104.0 596.0 L 95.0 596.0 L 91.0 600.0 L 87.0 600.0 L 84.0 603.0 L 76.0 604.0 L 74.0 601.0 L 71.0 590.0 L 68.0 588.0 L 61.0 589.0 L 59.0 595.0 L 55.0 596.0 L 50.0 600.0 L 49.0 603.0 L 43.0 603.0 L 36.0 607.0 L 32.0 612.0 L 32.0 622.0 L 34.0 626.0 L 31.0 629.0 L 31.0 645.0 L 34.0 649.0 L 41.0 651.0 L 41.0 655.0 L 38.0 658.0 L 38.0 669.0 L 35.0 671.0 L 35.0 679.0 L 37.0 681.0 L 37.0 690.0 L 40.0 695.0 L 47.0 696.0 L 47.0 699.0 L 40.0 699.0 L 34.0 703.0 L 34.0 709.0 L 32.0 711.0 L 32.0 722.0 L 36.0 725.0 L 43.0 725.0 L 43.0 728.0 L 46.0 729.0 L 47.0 733.0 L 52.0 735.0 L 55.0 741.0 L 63.0 747.0 L 62.0 755.0 L 58.0 763.0 L 58.0 772.0 L 61.0 774.0 L 70.0 773.0 L 71.0 782.0 L 79.0 786.0 L 84.0 790.0 L 88.0 796.0 L 86.0 796.0 L 83.0 801.0 L 83.0 808.0 L 78.0 806.0 L 71.0 806.0 L 68.0 808.0 L 68.0 814.0 L 49.0 819.0 L 42.0 824.0 L 42.0 829.0 L 40.0 833.0 L 40.0 845.0 L 42.0 849.0 L 48.0 854.0 L 58.0 854.0 L 67.0 862.0 L 79.0 862.0 L 86.0 859.0 L 94.0 860.0 L 97.0 863.0 L 100.0 863.0 L 102.0 866.0 L 105.0 866.0 L 108.0 864.0 L 114.0 864.0 L 119.0 866.0 L 127.0 874.0 L 128.0 878.0 L 135.0 884.0 L 141.0 886.0 L 144.0 890.0 L 148.0 892.0 L 155.0 892.0 L 157.0 885.0 L 159.0 883.0 L 172.0 883.0 L 179.0 890.0 L 186.0 891.0 L 191.0 888.0 L 193.0 884.0 L 200.0 884.0 L 208.0 894.0 L 220.0 905.0 L 233.0 908.0 L 239.0 905.0 L 240.0 903.0 L 248.0 903.0 L 257.0 908.0 L 261.0 914.0 L 262.0 919.0 L 265.0 922.0 L 273.0 923.0 L 278.0 927.0 L 283.0 928.0 L 283.0 927.0 L 285.0 927.0 L 291.0 920.0 L 296.0 918.0 L 306.0 919.0 L 314.0 916.0 L 316.0 916.0 L 311.0 909.0 L 311.0 905.0 L 306.0 900.0 L 300.0 899.0 L 300.0 888.0 L 291.0 883.0 L 285.0 876.0 L 280.0 872.0 L 284.0 871.0 L 288.0 866.0 L 294.0 864.0 L 298.0 855.0 L 294.0 850.0 L 287.0 848.0 L 285.0 844.0 L 288.0 841.0 L 288.0 832.0 L 290.0 830.0 L 290.0 819.0 L 287.0 813.0 L 283.0 810.0 L 271.0 810.0 L 265.0 804.0 L 265.0 789.0 Z",
      "bonusAnchor": {
        "x": 163.2,
        "y": 750.35
      }
    },
    {
      "id": "amberstrand",
      "name": "Amberstrand",
      "bonus": 4,
      "color": "#F2D600",
      "territoryIds": [
        "amberlight",
        "dune-harbour",
        "goldsand",
        "honeycove",
        "saffron-cape",
        "sunreef"
      ],
      "shape": "M 1067.0 503.0 L 1065.0 507.0 L 1053.0 510.0 L 1050.0 514.0 L 1050.0 527.0 L 1047.0 533.0 L 1038.0 543.0 L 1028.0 543.0 L 1025.0 541.0 L 1018.0 541.0 L 1013.0 543.0 L 1002.0 543.0 L 998.0 545.0 L 985.0 545.0 L 984.0 546.0 L 984.0 547.0 L 984.0 555.0 L 990.0 560.0 L 990.0 565.0 L 985.0 566.0 L 973.0 577.0 L 970.0 583.0 L 968.0 590.0 L 964.0 591.0 L 964.0 592.0 L 960.0 591.0 L 957.0 587.0 L 957.0 584.0 L 954.0 581.0 L 952.0 576.0 L 946.0 576.0 L 941.0 579.0 L 936.0 579.0 L 932.0 576.0 L 925.0 576.0 L 922.0 585.0 L 919.0 587.0 L 915.0 594.0 L 910.0 595.0 L 901.0 587.0 L 899.0 583.0 L 892.0 583.0 L 889.0 590.0 L 881.0 598.0 L 874.0 600.0 L 872.0 606.0 L 872.0 617.0 L 874.0 622.0 L 874.0 627.0 L 876.0 631.0 L 882.0 635.0 L 882.0 642.0 L 886.0 646.0 L 893.0 646.0 L 894.0 657.0 L 898.0 660.0 L 903.0 660.0 L 896.0 666.0 L 896.0 674.0 L 898.0 678.0 L 907.0 685.0 L 915.0 686.0 L 916.0 692.0 L 920.0 698.0 L 928.0 702.0 L 928.0 705.0 L 922.0 703.0 L 922.0 701.0 L 909.0 693.0 L 898.0 694.0 L 894.0 698.0 L 894.0 710.0 L 891.0 714.0 L 891.0 728.0 L 895.0 731.0 L 901.0 733.0 L 904.0 737.0 L 897.0 740.0 L 894.0 745.0 L 894.0 761.0 L 882.0 765.0 L 875.0 771.0 L 875.0 781.0 L 880.0 785.0 L 884.0 790.0 L 887.0 802.0 L 884.0 800.0 L 873.0 800.0 L 869.0 803.0 L 867.0 811.0 L 862.0 808.0 L 856.0 808.0 L 851.0 810.0 L 849.0 806.0 L 845.0 803.0 L 844.0 798.0 L 840.0 795.0 L 827.0 795.0 L 824.0 797.0 L 824.0 810.0 L 827.0 811.0 L 827.0 832.0 L 829.0 835.0 L 837.0 842.0 L 840.0 843.0 L 839.0 850.0 L 839.0 852.0 L 845.0 857.0 L 847.0 862.0 L 850.0 864.0 L 856.0 865.0 L 858.0 870.0 L 866.0 876.0 L 875.0 877.0 L 877.0 875.0 L 881.0 876.0 L 883.0 879.0 L 887.0 880.0 L 887.0 879.0 L 890.0 877.0 L 890.0 873.0 L 893.0 868.0 L 893.0 855.0 L 894.0 851.0 L 898.0 846.0 L 899.0 839.0 L 903.0 832.0 L 909.0 831.0 L 919.0 835.0 L 919.0 836.0 L 930.0 840.0 L 934.0 844.0 L 934.0 849.0 L 931.0 852.0 L 931.0 866.0 L 938.0 871.0 L 937.0 880.0 L 944.0 882.0 L 948.0 886.0 L 948.0 896.0 L 956.0 904.0 L 957.0 908.0 L 951.0 913.0 L 951.0 921.0 L 954.0 923.0 L 956.0 929.0 L 962.0 935.0 L 962.0 933.0 L 971.0 933.0 L 978.0 930.0 L 980.0 927.0 L 984.0 927.0 L 994.0 921.0 L 996.0 921.0 L 1002.0 910.0 L 1007.0 909.0 L 1013.0 902.0 L 1013.0 897.0 L 1011.0 891.0 L 1022.0 891.0 L 1026.0 888.0 L 1026.0 880.0 L 1024.0 876.0 L 1032.0 873.0 L 1039.0 866.0 L 1039.0 854.0 L 1046.0 851.0 L 1047.0 849.0 L 1052.0 849.0 L 1056.0 847.0 L 1056.0 837.0 L 1050.0 833.0 L 1049.0 824.0 L 1050.0 821.0 L 1053.0 821.0 L 1057.0 824.0 L 1064.0 824.0 L 1068.0 820.0 L 1068.0 814.0 L 1073.0 814.0 L 1076.0 811.0 L 1076.0 802.0 L 1070.0 796.0 L 1070.0 782.0 L 1068.0 777.0 L 1063.0 774.0 L 1059.0 769.0 L 1065.0 765.0 L 1070.0 765.0 L 1077.0 761.0 L 1077.0 754.0 L 1070.0 747.0 L 1075.0 747.0 L 1087.0 741.0 L 1100.0 740.0 L 1104.0 737.0 L 1104.0 727.0 L 1102.0 725.0 L 1100.0 715.0 L 1100.0 698.0 L 1095.0 692.0 L 1090.0 678.0 L 1089.0 671.0 L 1092.0 666.0 L 1092.0 663.0 L 1097.0 659.0 L 1099.0 655.0 L 1099.0 649.0 L 1093.0 645.0 L 1090.0 645.0 L 1085.0 642.0 L 1080.0 642.0 L 1073.0 634.0 L 1065.0 631.0 L 1061.0 627.0 L 1053.0 623.0 L 1069.0 623.0 L 1072.0 620.0 L 1078.0 619.0 L 1086.0 619.0 L 1094.0 627.0 L 1099.0 629.0 L 1107.0 629.0 L 1110.0 627.0 L 1118.0 627.0 L 1128.0 638.0 L 1122.0 639.0 L 1118.0 638.0 L 1112.0 641.0 L 1110.0 645.0 L 1110.0 651.0 L 1107.0 658.0 L 1103.0 660.0 L 1104.0 665.0 L 1104.0 684.0 L 1111.0 690.0 L 1116.0 703.0 L 1112.0 704.0 L 1109.0 707.0 L 1107.0 713.0 L 1107.0 725.0 L 1110.0 731.0 L 1111.0 736.0 L 1117.0 743.0 L 1117.0 745.0 L 1126.0 750.0 L 1131.0 746.0 L 1131.0 740.0 L 1135.0 734.0 L 1135.0 730.0 L 1140.0 733.0 L 1146.0 733.0 L 1149.0 731.0 L 1151.0 725.0 L 1157.0 720.0 L 1163.0 717.0 L 1165.0 712.0 L 1169.0 709.0 L 1171.0 703.0 L 1171.0 686.0 L 1176.0 684.0 L 1181.0 675.0 L 1181.0 664.0 L 1184.0 659.0 L 1184.0 651.0 L 1180.0 648.0 L 1175.0 648.0 L 1174.0 640.0 L 1184.0 640.0 L 1189.0 637.0 L 1189.0 631.0 L 1185.0 624.0 L 1185.0 609.0 L 1182.0 597.0 L 1180.0 596.0 L 1180.0 583.0 L 1178.0 580.0 L 1173.0 578.0 L 1173.0 568.0 L 1172.0 565.0 L 1167.0 561.0 L 1163.0 556.0 L 1156.0 555.0 L 1156.0 541.0 L 1154.0 537.0 L 1150.0 535.0 L 1144.0 535.0 L 1144.0 527.0 L 1141.0 526.0 L 1135.0 520.0 L 1120.0 520.0 L 1118.0 517.0 L 1118.0 507.0 L 1117.0 505.0 L 1110.0 501.0 L 1104.0 495.0 L 1103.0 490.0 L 1099.0 488.0 L 1094.0 488.0 L 1092.0 490.0 L 1082.0 489.0 L 1074.0 498.0 L 1067.0 503.0 Z"
    },
    {
      "id": "tritonmere",
      "name": "Tritonmere",
      "bonus": 5,
      "color": "#12D6E8",
      "territoryIds": [
        "coralgate",
        "merrow-rest",
        "nautilus-bay",
        "shellmark",
        "tidewell",
        "tridentfall",
        "lantern-key"
      ],
      "shape": "M 918.0 1010.0 L 922.0 1008.0 L 927.0 1011.0 L 934.0 1011.0 L 938.0 1008.0 L 938.0 998.0 L 944.0 992.0 L 944.0 981.0 L 942.0 978.0 L 943.0 972.0 L 951.0 972.0 L 955.0 969.0 L 956.0 964.0 L 962.0 959.0 L 962.0 950.0 L 959.0 948.0 L 964.0 943.0 L 964.0 937.0 L 962.0 935.0 L 956.0 929.0 L 954.0 923.0 L 951.0 921.0 L 951.0 913.0 L 957.0 908.0 L 956.0 904.0 L 948.0 896.0 L 948.0 886.0 L 944.0 882.0 L 937.0 880.0 L 938.0 871.0 L 931.0 866.0 L 931.0 852.0 L 934.0 849.0 L 934.0 844.0 L 930.0 840.0 L 919.0 836.0 L 919.0 835.0 L 909.0 831.0 L 903.0 832.0 L 899.0 839.0 L 898.0 846.0 L 894.0 851.0 L 893.0 855.0 L 893.0 868.0 L 890.0 873.0 L 890.0 877.0 L 887.0 879.0 L 887.0 880.0 L 883.0 879.0 L 881.0 876.0 L 877.0 875.0 L 875.0 877.0 L 866.0 876.0 L 858.0 870.0 L 856.0 865.0 L 850.0 864.0 L 847.0 862.0 L 845.0 857.0 L 839.0 852.0 L 836.0 851.0 L 831.0 856.0 L 828.0 862.0 L 819.0 861.0 L 813.0 865.0 L 812.0 875.0 L 813.0 878.0 L 805.0 878.0 L 801.0 881.0 L 799.0 888.0 L 792.0 888.0 L 788.0 891.0 L 788.0 899.0 L 785.0 902.0 L 781.0 903.0 L 778.0 910.0 L 775.0 910.0 L 771.0 907.0 L 766.0 907.0 L 754.0 912.0 L 751.0 909.0 L 740.0 909.0 L 734.0 915.0 L 728.0 914.0 L 726.0 912.0 L 720.0 912.0 L 716.0 915.0 L 707.0 915.0 L 704.0 919.0 L 693.0 919.0 L 688.0 916.0 L 683.0 916.0 L 681.0 914.0 L 669.0 914.0 L 665.0 918.0 L 654.0 916.0 L 654.0 917.0 L 643.0 917.0 L 639.0 921.0 L 639.0 931.0 L 642.0 933.0 L 650.0 933.0 L 656.0 937.0 L 660.0 938.0 L 660.0 945.0 L 663.0 949.0 L 668.0 952.0 L 673.0 952.0 L 678.0 948.0 L 689.0 948.0 L 701.0 962.0 L 709.0 961.0 L 714.0 953.0 L 717.0 951.0 L 722.0 951.0 L 719.0 957.0 L 719.0 964.0 L 722.0 967.0 L 730.0 967.0 L 736.0 964.0 L 736.0 969.0 L 739.0 973.0 L 738.0 982.0 L 742.0 986.0 L 745.0 986.0 L 742.0 989.0 L 742.0 996.0 L 740.0 999.0 L 740.0 1010.0 L 733.0 1017.0 L 732.0 1026.0 L 728.0 1031.0 L 726.0 1031.0 L 720.0 1042.0 L 711.0 1046.0 L 708.0 1049.0 L 708.0 1053.0 L 703.0 1061.0 L 691.0 1060.0 L 686.0 1066.0 L 680.0 1070.0 L 680.0 1079.0 L 676.0 1080.0 L 669.0 1089.0 L 664.0 1090.0 L 658.0 1096.0 L 656.0 1100.0 L 656.0 1109.0 L 647.0 1112.0 L 646.0 1114.0 L 640.0 1117.0 L 640.0 1126.0 L 647.0 1129.0 L 656.0 1129.0 L 661.0 1128.0 L 665.0 1130.0 L 673.0 1131.0 L 681.0 1136.0 L 691.0 1136.0 L 696.0 1130.0 L 702.0 1126.0 L 718.0 1126.0 L 721.0 1124.0 L 738.0 1124.0 L 745.0 1123.0 L 754.0 1127.0 L 761.0 1128.0 L 765.0 1131.0 L 771.0 1131.0 L 775.0 1129.0 L 775.0 1126.0 L 783.0 1127.0 L 791.0 1124.0 L 801.0 1123.0 L 804.0 1125.0 L 821.0 1125.0 L 824.0 1123.0 L 830.0 1122.0 L 834.0 1119.0 L 839.0 1113.0 L 843.0 1110.0 L 847.0 1110.0 L 849.0 1115.0 L 856.0 1119.0 L 862.0 1126.0 L 867.0 1129.0 L 874.0 1129.0 L 880.0 1124.0 L 881.0 1119.0 L 881.0 1106.0 L 877.0 1101.0 L 876.0 1097.0 L 881.0 1096.0 L 886.0 1092.0 L 886.0 1083.0 L 891.0 1083.0 L 894.0 1081.0 L 897.0 1075.0 L 906.0 1076.0 L 905.0 1080.0 L 900.0 1086.0 L 900.0 1093.0 L 902.0 1096.0 L 907.0 1097.0 L 912.0 1101.0 L 917.0 1101.0 L 921.0 1099.0 L 926.0 1090.0 L 931.0 1090.0 L 936.0 1085.0 L 936.0 1078.0 L 940.0 1071.0 L 946.0 1071.0 L 949.0 1069.0 L 949.0 1062.0 L 945.0 1057.0 L 945.0 1054.0 L 942.0 1050.0 L 942.0 1047.0 L 936.0 1043.0 L 929.0 1044.0 L 926.0 1048.0 L 919.0 1044.0 L 913.0 1044.0 L 906.0 1048.0 L 900.0 1047.0 L 901.0 1039.0 L 906.0 1035.0 L 906.0 1024.0 L 911.0 1024.0 L 918.0 1019.0 L 918.0 1014.0 L 918.0 1010.0 Z M 756.0 846.0 L 754.0 847.0 L 747.0 859.0 L 743.0 864.0 L 744.0 878.0 L 748.0 882.0 L 753.0 883.0 L 775.0 883.0 L 781.0 884.0 L 791.0 881.0 L 802.0 869.0 L 803.0 867.0 L 803.0 858.0 L 802.0 858.0 L 802.0 847.0 L 796.0 843.0 L 773.0 843.0 L 765.0 846.0 L 756.0 846.0 Z"
    },
    {
      "id": "wyrmtail",
      "name": "Wyrmtail",
      "bonus": 3,
      "color": "#B3122E",
      "territoryIds": [
        "drakesfoot",
        "fangmouth",
        "scalecrest",
        "serpent-coil",
        "wyrmtip"
      ],
      "shape": "M 112.0 888.0 L 114.0 891.0 L 110.0 895.0 L 110.0 905.0 L 115.0 910.0 L 120.0 910.0 L 124.0 915.0 L 131.0 920.0 L 143.0 920.0 L 148.0 922.0 L 149.0 930.0 L 155.0 934.0 L 155.0 937.0 L 152.0 942.0 L 152.0 950.0 L 156.0 955.0 L 157.0 959.0 L 167.0 965.0 L 172.0 964.0 L 176.0 965.0 L 175.0 977.0 L 180.0 985.0 L 188.0 989.0 L 202.0 989.0 L 207.0 987.0 L 207.0 995.0 L 213.0 1001.0 L 222.0 1001.0 L 224.0 1003.0 L 225.0 1009.0 L 228.0 1013.0 L 235.0 1015.0 L 235.0 1019.0 L 233.0 1022.0 L 233.0 1035.0 L 234.0 1037.0 L 242.0 1044.0 L 246.0 1045.0 L 253.0 1051.0 L 261.0 1055.0 L 260.0 1068.0 L 262.0 1072.0 L 270.0 1078.0 L 286.0 1078.0 L 286.0 1089.0 L 289.0 1091.0 L 295.0 1091.0 L 292.0 1095.0 L 287.0 1098.0 L 287.0 1109.0 L 293.0 1115.0 L 299.0 1115.0 L 303.0 1111.0 L 306.0 1111.0 L 304.0 1116.0 L 304.0 1121.0 L 308.0 1124.0 L 307.0 1128.0 L 310.0 1135.0 L 316.0 1140.0 L 321.0 1141.0 L 315.0 1141.0 L 310.0 1144.0 L 309.0 1147.0 L 302.0 1149.0 L 298.0 1155.0 L 298.0 1169.0 L 291.0 1172.0 L 288.0 1176.0 L 287.0 1182.0 L 283.0 1188.0 L 282.0 1196.0 L 278.0 1201.0 L 272.0 1201.0 L 269.0 1203.0 L 269.0 1214.0 L 273.0 1222.0 L 275.0 1223.0 L 285.0 1223.0 L 287.0 1221.0 L 291.0 1222.0 L 294.0 1228.0 L 300.0 1232.0 L 311.0 1232.0 L 319.0 1224.0 L 320.0 1218.0 L 322.0 1217.0 L 322.0 1208.0 L 321.0 1208.0 L 321.0 1196.0 L 322.0 1194.0 L 329.0 1199.0 L 339.0 1199.0 L 345.0 1194.0 L 345.0 1185.0 L 355.0 1184.0 L 359.0 1181.0 L 360.0 1173.0 L 367.0 1173.0 L 368.0 1179.0 L 371.0 1181.0 L 379.0 1181.0 L 384.0 1179.0 L 388.0 1184.0 L 392.0 1186.0 L 402.0 1186.0 L 409.0 1179.0 L 412.0 1184.0 L 417.0 1188.0 L 424.0 1188.0 L 428.0 1185.0 L 432.0 1175.0 L 444.0 1176.0 L 456.0 1168.0 L 465.0 1168.0 L 468.0 1172.0 L 472.0 1174.0 L 495.0 1174.0 L 500.0 1172.0 L 505.0 1166.0 L 506.0 1162.0 L 509.0 1160.0 L 509.0 1157.0 L 525.0 1157.0 L 532.0 1158.0 L 544.0 1155.0 L 546.0 1153.0 L 553.0 1153.0 L 557.0 1148.0 L 564.0 1143.0 L 565.0 1141.0 L 570.0 1141.0 L 576.0 1137.0 L 580.0 1137.0 L 586.0 1142.0 L 598.0 1142.0 L 603.0 1139.0 L 613.0 1139.0 L 615.0 1141.0 L 623.0 1141.0 L 626.0 1138.0 L 626.0 1131.0 L 623.0 1127.0 L 623.0 1121.0 L 617.0 1113.0 L 605.0 1107.0 L 601.0 1101.0 L 594.0 1095.0 L 590.0 1094.0 L 588.0 1083.0 L 585.0 1081.0 L 583.0 1076.0 L 579.0 1074.0 L 572.0 1067.0 L 564.0 1064.0 L 550.0 1064.0 L 545.0 1059.0 L 538.0 1059.0 L 530.0 1054.0 L 530.0 1049.0 L 522.0 1044.0 L 519.0 1044.0 L 519.0 1037.0 L 513.0 1032.0 L 505.0 1031.0 L 497.0 1019.0 L 495.0 1019.0 L 491.0 1013.0 L 488.0 1011.0 L 488.0 1006.0 L 484.0 1001.0 L 473.0 1001.0 L 467.0 1003.0 L 461.0 1007.0 L 461.0 1015.0 L 458.0 1019.0 L 452.0 1022.0 L 445.0 1022.0 L 440.0 1026.0 L 440.0 1029.0 L 435.0 1023.0 L 431.0 1022.0 L 425.0 1017.0 L 418.0 1016.0 L 411.0 1019.0 L 407.0 1014.0 L 407.0 1011.0 L 403.0 1008.0 L 391.0 1007.0 L 390.0 998.0 L 387.0 993.0 L 383.0 991.0 L 382.0 980.0 L 381.0 978.0 L 371.0 972.0 L 366.0 967.0 L 372.0 963.0 L 377.0 954.0 L 377.0 944.0 L 373.0 940.0 L 363.0 940.0 L 359.0 943.0 L 359.0 947.0 L 351.0 947.0 L 346.0 936.0 L 337.0 931.0 L 333.0 930.0 L 330.0 926.0 L 325.0 925.0 L 318.0 921.0 L 317.0 916.0 L 314.0 916.0 L 306.0 919.0 L 296.0 918.0 L 291.0 920.0 L 285.0 927.0 L 283.0 927.0 L 283.0 928.0 L 278.0 927.0 L 273.0 923.0 L 265.0 922.0 L 262.0 919.0 L 261.0 914.0 L 257.0 908.0 L 248.0 903.0 L 240.0 903.0 L 239.0 905.0 L 233.0 908.0 L 220.0 905.0 L 208.0 894.0 L 200.0 884.0 L 193.0 884.0 L 191.0 888.0 L 186.0 891.0 L 179.0 890.0 L 172.0 883.0 L 159.0 883.0 L 157.0 885.0 L 155.0 892.0 L 148.0 892.0 L 144.0 890.0 L 141.0 886.0 L 135.0 884.0 L 128.0 878.0 L 127.0 874.0 L 119.0 866.0 L 114.0 864.0 L 108.0 864.0 L 105.0 866.0 L 105.0 884.0 L 112.0 888.0 Z"
    },
    {
      "id": "leviathans-spine",
      "name": "Leviathan's Spine",
      "bonus": 6,
      "color": "#8A5A2B",
      "territoryIds": [
        "barnacle-key",
        "driftspire",
        "finback",
        "great-leviathan",
        "gullrock",
        "hookjaw",
        "knuckle-isle",
        "longrib"
      ],
      "shape": "M 723.0 599.0 L 719.0 600.0 L 716.0 605.0 L 715.0 617.0 L 704.0 622.0 L 701.0 628.0 L 701.0 640.0 L 705.0 643.0 L 711.0 644.0 L 714.0 648.0 L 714.0 654.0 L 707.0 658.0 L 704.0 658.0 L 699.0 661.0 L 696.0 669.0 L 696.0 686.0 L 688.0 693.0 L 677.0 693.0 L 668.0 696.0 L 665.0 699.0 L 665.0 718.0 L 667.0 725.0 L 676.0 730.0 L 677.0 732.0 L 688.0 735.0 L 695.0 734.0 L 701.0 730.0 L 705.0 721.0 L 716.0 721.0 L 720.0 719.0 L 725.0 712.0 L 725.0 693.0 L 733.0 689.0 L 735.0 686.0 L 738.0 677.0 L 747.0 677.0 L 752.0 672.0 L 751.0 667.0 L 751.0 654.0 L 748.0 647.0 L 745.0 644.0 L 745.0 640.0 L 751.0 634.0 L 751.0 622.0 L 750.0 619.0 L 756.0 614.0 L 761.0 606.0 L 761.0 597.0 L 760.0 594.0 L 756.0 591.0 L 744.0 592.0 L 740.0 595.0 L 727.0 595.0 L 723.0 599.0 Z M 704.0 506.0 L 696.0 514.0 L 688.0 516.0 L 686.0 520.0 L 686.0 531.0 L 688.0 534.0 L 688.0 547.0 L 691.0 551.0 L 695.0 553.0 L 707.0 553.0 L 712.0 562.0 L 713.0 562.0 L 713.0 579.0 L 724.0 589.0 L 733.0 589.0 L 737.0 587.0 L 742.0 582.0 L 742.0 571.0 L 748.0 565.0 L 749.0 559.0 L 746.0 551.0 L 738.0 544.0 L 739.0 536.0 L 743.0 532.0 L 743.0 528.0 L 749.0 519.0 L 750.0 508.0 L 742.0 500.0 L 734.0 496.0 L 722.0 496.0 L 716.0 504.0 L 708.0 504.0 L 704.0 506.0 Z M 531.0 549.0 L 531.0 552.0 L 524.0 555.0 L 522.0 559.0 L 522.0 566.0 L 519.0 570.0 L 519.0 580.0 L 525.0 585.0 L 521.0 587.0 L 515.0 594.0 L 515.0 605.0 L 516.0 608.0 L 512.0 612.0 L 511.0 623.0 L 512.0 625.0 L 519.0 628.0 L 519.0 640.0 L 523.0 644.0 L 540.0 644.0 L 544.0 648.0 L 544.0 661.0 L 548.0 665.0 L 549.0 669.0 L 554.0 672.0 L 560.0 672.0 L 567.0 665.0 L 570.0 654.0 L 573.0 651.0 L 578.0 651.0 L 585.0 647.0 L 585.0 650.0 L 590.0 655.0 L 604.0 655.0 L 611.0 651.0 L 613.0 646.0 L 613.0 639.0 L 616.0 635.0 L 616.0 624.0 L 609.0 620.0 L 607.0 617.0 L 612.0 612.0 L 626.0 612.0 L 632.0 608.0 L 632.0 599.0 L 640.0 595.0 L 643.0 590.0 L 642.0 577.0 L 639.0 572.0 L 634.0 570.0 L 634.0 565.0 L 627.0 561.0 L 624.0 558.0 L 615.0 557.0 L 609.0 564.0 L 604.0 564.0 L 599.0 569.0 L 599.0 574.0 L 586.0 568.0 L 585.0 563.0 L 579.0 555.0 L 575.0 554.0 L 571.0 546.0 L 564.0 541.0 L 555.0 541.0 L 550.0 545.0 L 540.0 544.0 L 531.0 549.0 Z M 581.0 901.0 L 575.0 898.0 L 569.0 898.0 L 558.0 905.0 L 558.0 913.0 L 562.0 916.0 L 572.0 916.0 L 578.0 919.0 L 580.0 924.0 L 587.0 929.0 L 587.0 936.0 L 591.0 938.0 L 611.0 938.0 L 611.0 939.0 L 621.0 939.0 L 625.0 935.0 L 625.0 922.0 L 631.0 914.0 L 631.0 906.0 L 627.0 903.0 L 624.0 903.0 L 623.0 897.0 L 619.0 895.0 L 611.0 896.0 L 597.0 896.0 L 591.0 901.0 L 581.0 901.0 Z M 561.0 749.0 L 555.0 751.0 L 551.0 755.0 L 551.0 760.0 L 549.0 763.0 L 549.0 771.0 L 552.0 780.0 L 559.0 785.0 L 566.0 785.0 L 567.0 787.0 L 574.0 790.0 L 583.0 790.0 L 586.0 788.0 L 604.0 788.0 L 609.0 787.0 L 613.0 784.0 L 613.0 779.0 L 617.0 773.0 L 617.0 760.0 L 619.0 753.0 L 617.0 749.0 L 610.0 747.0 L 606.0 736.0 L 600.0 732.0 L 589.0 732.0 L 589.0 731.0 L 575.0 731.0 L 567.0 733.0 L 561.0 741.0 L 561.0 749.0 Z M 496.0 763.0 L 489.0 767.0 L 487.0 774.0 L 484.0 777.0 L 485.0 784.0 L 485.0 793.0 L 484.0 801.0 L 485.0 803.0 L 493.0 808.0 L 495.0 813.0 L 501.0 817.0 L 511.0 817.0 L 514.0 815.0 L 520.0 814.0 L 527.0 806.0 L 531.0 805.0 L 535.0 799.0 L 535.0 793.0 L 540.0 783.0 L 540.0 775.0 L 537.0 769.0 L 525.0 763.0 L 525.0 761.0 L 517.0 756.0 L 511.0 756.0 L 506.0 761.0 L 502.0 763.0 L 496.0 763.0 Z M 445.0 812.0 L 443.0 817.0 L 443.0 832.0 L 440.0 837.0 L 440.0 847.0 L 444.0 852.0 L 452.0 859.0 L 458.0 861.0 L 463.0 861.0 L 469.0 857.0 L 479.0 855.0 L 481.0 853.0 L 485.0 854.0 L 490.0 851.0 L 492.0 842.0 L 497.0 837.0 L 497.0 827.0 L 492.0 823.0 L 488.0 812.0 L 482.0 809.0 L 474.0 801.0 L 462.0 801.0 L 453.0 809.0 L 449.0 809.0 L 445.0 812.0 Z M 425.0 882.0 L 423.0 887.0 L 421.0 887.0 L 415.0 895.0 L 415.0 906.0 L 425.0 917.0 L 421.0 924.0 L 417.0 928.0 L 416.0 939.0 L 417.0 939.0 L 417.0 950.0 L 416.0 950.0 L 416.0 959.0 L 418.0 965.0 L 420.0 966.0 L 420.0 972.0 L 416.0 978.0 L 416.0 989.0 L 418.0 995.0 L 421.0 999.0 L 435.0 1005.0 L 438.0 1008.0 L 444.0 1008.0 L 447.0 1006.0 L 449.0 999.0 L 453.0 1000.0 L 467.0 1000.0 L 473.0 995.0 L 472.0 985.0 L 466.0 981.0 L 463.0 968.0 L 466.0 963.0 L 466.0 956.0 L 461.0 951.0 L 457.0 945.0 L 455.0 938.0 L 454.0 926.0 L 461.0 920.0 L 462.0 914.0 L 464.0 914.0 L 469.0 907.0 L 469.0 897.0 L 468.0 894.0 L 461.0 888.0 L 455.0 886.0 L 452.0 881.0 L 449.0 879.0 L 445.0 873.0 L 439.0 858.0 L 435.0 855.0 L 428.0 855.0 L 424.0 860.0 L 424.0 874.0 L 425.0 882.0 Z",
      "bonusAnchor": {
        "x": 622.28,
        "y": 789.23
      }
    }
  ],
  "territories": [
    {
      "id": "cloudbreak",
      "name": "Cloudbreak",
      "regionId": "stormcrown",
      "shape": "M 481.0 199.0 L 481.0 200.0 L 475.0 205.0 L 472.0 205.0 L 468.0 212.0 L 459.0 218.0 L 450.0 218.0 L 449.0 225.0 L 454.0 228.0 L 454.0 233.0 L 447.0 239.0 L 444.0 240.0 L 427.0 240.0 L 421.0 245.0 L 418.0 245.0 L 417.0 249.0 L 412.0 252.0 L 412.0 259.0 L 409.0 262.0 L 403.0 262.0 L 400.0 266.0 L 399.0 279.0 L 403.0 281.0 L 410.0 288.0 L 410.0 295.0 L 408.0 297.0 L 407.0 303.0 L 396.0 308.0 L 398.0 313.0 L 398.0 318.0 L 392.0 322.0 L 388.0 327.0 L 388.0 336.0 L 386.0 338.0 L 386.0 342.0 L 390.0 345.0 L 391.0 349.0 L 399.0 357.0 L 402.0 363.0 L 402.0 371.0 L 405.0 374.0 L 405.0 377.0 L 409.0 384.0 L 418.0 388.0 L 422.0 392.0 L 426.0 393.0 L 429.0 398.0 L 432.0 398.0 L 435.0 396.0 L 440.0 396.0 L 449.0 390.0 L 449.0 384.0 L 456.0 380.0 L 465.0 380.0 L 467.0 382.0 L 474.0 382.0 L 477.0 384.0 L 479.0 389.0 L 479.0 394.0 L 482.0 396.0 L 485.0 389.0 L 490.0 385.0 L 491.0 380.0 L 498.0 374.0 L 505.0 373.0 L 508.0 371.0 L 508.0 369.0 L 512.0 362.0 L 517.0 358.0 L 516.0 353.0 L 516.0 340.0 L 518.0 338.0 L 518.0 333.0 L 521.0 331.0 L 523.0 324.0 L 526.0 320.0 L 532.0 322.0 L 535.0 322.0 L 539.0 316.0 L 539.0 312.0 L 544.0 307.0 L 544.0 301.0 L 542.0 300.0 L 542.0 292.0 L 539.0 289.0 L 539.0 285.0 L 545.0 279.0 L 547.0 273.0 L 547.0 264.0 L 546.0 260.0 L 537.0 252.0 L 536.0 246.0 L 538.0 243.0 L 537.0 237.0 L 527.0 228.0 L 519.0 227.0 L 516.0 229.0 L 509.0 229.0 L 504.0 227.0 L 501.0 222.0 L 498.0 220.0 L 495.0 215.0 L 495.0 208.0 L 492.0 204.0 Z",
      "position": {
        "x": 470.4,
        "y": 294.6
      },
      "badgeAnchor": {
        "x": 470.4,
        "y": 294.6
      },
      "adjacencies": [
        "galecliff",
        "hazewood",
        "highwatch",
        "lightning-ford",
        "ravenspire",
        "skyreach"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crownhaven",
      "name": "Crownhaven",
      "regionId": "stormcrown",
      "shape": "M 658.0 411.0 L 657.0 411.0 L 657.0 415.0 L 650.0 422.0 L 645.0 424.0 L 642.0 427.0 L 642.0 433.0 L 646.0 437.0 L 646.0 442.0 L 643.0 445.0 L 642.0 452.0 L 638.0 454.0 L 631.0 463.0 L 630.0 472.0 L 622.0 478.0 L 619.0 482.0 L 618.0 484.0 L 622.0 487.0 L 623.0 492.0 L 622.0 496.0 L 618.0 497.0 L 615.0 501.0 L 615.0 504.0 L 610.0 509.0 L 610.0 513.0 L 607.0 515.0 L 604.0 521.0 L 604.0 531.0 L 597.0 531.0 L 593.0 534.0 L 593.0 549.0 L 590.0 552.0 L 590.0 555.0 L 594.0 558.0 L 601.0 559.0 L 603.0 557.0 L 608.0 557.0 L 614.0 553.0 L 624.0 554.0 L 631.0 550.0 L 631.0 544.0 L 636.0 540.0 L 636.0 530.0 L 645.0 529.0 L 648.0 532.0 L 657.0 533.0 L 661.0 529.0 L 661.0 517.0 L 655.0 512.0 L 661.0 505.0 L 661.0 513.0 L 665.0 518.0 L 675.0 518.0 L 679.0 514.0 L 679.0 509.0 L 683.0 504.0 L 695.0 504.0 L 699.0 499.0 L 701.0 494.0 L 705.0 496.0 L 711.0 496.0 L 718.0 493.0 L 718.0 483.0 L 712.0 476.0 L 712.0 471.0 L 717.0 471.0 L 720.0 469.0 L 720.0 464.0 L 721.0 459.0 L 724.0 455.0 L 725.0 450.0 L 730.0 447.0 L 732.0 444.0 L 736.0 443.0 L 736.0 438.0 L 734.0 431.0 L 749.0 422.0 L 753.0 419.0 L 753.0 415.0 L 750.0 411.0 L 750.0 403.0 L 752.0 400.0 L 751.0 397.0 L 751.0 395.0 L 745.0 395.0 L 736.0 398.0 L 732.0 402.0 L 724.0 402.0 L 719.0 400.0 L 709.0 400.0 L 702.0 404.0 L 699.0 409.0 L 691.0 414.0 L 685.0 414.0 L 678.0 410.0 L 675.0 407.0 L 667.0 407.0 Z",
      "position": {
        "x": 675.7,
        "y": 466.4
      },
      "badgeAnchor": {
        "x": 675.7,
        "y": 466.4
      },
      "adjacencies": [
        "coilhaven",
        "great-leviathan",
        "skyreach",
        "tempest-vale",
        "finback"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "galecliff",
      "name": "Galecliff",
      "regionId": "stormcrown",
      "shape": "M 398.0 123.0 L 400.0 125.0 L 401.0 131.0 L 403.0 133.0 L 403.0 139.0 L 399.0 144.0 L 388.0 145.0 L 383.0 151.0 L 375.0 155.0 L 369.0 155.0 L 361.0 165.0 L 349.0 165.0 L 347.0 167.0 L 347.0 174.0 L 343.0 178.0 L 338.0 179.0 L 338.0 185.0 L 335.0 189.0 L 336.0 193.0 L 343.0 201.0 L 343.0 202.0 L 349.0 203.0 L 351.0 205.0 L 361.0 203.0 L 369.0 211.0 L 376.0 208.0 L 381.0 208.0 L 383.0 212.0 L 390.0 218.0 L 391.0 226.0 L 395.0 231.0 L 404.0 236.0 L 410.0 237.0 L 417.0 245.0 L 421.0 245.0 L 427.0 240.0 L 444.0 240.0 L 447.0 239.0 L 454.0 233.0 L 454.0 228.0 L 449.0 225.0 L 450.0 218.0 L 459.0 218.0 L 468.0 212.0 L 472.0 205.0 L 475.0 205.0 L 481.0 200.0 L 481.0 195.0 L 481.0 187.0 L 486.0 184.0 L 491.0 177.0 L 496.0 173.0 L 496.0 167.0 L 484.0 159.0 L 484.0 157.0 L 476.0 151.0 L 468.0 151.0 L 463.0 147.0 L 463.0 144.0 L 468.0 140.0 L 481.0 140.0 L 484.0 143.0 L 489.0 143.0 L 493.0 140.0 L 497.0 134.0 L 497.0 128.0 L 500.0 125.0 L 508.0 123.0 L 513.0 119.0 L 518.0 109.0 L 515.0 105.0 L 516.0 95.0 L 525.0 88.0 L 534.0 88.0 L 538.0 91.0 L 549.0 91.0 L 554.0 88.0 L 556.0 84.0 L 561.0 86.0 L 573.0 83.0 L 575.0 83.0 L 578.0 81.0 L 578.0 78.0 L 576.0 75.0 L 576.0 61.0 L 571.0 57.0 L 577.0 51.0 L 577.0 44.0 L 566.0 38.0 L 563.0 35.0 L 560.0 35.0 L 556.0 31.0 L 548.0 31.0 L 544.0 34.0 L 543.0 38.0 L 536.0 45.0 L 536.0 39.0 L 533.0 36.0 L 523.0 36.0 L 518.0 41.0 L 509.0 37.0 L 509.0 36.0 L 490.0 36.0 L 484.0 40.0 L 482.0 48.0 L 478.0 50.0 L 476.0 54.0 L 476.0 63.0 L 461.0 63.0 L 455.0 65.0 L 448.0 70.0 L 448.0 81.0 L 452.0 86.0 L 453.0 90.0 L 444.0 90.0 L 442.0 91.0 L 442.0 82.0 L 437.0 77.0 L 428.0 77.0 L 425.0 76.0 L 419.0 80.0 L 415.0 81.0 L 401.0 81.0 L 397.0 83.0 L 396.0 92.0 L 389.0 92.0 L 385.0 96.0 L 385.0 104.0 L 388.0 109.0 L 398.0 116.0 Z",
      "position": {
        "x": 428.7,
        "y": 178.1
      },
      "badgeAnchor": {
        "x": 428.7,
        "y": 178.1
      },
      "adjacencies": [
        "cloudbreak",
        "highwatch",
        "ravenspire",
        "stormhold"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "highwatch",
      "name": "Highwatch",
      "regionId": "stormcrown",
      "shape": "M 343.0 202.0 L 343.0 203.0 L 340.0 208.0 L 341.0 221.0 L 340.0 226.0 L 336.0 232.0 L 333.0 234.0 L 319.0 233.0 L 318.0 234.0 L 318.0 254.0 L 315.0 258.0 L 308.0 261.0 L 304.0 265.0 L 304.0 271.0 L 309.0 277.0 L 309.0 282.0 L 304.0 286.0 L 304.0 292.0 L 301.0 296.0 L 295.0 296.0 L 291.0 286.0 L 276.0 286.0 L 275.0 287.0 L 275.0 297.0 L 268.0 299.0 L 264.0 305.0 L 264.0 308.0 L 261.0 312.0 L 259.0 312.0 L 259.0 328.0 L 259.0 331.0 L 272.0 336.0 L 280.0 341.0 L 286.0 341.0 L 288.0 335.0 L 298.0 334.0 L 303.0 328.0 L 310.0 328.0 L 317.0 332.0 L 320.0 336.0 L 323.0 337.0 L 332.0 337.0 L 336.0 343.0 L 338.0 343.0 L 343.0 349.0 L 358.0 354.0 L 361.0 347.0 L 371.0 347.0 L 377.0 344.0 L 380.0 341.0 L 386.0 341.0 L 386.0 338.0 L 388.0 336.0 L 388.0 327.0 L 392.0 322.0 L 398.0 318.0 L 398.0 313.0 L 396.0 308.0 L 407.0 303.0 L 408.0 297.0 L 410.0 295.0 L 410.0 288.0 L 403.0 281.0 L 399.0 279.0 L 400.0 266.0 L 403.0 262.0 L 409.0 262.0 L 412.0 259.0 L 412.0 252.0 L 417.0 249.0 L 418.0 245.0 L 417.0 245.0 L 410.0 237.0 L 404.0 236.0 L 395.0 231.0 L 391.0 226.0 L 390.0 218.0 L 383.0 212.0 L 381.0 208.0 L 376.0 208.0 L 369.0 211.0 L 361.0 203.0 L 351.0 205.0 L 349.0 203.0 Z",
      "position": {
        "x": 354.3,
        "y": 288.9
      },
      "badgeAnchor": {
        "x": 354.3,
        "y": 288.9
      },
      "adjacencies": [
        "cloudbreak",
        "fogmere",
        "galecliff",
        "hazewood",
        "stormhold"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "lightning-ford",
      "name": "Lightning Ford",
      "regionId": "stormcrown",
      "shape": "M 432.0 398.0 L 430.0 398.0 L 431.0 409.0 L 430.0 409.0 L 430.0 419.0 L 436.0 426.0 L 436.0 432.0 L 428.0 436.0 L 427.0 444.0 L 418.0 447.0 L 409.0 447.0 L 404.0 454.0 L 404.0 456.0 L 399.0 456.0 L 397.0 454.0 L 391.0 454.0 L 387.0 457.0 L 381.0 458.0 L 374.0 454.0 L 365.0 455.0 L 365.0 458.0 L 361.0 465.0 L 362.0 471.0 L 364.0 471.0 L 368.0 477.0 L 371.0 479.0 L 375.0 487.0 L 383.0 491.0 L 389.0 498.0 L 389.0 508.0 L 393.0 513.0 L 400.0 514.0 L 404.0 513.0 L 405.0 517.0 L 412.0 521.0 L 424.0 521.0 L 432.0 514.0 L 432.0 507.0 L 430.0 504.0 L 435.0 504.0 L 438.0 501.0 L 438.0 495.0 L 444.0 493.0 L 447.0 490.0 L 446.0 478.0 L 453.0 472.0 L 455.0 465.0 L 461.0 469.0 L 467.0 469.0 L 471.0 467.0 L 475.0 460.0 L 475.0 453.0 L 478.0 449.0 L 478.0 439.0 L 482.0 438.0 L 484.0 435.0 L 487.0 435.0 L 493.0 445.0 L 495.0 446.0 L 495.0 454.0 L 500.0 458.0 L 507.0 458.0 L 510.0 455.0 L 511.0 465.0 L 517.0 468.0 L 523.0 468.0 L 529.0 473.0 L 534.0 473.0 L 537.0 471.0 L 537.0 463.0 L 541.0 462.0 L 545.0 458.0 L 545.0 452.0 L 542.0 448.0 L 539.0 447.0 L 535.0 439.0 L 523.0 431.0 L 521.0 428.0 L 517.0 428.0 L 514.0 417.0 L 517.0 414.0 L 517.0 409.0 L 513.0 408.0 L 508.0 404.0 L 509.0 396.0 L 509.0 386.0 L 512.0 383.0 L 512.0 378.0 L 508.0 372.0 L 508.0 371.0 L 505.0 373.0 L 498.0 374.0 L 491.0 380.0 L 490.0 385.0 L 485.0 389.0 L 482.0 396.0 L 479.0 394.0 L 479.0 389.0 L 477.0 384.0 L 474.0 382.0 L 467.0 382.0 L 465.0 380.0 L 456.0 380.0 L 449.0 384.0 L 449.0 390.0 L 440.0 396.0 L 435.0 396.0 Z",
      "position": {
        "x": 462,
        "y": 416.2
      },
      "badgeAnchor": {
        "x": 462,
        "y": 416.2
      },
      "adjacencies": [
        "cloudbreak",
        "great-leviathan",
        "hazewood",
        "shroud-hollow",
        "skyreach"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "ravenspire",
      "name": "Ravenspire",
      "regionId": "stormcrown",
      "shape": "M 573.0 83.0 L 561.0 86.0 L 556.0 84.0 L 554.0 88.0 L 549.0 91.0 L 538.0 91.0 L 534.0 88.0 L 525.0 88.0 L 516.0 95.0 L 515.0 105.0 L 518.0 109.0 L 513.0 119.0 L 508.0 123.0 L 500.0 125.0 L 497.0 128.0 L 497.0 134.0 L 493.0 140.0 L 489.0 143.0 L 484.0 143.0 L 481.0 140.0 L 468.0 140.0 L 463.0 144.0 L 463.0 147.0 L 468.0 151.0 L 476.0 151.0 L 484.0 157.0 L 484.0 159.0 L 496.0 167.0 L 496.0 173.0 L 491.0 177.0 L 486.0 184.0 L 481.0 187.0 L 481.0 195.0 L 481.0 199.0 L 492.0 204.0 L 495.0 208.0 L 495.0 215.0 L 498.0 220.0 L 501.0 222.0 L 504.0 227.0 L 509.0 229.0 L 516.0 229.0 L 519.0 227.0 L 527.0 228.0 L 537.0 237.0 L 538.0 243.0 L 536.0 246.0 L 537.0 252.0 L 546.0 260.0 L 547.0 264.0 L 547.0 273.0 L 545.0 279.0 L 539.0 285.0 L 539.0 289.0 L 542.0 292.0 L 542.0 300.0 L 544.0 301.0 L 544.0 307.0 L 539.0 312.0 L 539.0 316.0 L 535.0 322.0 L 534.0 322.0 L 541.0 330.0 L 543.0 330.0 L 551.0 339.0 L 557.0 341.0 L 561.0 336.0 L 567.0 336.0 L 571.0 341.0 L 576.0 345.0 L 578.0 345.0 L 578.0 344.0 L 589.0 344.0 L 593.0 341.0 L 592.0 329.0 L 594.0 326.0 L 594.0 321.0 L 598.0 317.0 L 598.0 305.0 L 601.0 301.0 L 609.0 301.0 L 612.0 299.0 L 614.0 294.0 L 624.0 285.0 L 624.0 284.0 L 625.0 284.0 L 626.0 280.0 L 633.0 275.0 L 633.0 270.0 L 627.0 265.0 L 627.0 261.0 L 631.0 256.0 L 631.0 249.0 L 638.0 241.0 L 639.0 237.0 L 637.0 235.0 L 636.0 223.0 L 637.0 221.0 L 648.0 220.0 L 656.0 213.0 L 662.0 211.0 L 672.0 200.0 L 672.0 198.0 L 667.0 194.0 L 660.0 194.0 L 655.0 187.0 L 649.0 181.0 L 650.0 172.0 L 646.0 165.0 L 638.0 164.0 L 627.0 152.0 L 625.0 151.0 L 612.0 151.0 L 610.0 156.0 L 603.0 160.0 L 593.0 162.0 L 589.0 165.0 L 584.0 165.0 L 577.0 163.0 L 574.0 160.0 L 572.0 149.0 L 566.0 145.0 L 559.0 136.0 L 559.0 129.0 L 562.0 123.0 L 567.0 120.0 L 569.0 114.0 L 569.0 104.0 L 574.0 98.0 L 574.0 83.0 Z",
      "position": {
        "x": 584.6,
        "y": 216.8
      },
      "badgeAnchor": {
        "x": 584.6,
        "y": 216.8
      },
      "adjacencies": [
        "cloudbreak",
        "galecliff",
        "skyreach",
        "tempest-vale",
        "tentacle-point",
        "thunderpeak"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "skyreach",
      "name": "Skyreach",
      "regionId": "stormcrown",
      "shape": "M 508.0 369.0 L 508.0 372.0 L 512.0 378.0 L 512.0 383.0 L 509.0 386.0 L 509.0 396.0 L 508.0 404.0 L 513.0 408.0 L 517.0 409.0 L 517.0 414.0 L 514.0 417.0 L 517.0 428.0 L 529.0 428.0 L 533.0 433.0 L 541.0 435.0 L 546.0 431.0 L 548.0 425.0 L 554.0 424.0 L 553.0 432.0 L 558.0 440.0 L 558.0 444.0 L 562.0 447.0 L 567.0 447.0 L 572.0 444.0 L 573.0 450.0 L 580.0 452.0 L 585.0 449.0 L 589.0 450.0 L 589.0 462.0 L 593.0 465.0 L 596.0 465.0 L 595.0 468.0 L 595.0 478.0 L 601.0 482.0 L 608.0 482.0 L 615.0 479.0 L 619.0 482.0 L 622.0 478.0 L 630.0 472.0 L 631.0 463.0 L 638.0 454.0 L 642.0 452.0 L 643.0 445.0 L 646.0 442.0 L 646.0 437.0 L 642.0 433.0 L 642.0 427.0 L 645.0 424.0 L 650.0 422.0 L 657.0 415.0 L 657.0 411.0 L 656.0 411.0 L 646.0 406.0 L 645.0 402.0 L 640.0 400.0 L 635.0 393.0 L 637.0 382.0 L 630.0 378.0 L 628.0 372.0 L 625.0 371.0 L 623.0 364.0 L 610.0 365.0 L 610.0 366.0 L 593.0 366.0 L 586.0 367.0 L 585.0 364.0 L 580.0 360.0 L 577.0 353.0 L 577.0 345.0 L 576.0 345.0 L 571.0 341.0 L 567.0 336.0 L 561.0 336.0 L 557.0 341.0 L 551.0 339.0 L 543.0 330.0 L 541.0 330.0 L 534.0 322.0 L 532.0 322.0 L 526.0 320.0 L 523.0 324.0 L 521.0 331.0 L 518.0 333.0 L 518.0 338.0 L 516.0 340.0 L 516.0 353.0 L 517.0 358.0 L 512.0 362.0 Z",
      "position": {
        "x": 595.5,
        "y": 408.3
      },
      "badgeAnchor": {
        "x": 595.5,
        "y": 408.3
      },
      "adjacencies": [
        "cloudbreak",
        "crownhaven",
        "great-leviathan",
        "lightning-ford",
        "ravenspire",
        "tempest-vale"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "stormhold",
      "name": "Stormhold",
      "regionId": "stormcrown",
      "shape": "M 194.0 231.0 L 201.0 238.0 L 203.0 238.0 L 208.0 245.0 L 212.0 247.0 L 212.0 256.0 L 223.0 266.0 L 234.0 271.0 L 241.0 280.0 L 241.0 291.0 L 248.0 297.0 L 249.0 301.0 L 255.0 306.0 L 258.0 312.0 L 261.0 312.0 L 264.0 308.0 L 264.0 305.0 L 268.0 299.0 L 275.0 297.0 L 275.0 287.0 L 276.0 286.0 L 291.0 286.0 L 295.0 296.0 L 301.0 296.0 L 304.0 292.0 L 304.0 286.0 L 309.0 282.0 L 309.0 277.0 L 304.0 271.0 L 304.0 265.0 L 308.0 261.0 L 315.0 258.0 L 318.0 254.0 L 318.0 234.0 L 319.0 233.0 L 333.0 234.0 L 336.0 232.0 L 340.0 226.0 L 341.0 221.0 L 340.0 208.0 L 343.0 203.0 L 343.0 201.0 L 336.0 193.0 L 335.0 189.0 L 338.0 185.0 L 338.0 179.0 L 343.0 178.0 L 347.0 174.0 L 347.0 167.0 L 349.0 165.0 L 361.0 165.0 L 369.0 155.0 L 375.0 155.0 L 383.0 151.0 L 388.0 145.0 L 399.0 144.0 L 403.0 139.0 L 403.0 133.0 L 401.0 131.0 L 400.0 125.0 L 398.0 123.0 L 398.0 121.0 L 391.0 120.0 L 382.0 114.0 L 382.0 108.0 L 377.0 102.0 L 370.0 102.0 L 366.0 106.0 L 360.0 105.0 L 351.0 105.0 L 347.0 109.0 L 347.0 114.0 L 338.0 107.0 L 329.0 107.0 L 324.0 112.0 L 319.0 113.0 L 318.0 120.0 L 319.0 123.0 L 311.0 123.0 L 305.0 128.0 L 301.0 128.0 L 295.0 131.0 L 292.0 135.0 L 292.0 150.0 L 287.0 150.0 L 284.0 153.0 L 284.0 160.0 L 291.0 172.0 L 294.0 173.0 L 294.0 176.0 L 291.0 178.0 L 284.0 168.0 L 283.0 164.0 L 274.0 160.0 L 267.0 165.0 L 268.0 155.0 L 264.0 152.0 L 250.0 152.0 L 247.0 155.0 L 246.0 163.0 L 243.0 167.0 L 243.0 179.0 L 245.0 181.0 L 239.0 187.0 L 239.0 200.0 L 235.0 195.0 L 235.0 191.0 L 232.0 189.0 L 227.0 189.0 L 221.0 193.0 L 217.0 198.0 L 217.0 204.0 L 212.0 204.0 L 208.0 207.0 L 207.0 215.0 L 198.0 219.0 L 196.0 222.0 L 196.0 230.0 Z",
      "position": {
        "x": 266.5,
        "y": 237.4
      },
      "badgeAnchor": {
        "x": 266.5,
        "y": 237.4
      },
      "adjacencies": [
        "fogmere",
        "galecliff",
        "highwatch"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "tempest-vale",
      "name": "Tempest Vale",
      "regionId": "stormcrown",
      "shape": "M 624.0 284.0 L 624.0 285.0 L 614.0 294.0 L 612.0 299.0 L 609.0 301.0 L 601.0 301.0 L 598.0 305.0 L 598.0 317.0 L 594.0 321.0 L 594.0 326.0 L 592.0 329.0 L 593.0 341.0 L 589.0 344.0 L 578.0 344.0 L 578.0 345.0 L 577.0 345.0 L 577.0 353.0 L 580.0 360.0 L 585.0 364.0 L 586.0 367.0 L 593.0 366.0 L 610.0 366.0 L 610.0 365.0 L 623.0 364.0 L 625.0 371.0 L 628.0 372.0 L 630.0 378.0 L 637.0 382.0 L 635.0 393.0 L 640.0 400.0 L 645.0 402.0 L 646.0 406.0 L 656.0 411.0 L 658.0 411.0 L 667.0 407.0 L 675.0 407.0 L 678.0 410.0 L 685.0 414.0 L 691.0 414.0 L 699.0 409.0 L 702.0 404.0 L 709.0 400.0 L 719.0 400.0 L 724.0 402.0 L 732.0 402.0 L 736.0 398.0 L 745.0 395.0 L 751.0 395.0 L 751.0 393.0 L 752.0 388.0 L 750.0 382.0 L 749.0 382.0 L 744.0 378.0 L 739.0 370.0 L 729.0 362.0 L 725.0 362.0 L 721.0 359.0 L 720.0 356.0 L 709.0 356.0 L 706.0 355.0 L 702.0 345.0 L 697.0 344.0 L 683.0 344.0 L 677.0 339.0 L 676.0 332.0 L 671.0 330.0 L 668.0 327.0 L 668.0 318.0 L 671.0 312.0 L 671.0 306.0 L 669.0 302.0 L 661.0 302.0 L 654.0 309.0 L 653.0 312.0 L 646.0 312.0 L 641.0 306.0 L 634.0 303.0 L 635.0 289.0 L 627.0 286.0 L 626.0 284.0 Z",
      "position": {
        "x": 668.9,
        "y": 374
      },
      "badgeAnchor": {
        "x": 668.9,
        "y": 374
      },
      "adjacencies": [
        "coilhaven",
        "crownhaven",
        "ravenspire",
        "skyreach",
        "tentacle-point"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "thunderpeak",
      "name": "Thunderpeak",
      "regionId": "stormcrown",
      "shape": "M 578.0 81.0 L 575.0 83.0 L 574.0 83.0 L 574.0 98.0 L 569.0 104.0 L 569.0 114.0 L 567.0 120.0 L 562.0 123.0 L 559.0 129.0 L 559.0 136.0 L 566.0 145.0 L 572.0 149.0 L 574.0 160.0 L 577.0 163.0 L 584.0 165.0 L 589.0 165.0 L 593.0 162.0 L 603.0 160.0 L 610.0 156.0 L 612.0 151.0 L 625.0 151.0 L 627.0 152.0 L 638.0 164.0 L 646.0 165.0 L 650.0 172.0 L 649.0 181.0 L 655.0 187.0 L 660.0 194.0 L 667.0 194.0 L 672.0 198.0 L 672.0 199.0 L 680.0 199.0 L 683.0 207.0 L 686.0 209.0 L 688.0 214.0 L 691.0 217.0 L 708.0 217.0 L 711.0 214.0 L 717.0 203.0 L 725.0 203.0 L 727.0 205.0 L 733.0 204.0 L 736.0 204.0 L 738.0 200.0 L 737.0 190.0 L 731.0 187.0 L 728.0 182.0 L 725.0 180.0 L 725.0 177.0 L 728.0 173.0 L 727.0 168.0 L 722.0 166.0 L 714.0 157.0 L 713.0 153.0 L 719.0 147.0 L 729.0 147.0 L 732.0 142.0 L 732.0 137.0 L 735.0 133.0 L 741.0 130.0 L 742.0 124.0 L 740.0 120.0 L 736.0 120.0 L 731.0 117.0 L 731.0 107.0 L 725.0 103.0 L 719.0 101.0 L 719.0 99.0 L 714.0 94.0 L 714.0 84.0 L 706.0 84.0 L 698.0 87.0 L 703.0 81.0 L 704.0 76.0 L 712.0 67.0 L 712.0 64.0 L 715.0 60.0 L 716.0 52.0 L 712.0 48.0 L 698.0 48.0 L 695.0 50.0 L 695.0 55.0 L 692.0 57.0 L 685.0 57.0 L 678.0 61.0 L 677.0 64.0 L 677.0 74.0 L 673.0 79.0 L 670.0 86.0 L 663.0 86.0 L 658.0 81.0 L 649.0 81.0 L 647.0 83.0 L 645.0 76.0 L 638.0 72.0 L 634.0 66.0 L 630.0 64.0 L 610.0 64.0 L 606.0 67.0 L 605.0 73.0 L 603.0 74.0 L 602.0 67.0 L 599.0 62.0 L 595.0 60.0 L 587.0 60.0 L 583.0 63.0 L 580.0 69.0 L 580.0 79.0 Z",
      "position": {
        "x": 674.1,
        "y": 130.4
      },
      "badgeAnchor": {
        "x": 674.1,
        "y": 130.4
      },
      "adjacencies": [
        "inkwater",
        "ravenspire",
        "tentacle-point"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "abyss-gate",
      "name": "Abyss Gate",
      "regionId": "kraken-reach",
      "shape": "M 836.0 530.0 L 838.0 539.0 L 834.0 543.0 L 828.0 543.0 L 824.0 547.0 L 824.0 555.0 L 827.0 559.0 L 827.0 567.0 L 829.0 571.0 L 833.0 574.0 L 843.0 574.0 L 848.0 571.0 L 848.0 581.0 L 854.0 584.0 L 853.0 599.0 L 856.0 601.0 L 862.0 601.0 L 865.0 598.0 L 873.0 598.0 L 874.0 600.0 L 881.0 598.0 L 889.0 590.0 L 892.0 583.0 L 899.0 583.0 L 901.0 587.0 L 910.0 595.0 L 915.0 594.0 L 919.0 587.0 L 922.0 585.0 L 925.0 576.0 L 932.0 576.0 L 936.0 579.0 L 941.0 579.0 L 946.0 576.0 L 952.0 576.0 L 954.0 581.0 L 957.0 584.0 L 957.0 587.0 L 960.0 591.0 L 964.0 592.0 L 964.0 591.0 L 968.0 590.0 L 970.0 583.0 L 973.0 577.0 L 985.0 566.0 L 990.0 565.0 L 990.0 560.0 L 984.0 555.0 L 984.0 547.0 L 984.0 544.0 L 976.0 539.0 L 972.0 535.0 L 973.0 523.0 L 962.0 515.0 L 951.0 515.0 L 949.0 514.0 L 941.0 504.0 L 941.0 498.0 L 945.0 493.0 L 945.0 490.0 L 943.0 484.0 L 939.0 481.0 L 938.0 477.0 L 929.0 478.0 L 926.0 476.0 L 926.0 466.0 L 925.0 465.0 L 916.0 465.0 L 913.0 469.0 L 906.0 475.0 L 900.0 478.0 L 900.0 485.0 L 896.0 492.0 L 886.0 495.0 L 881.0 495.0 L 878.0 493.0 L 872.0 494.0 L 871.0 498.0 L 866.0 500.0 L 863.0 505.0 L 862.0 512.0 L 853.0 520.0 L 841.0 523.0 Z",
      "position": {
        "x": 900.8,
        "y": 537.9
      },
      "badgeAnchor": {
        "x": 900.8,
        "y": 537.9
      },
      "adjacencies": [
        "amberlight",
        "deepgrasp",
        "finback",
        "goldsand",
        "suckerstone"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "blackbrine",
      "name": "Blackbrine",
      "regionId": "kraken-reach",
      "shape": "M 935.0 289.0 L 933.0 289.0 L 933.0 291.0 L 928.0 295.0 L 927.0 301.0 L 928.0 305.0 L 925.0 310.0 L 917.0 317.0 L 909.0 317.0 L 906.0 321.0 L 908.0 327.0 L 904.0 338.0 L 901.0 342.0 L 896.0 344.0 L 896.0 347.0 L 899.0 349.0 L 902.0 358.0 L 907.0 362.0 L 909.0 366.0 L 909.0 375.0 L 906.0 379.0 L 906.0 387.0 L 908.0 389.0 L 906.0 393.0 L 906.0 404.0 L 914.0 407.0 L 916.0 411.0 L 920.0 414.0 L 925.0 414.0 L 928.0 412.0 L 934.0 412.0 L 937.0 418.0 L 941.0 421.0 L 952.0 418.0 L 956.0 414.0 L 956.0 410.0 L 960.0 405.0 L 971.0 405.0 L 975.0 404.0 L 977.0 407.0 L 982.0 408.0 L 983.0 412.0 L 988.0 412.0 L 993.0 411.0 L 995.0 408.0 L 996.0 402.0 L 1003.0 402.0 L 1006.0 400.0 L 1006.0 393.0 L 1009.0 389.0 L 1015.0 388.0 L 1020.0 385.0 L 1022.0 380.0 L 1030.0 375.0 L 1031.0 373.0 L 1031.0 364.0 L 1036.0 367.0 L 1045.0 368.0 L 1053.0 363.0 L 1053.0 355.0 L 1050.0 350.0 L 1053.0 346.0 L 1052.0 337.0 L 1057.0 333.0 L 1057.0 326.0 L 1046.0 320.0 L 1043.0 313.0 L 1031.0 308.0 L 1029.0 304.0 L 1024.0 301.0 L 1018.0 291.0 L 1015.0 291.0 L 1006.0 296.0 L 988.0 296.0 L 984.0 291.0 L 968.0 290.0 L 963.0 295.0 L 954.0 296.0 L 950.0 293.0 L 948.0 287.0 L 940.0 287.0 Z",
      "position": {
        "x": 971.2,
        "y": 349.3
      },
      "badgeAnchor": {
        "x": 971.2,
        "y": 349.3
      },
      "adjacencies": [
        "deepgrasp",
        "krakenhold",
        "squidmoor",
        "suckerstone"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "coilhaven",
      "name": "Coilhaven",
      "regionId": "kraken-reach",
      "shape": "M 789.0 334.0 L 782.0 337.0 L 780.0 342.0 L 775.0 343.0 L 772.0 346.0 L 772.0 355.0 L 769.0 357.0 L 762.0 358.0 L 762.0 365.0 L 760.0 369.0 L 755.0 373.0 L 754.0 378.0 L 751.0 382.0 L 750.0 382.0 L 752.0 388.0 L 751.0 393.0 L 751.0 397.0 L 752.0 400.0 L 750.0 403.0 L 750.0 411.0 L 753.0 415.0 L 753.0 419.0 L 749.0 422.0 L 734.0 431.0 L 736.0 438.0 L 736.0 443.0 L 732.0 444.0 L 730.0 447.0 L 725.0 450.0 L 724.0 455.0 L 721.0 459.0 L 720.0 464.0 L 720.0 470.0 L 723.0 472.0 L 724.0 476.0 L 728.0 479.0 L 734.0 479.0 L 739.0 476.0 L 742.0 480.0 L 749.0 482.0 L 755.0 480.0 L 756.0 476.0 L 761.0 478.0 L 760.0 488.0 L 764.0 491.0 L 770.0 490.0 L 772.0 487.0 L 778.0 489.0 L 785.0 489.0 L 789.0 486.0 L 790.0 480.0 L 797.0 475.0 L 798.0 478.0 L 807.0 482.0 L 815.0 478.0 L 818.0 474.0 L 821.0 470.0 L 821.0 461.0 L 826.0 454.0 L 835.0 448.0 L 837.0 448.0 L 845.0 440.0 L 852.0 441.0 L 856.0 446.0 L 861.0 445.0 L 861.0 437.0 L 870.0 433.0 L 871.0 431.0 L 871.0 414.0 L 863.0 407.0 L 860.0 401.0 L 858.0 401.0 L 855.0 392.0 L 852.0 390.0 L 852.0 385.0 L 846.0 379.0 L 846.0 372.0 L 848.0 369.0 L 847.0 363.0 L 845.0 360.0 L 835.0 357.0 L 830.0 349.0 L 826.0 346.0 L 821.0 346.0 L 813.0 352.0 L 808.0 352.0 L 804.0 349.0 L 796.0 340.0 L 794.0 334.0 Z",
      "position": {
        "x": 803.5,
        "y": 407
      },
      "badgeAnchor": {
        "x": 803.5,
        "y": 407
      },
      "adjacencies": [
        "crownhaven",
        "deepgrasp",
        "finback",
        "squidmoor",
        "tempest-vale",
        "tentacle-point"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "deepgrasp",
      "name": "Deepgrasp",
      "regionId": "kraken-reach",
      "shape": "M 861.0 401.0 L 860.0 401.0 L 863.0 407.0 L 871.0 414.0 L 871.0 431.0 L 870.0 433.0 L 861.0 437.0 L 861.0 445.0 L 856.0 446.0 L 852.0 441.0 L 845.0 440.0 L 837.0 448.0 L 835.0 448.0 L 826.0 454.0 L 821.0 461.0 L 821.0 470.0 L 818.0 474.0 L 816.0 483.0 L 811.0 486.0 L 808.0 490.0 L 808.0 499.0 L 813.0 502.0 L 812.0 504.0 L 807.0 505.0 L 804.0 508.0 L 803.0 514.0 L 804.0 519.0 L 810.0 523.0 L 818.0 522.0 L 824.0 527.0 L 830.0 527.0 L 833.0 530.0 L 836.0 530.0 L 841.0 523.0 L 853.0 520.0 L 862.0 512.0 L 863.0 505.0 L 866.0 500.0 L 871.0 498.0 L 872.0 494.0 L 878.0 493.0 L 881.0 495.0 L 886.0 495.0 L 896.0 492.0 L 900.0 485.0 L 900.0 478.0 L 906.0 475.0 L 913.0 469.0 L 916.0 465.0 L 925.0 465.0 L 926.0 466.0 L 926.0 476.0 L 929.0 478.0 L 938.0 477.0 L 939.0 481.0 L 943.0 484.0 L 945.0 490.0 L 945.0 492.0 L 954.0 493.0 L 959.0 490.0 L 959.0 487.0 L 963.0 481.0 L 963.0 470.0 L 966.0 467.0 L 969.0 467.0 L 973.0 460.0 L 975.0 459.0 L 978.0 453.0 L 978.0 446.0 L 971.0 440.0 L 970.0 433.0 L 973.0 432.0 L 977.0 426.0 L 975.0 417.0 L 982.0 412.0 L 983.0 412.0 L 982.0 408.0 L 977.0 407.0 L 975.0 404.0 L 971.0 405.0 L 960.0 405.0 L 956.0 410.0 L 956.0 414.0 L 952.0 418.0 L 941.0 421.0 L 937.0 418.0 L 934.0 412.0 L 928.0 412.0 L 925.0 414.0 L 920.0 414.0 L 916.0 411.0 L 914.0 407.0 L 906.0 404.0 L 906.0 393.0 L 908.0 389.0 L 906.0 387.0 L 906.0 379.0 L 909.0 375.0 L 909.0 366.0 L 907.0 362.0 L 902.0 358.0 L 899.0 349.0 L 896.0 347.0 L 896.0 345.0 L 890.0 345.0 L 886.0 349.0 L 886.0 354.0 L 883.0 358.0 L 880.0 358.0 L 874.0 362.0 L 871.0 366.0 L 871.0 395.0 Z",
      "position": {
        "x": 900.9,
        "y": 438.2
      },
      "badgeAnchor": {
        "x": 900.9,
        "y": 438.2
      },
      "adjacencies": [
        "abyss-gate",
        "blackbrine",
        "coilhaven",
        "finback",
        "squidmoor",
        "suckerstone"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "inkwater",
      "name": "Inkwater",
      "regionId": "kraken-reach",
      "shape": "M 714.0 84.0 L 714.0 94.0 L 719.0 99.0 L 719.0 101.0 L 725.0 103.0 L 731.0 107.0 L 731.0 117.0 L 736.0 120.0 L 740.0 120.0 L 742.0 124.0 L 741.0 130.0 L 735.0 133.0 L 732.0 137.0 L 732.0 142.0 L 729.0 147.0 L 719.0 147.0 L 713.0 153.0 L 714.0 157.0 L 722.0 166.0 L 727.0 168.0 L 728.0 173.0 L 725.0 177.0 L 725.0 180.0 L 728.0 182.0 L 731.0 187.0 L 737.0 190.0 L 738.0 200.0 L 736.0 204.0 L 735.0 204.0 L 736.0 209.0 L 738.0 210.0 L 741.0 219.0 L 740.0 221.0 L 729.0 230.0 L 729.0 235.0 L 737.0 240.0 L 740.0 243.0 L 740.0 256.0 L 747.0 261.0 L 753.0 261.0 L 759.0 266.0 L 768.0 269.0 L 771.0 272.0 L 776.0 272.0 L 783.0 263.0 L 792.0 263.0 L 799.0 257.0 L 805.0 257.0 L 810.0 262.0 L 818.0 262.0 L 823.0 253.0 L 827.0 250.0 L 832.0 250.0 L 838.0 253.0 L 839.0 255.0 L 845.0 255.0 L 847.0 258.0 L 855.0 262.0 L 859.0 267.0 L 860.0 273.0 L 864.0 278.0 L 869.0 278.0 L 873.0 276.0 L 876.0 272.0 L 877.0 272.0 L 876.0 264.0 L 873.0 261.0 L 873.0 256.0 L 879.0 254.0 L 884.0 249.0 L 884.0 244.0 L 880.0 241.0 L 879.0 237.0 L 874.0 230.0 L 874.0 224.0 L 879.0 220.0 L 880.0 213.0 L 885.0 206.0 L 884.0 191.0 L 889.0 184.0 L 889.0 178.0 L 887.0 171.0 L 884.0 168.0 L 884.0 164.0 L 881.0 162.0 L 875.0 162.0 L 873.0 164.0 L 866.0 161.0 L 866.0 152.0 L 863.0 148.0 L 857.0 145.0 L 839.0 145.0 L 835.0 147.0 L 830.0 154.0 L 823.0 152.0 L 820.0 153.0 L 820.0 145.0 L 824.0 136.0 L 824.0 128.0 L 818.0 123.0 L 817.0 118.0 L 823.0 112.0 L 823.0 100.0 L 818.0 96.0 L 814.0 91.0 L 812.0 86.0 L 807.0 84.0 L 790.0 84.0 L 784.0 86.0 L 781.0 90.0 L 775.0 94.0 L 763.0 94.0 L 760.0 97.0 L 743.0 97.0 L 738.0 91.0 L 732.0 90.0 L 721.0 84.0 Z",
      "position": {
        "x": 793.8,
        "y": 201.8
      },
      "badgeAnchor": {
        "x": 793.8,
        "y": 201.8
      },
      "adjacencies": [
        "krakenhold",
        "squidmoor",
        "tentacle-point",
        "thunderpeak"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "krakenhold",
      "name": "Krakenhold",
      "regionId": "kraken-reach",
      "shape": "M 889.0 184.0 L 884.0 191.0 L 885.0 206.0 L 880.0 213.0 L 879.0 220.0 L 874.0 224.0 L 874.0 230.0 L 879.0 237.0 L 880.0 241.0 L 884.0 244.0 L 884.0 249.0 L 879.0 254.0 L 873.0 256.0 L 873.0 261.0 L 876.0 264.0 L 877.0 272.0 L 880.0 272.0 L 885.0 278.0 L 896.0 282.0 L 905.0 282.0 L 916.0 278.0 L 917.0 272.0 L 928.0 272.0 L 931.0 274.0 L 931.0 284.0 L 934.0 289.0 L 935.0 289.0 L 940.0 287.0 L 948.0 287.0 L 950.0 293.0 L 954.0 296.0 L 963.0 295.0 L 968.0 290.0 L 984.0 291.0 L 988.0 296.0 L 1006.0 296.0 L 1015.0 291.0 L 1017.0 288.0 L 1020.0 288.0 L 1031.0 296.0 L 1038.0 298.0 L 1042.0 301.0 L 1047.0 302.0 L 1052.0 308.0 L 1061.0 310.0 L 1065.0 309.0 L 1065.0 302.0 L 1055.0 295.0 L 1050.0 286.0 L 1048.0 285.0 L 1047.0 280.0 L 1042.0 275.0 L 1036.0 273.0 L 1034.0 270.0 L 1028.0 267.0 L 1021.0 267.0 L 1015.0 264.0 L 1011.0 260.0 L 1011.0 256.0 L 993.0 246.0 L 989.0 246.0 L 982.0 250.0 L 982.0 245.0 L 980.0 241.0 L 970.0 236.0 L 970.0 222.0 L 962.0 214.0 L 956.0 213.0 L 953.0 210.0 L 946.0 211.0 L 946.0 206.0 L 940.0 201.0 L 947.0 192.0 L 947.0 186.0 L 942.0 181.0 L 942.0 179.0 L 937.0 176.0 L 933.0 170.0 L 927.0 165.0 L 918.0 165.0 L 914.0 168.0 L 913.0 174.0 L 908.0 172.0 L 897.0 172.0 L 892.0 177.0 L 892.0 184.0 Z",
      "position": {
        "x": 919.3,
        "y": 235.8
      },
      "badgeAnchor": {
        "x": 919.3,
        "y": 235.8
      },
      "adjacencies": [
        "blackbrine",
        "inkwater",
        "squidmoor"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "squidmoor",
      "name": "Squidmoor",
      "regionId": "kraken-reach",
      "shape": "M 776.0 272.0 L 775.0 272.0 L 777.0 275.0 L 777.0 284.0 L 778.0 284.0 L 778.0 296.0 L 771.0 301.0 L 771.0 305.0 L 779.0 310.0 L 786.0 310.0 L 794.0 313.0 L 798.0 319.0 L 798.0 326.0 L 793.0 334.0 L 794.0 334.0 L 796.0 340.0 L 804.0 349.0 L 808.0 352.0 L 813.0 352.0 L 821.0 346.0 L 826.0 346.0 L 830.0 349.0 L 835.0 357.0 L 845.0 360.0 L 847.0 363.0 L 848.0 369.0 L 846.0 372.0 L 846.0 379.0 L 852.0 385.0 L 852.0 390.0 L 855.0 392.0 L 858.0 401.0 L 861.0 401.0 L 871.0 395.0 L 871.0 366.0 L 874.0 362.0 L 880.0 358.0 L 883.0 358.0 L 886.0 354.0 L 886.0 349.0 L 890.0 345.0 L 896.0 345.0 L 896.0 344.0 L 901.0 342.0 L 904.0 338.0 L 908.0 327.0 L 906.0 321.0 L 909.0 317.0 L 917.0 317.0 L 925.0 310.0 L 928.0 305.0 L 927.0 301.0 L 928.0 295.0 L 933.0 291.0 L 933.0 289.0 L 934.0 289.0 L 931.0 284.0 L 931.0 274.0 L 928.0 272.0 L 917.0 272.0 L 916.0 278.0 L 905.0 282.0 L 896.0 282.0 L 885.0 278.0 L 880.0 272.0 L 876.0 272.0 L 873.0 276.0 L 869.0 278.0 L 864.0 278.0 L 860.0 273.0 L 859.0 267.0 L 855.0 262.0 L 847.0 258.0 L 845.0 255.0 L 839.0 255.0 L 838.0 253.0 L 832.0 250.0 L 827.0 250.0 L 823.0 253.0 L 818.0 262.0 L 810.0 262.0 L 805.0 257.0 L 799.0 257.0 L 792.0 263.0 L 783.0 263.0 Z",
      "position": {
        "x": 857.9,
        "y": 318.8
      },
      "badgeAnchor": {
        "x": 857.9,
        "y": 318.8
      },
      "adjacencies": [
        "blackbrine",
        "coilhaven",
        "deepgrasp",
        "inkwater",
        "krakenhold",
        "tentacle-point"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "suckerstone",
      "name": "Suckerstone",
      "regionId": "kraken-reach",
      "shape": "M 1031.0 373.0 L 1030.0 375.0 L 1022.0 380.0 L 1020.0 385.0 L 1015.0 388.0 L 1009.0 389.0 L 1006.0 393.0 L 1006.0 400.0 L 1003.0 402.0 L 996.0 402.0 L 995.0 408.0 L 993.0 411.0 L 988.0 412.0 L 982.0 412.0 L 975.0 417.0 L 977.0 426.0 L 973.0 432.0 L 970.0 433.0 L 971.0 440.0 L 978.0 446.0 L 978.0 453.0 L 975.0 459.0 L 973.0 460.0 L 969.0 467.0 L 966.0 467.0 L 963.0 470.0 L 963.0 481.0 L 959.0 487.0 L 959.0 490.0 L 954.0 493.0 L 945.0 492.0 L 945.0 493.0 L 941.0 498.0 L 941.0 504.0 L 949.0 514.0 L 951.0 515.0 L 962.0 515.0 L 973.0 523.0 L 972.0 535.0 L 976.0 539.0 L 984.0 544.0 L 984.0 546.0 L 985.0 545.0 L 998.0 545.0 L 1002.0 543.0 L 1013.0 543.0 L 1018.0 541.0 L 1025.0 541.0 L 1028.0 543.0 L 1038.0 543.0 L 1047.0 533.0 L 1050.0 527.0 L 1050.0 514.0 L 1053.0 510.0 L 1065.0 507.0 L 1067.0 503.0 L 1074.0 498.0 L 1082.0 489.0 L 1083.0 487.0 L 1077.0 484.0 L 1074.0 479.0 L 1071.0 477.0 L 1069.0 471.0 L 1074.0 466.0 L 1074.0 456.0 L 1071.0 450.0 L 1068.0 449.0 L 1061.0 441.0 L 1065.0 440.0 L 1068.0 437.0 L 1068.0 429.0 L 1060.0 425.0 L 1062.0 421.0 L 1067.0 421.0 L 1071.0 418.0 L 1072.0 412.0 L 1062.0 404.0 L 1060.0 404.0 L 1057.0 399.0 L 1048.0 393.0 L 1048.0 384.0 L 1047.0 378.0 L 1043.0 375.0 L 1037.0 375.0 Z",
      "position": {
        "x": 1021.1,
        "y": 474
      },
      "badgeAnchor": {
        "x": 1021.1,
        "y": 474
      },
      "adjacencies": [
        "abyss-gate",
        "blackbrine",
        "deepgrasp",
        "goldsand"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "tentacle-point",
      "name": "Tentacle Point",
      "regionId": "kraken-reach",
      "shape": "M 672.0 199.0 L 672.0 200.0 L 662.0 211.0 L 656.0 213.0 L 648.0 220.0 L 637.0 221.0 L 636.0 223.0 L 637.0 235.0 L 639.0 237.0 L 638.0 241.0 L 631.0 249.0 L 631.0 256.0 L 627.0 261.0 L 627.0 265.0 L 633.0 270.0 L 633.0 275.0 L 626.0 280.0 L 625.0 284.0 L 626.0 284.0 L 627.0 286.0 L 635.0 289.0 L 634.0 303.0 L 641.0 306.0 L 646.0 312.0 L 653.0 312.0 L 654.0 309.0 L 661.0 302.0 L 669.0 302.0 L 671.0 306.0 L 671.0 312.0 L 668.0 318.0 L 668.0 327.0 L 671.0 330.0 L 676.0 332.0 L 677.0 339.0 L 683.0 344.0 L 697.0 344.0 L 702.0 345.0 L 706.0 355.0 L 709.0 356.0 L 720.0 356.0 L 721.0 359.0 L 725.0 362.0 L 729.0 362.0 L 739.0 370.0 L 744.0 378.0 L 749.0 382.0 L 751.0 382.0 L 754.0 378.0 L 755.0 373.0 L 760.0 369.0 L 762.0 365.0 L 762.0 358.0 L 769.0 357.0 L 772.0 355.0 L 772.0 346.0 L 775.0 343.0 L 780.0 342.0 L 782.0 337.0 L 789.0 334.0 L 793.0 334.0 L 798.0 326.0 L 798.0 319.0 L 794.0 313.0 L 786.0 310.0 L 779.0 310.0 L 771.0 305.0 L 771.0 301.0 L 778.0 296.0 L 778.0 284.0 L 777.0 284.0 L 777.0 275.0 L 775.0 272.0 L 771.0 272.0 L 768.0 269.0 L 759.0 266.0 L 753.0 261.0 L 747.0 261.0 L 740.0 256.0 L 740.0 243.0 L 737.0 240.0 L 729.0 235.0 L 729.0 230.0 L 740.0 221.0 L 741.0 219.0 L 738.0 210.0 L 736.0 209.0 L 735.0 204.0 L 733.0 204.0 L 727.0 205.0 L 725.0 203.0 L 717.0 203.0 L 711.0 214.0 L 708.0 217.0 L 691.0 217.0 L 688.0 214.0 L 686.0 209.0 L 683.0 207.0 L 680.0 199.0 Z",
      "position": {
        "x": 718.8,
        "y": 300
      },
      "badgeAnchor": {
        "x": 718.8,
        "y": 300
      },
      "adjacencies": [
        "coilhaven",
        "inkwater",
        "ravenspire",
        "squidmoor",
        "tempest-vale",
        "thunderpeak"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "duskfen",
      "name": "Duskfen",
      "regionId": "mistmarch",
      "shape": "M 186.0 421.0 L 185.0 424.0 L 174.0 430.0 L 169.0 430.0 L 163.0 432.0 L 159.0 437.0 L 158.0 447.0 L 151.0 452.0 L 140.0 453.0 L 135.0 457.0 L 135.0 465.0 L 130.0 470.0 L 121.0 470.0 L 117.0 478.0 L 113.0 480.0 L 102.0 480.0 L 100.0 481.0 L 91.0 493.0 L 89.0 498.0 L 89.0 506.0 L 94.0 511.0 L 101.0 511.0 L 103.0 515.0 L 102.0 525.0 L 110.0 531.0 L 101.0 538.0 L 100.0 548.0 L 105.0 553.0 L 109.0 562.0 L 104.0 562.0 L 101.0 564.0 L 101.0 587.0 L 107.0 593.0 L 110.0 593.0 L 120.0 601.0 L 128.0 600.0 L 131.0 594.0 L 142.0 594.0 L 144.0 589.0 L 144.0 580.0 L 145.0 578.0 L 146.0 578.0 L 145.0 572.0 L 147.0 568.0 L 147.0 547.0 L 144.0 544.0 L 144.0 539.0 L 152.0 535.0 L 153.0 528.0 L 157.0 522.0 L 162.0 517.0 L 162.0 511.0 L 167.0 509.0 L 178.0 510.0 L 180.0 512.0 L 185.0 512.0 L 191.0 518.0 L 198.0 518.0 L 202.0 514.0 L 206.0 514.0 L 208.0 510.0 L 213.0 508.0 L 219.0 500.0 L 219.0 497.0 L 217.0 495.0 L 216.0 486.0 L 222.0 480.0 L 224.0 475.0 L 223.0 465.0 L 213.0 457.0 L 213.0 446.0 L 215.0 439.0 L 213.0 436.0 L 208.0 433.0 L 200.0 433.0 L 195.0 430.0 L 193.0 425.0 L 189.0 421.0 Z",
      "position": {
        "x": 181.5,
        "y": 474.1
      },
      "badgeAnchor": {
        "x": 181.5,
        "y": 474.1
      },
      "adjacencies": [
        "greyveil",
        "kelpdown",
        "shroud-hollow",
        "vaporholt",
        "weedwater"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "fogmere",
      "name": "Fogmere",
      "regionId": "mistmarch",
      "shape": "M 121.0 337.0 L 129.0 339.0 L 133.0 342.0 L 137.0 342.0 L 140.0 346.0 L 140.0 356.0 L 139.0 361.0 L 142.0 368.0 L 144.0 369.0 L 146.0 376.0 L 150.0 382.0 L 152.0 382.0 L 156.0 387.0 L 161.0 386.0 L 164.0 383.0 L 170.0 383.0 L 173.0 385.0 L 175.0 390.0 L 175.0 399.0 L 172.0 403.0 L 173.0 410.0 L 177.0 414.0 L 182.0 414.0 L 187.0 417.0 L 187.0 416.0 L 192.0 412.0 L 194.0 407.0 L 199.0 407.0 L 202.0 410.0 L 208.0 410.0 L 211.0 405.0 L 218.0 405.0 L 222.0 403.0 L 221.0 395.0 L 223.0 393.0 L 236.0 392.0 L 238.0 399.0 L 242.0 402.0 L 251.0 401.0 L 256.0 409.0 L 261.0 409.0 L 265.0 406.0 L 266.0 406.0 L 263.0 395.0 L 266.0 394.0 L 269.0 387.0 L 269.0 379.0 L 266.0 373.0 L 264.0 372.0 L 263.0 367.0 L 259.0 363.0 L 260.0 351.0 L 258.0 346.0 L 254.0 342.0 L 254.0 336.0 L 259.0 332.0 L 259.0 328.0 L 259.0 312.0 L 258.0 312.0 L 255.0 306.0 L 249.0 301.0 L 248.0 297.0 L 241.0 291.0 L 241.0 280.0 L 234.0 271.0 L 223.0 266.0 L 212.0 256.0 L 212.0 247.0 L 208.0 245.0 L 203.0 238.0 L 201.0 238.0 L 194.0 231.0 L 189.0 232.0 L 189.0 237.0 L 186.0 240.0 L 183.0 240.0 L 171.0 248.0 L 171.0 253.0 L 174.0 263.0 L 169.0 259.0 L 168.0 256.0 L 162.0 255.0 L 159.0 257.0 L 159.0 265.0 L 156.0 269.0 L 156.0 280.0 L 158.0 283.0 L 167.0 291.0 L 164.0 292.0 L 147.0 283.0 L 141.0 277.0 L 134.0 277.0 L 130.0 281.0 L 130.0 287.0 L 127.0 291.0 L 121.0 291.0 L 117.0 294.0 L 117.0 312.0 L 116.0 317.0 L 114.0 318.0 L 113.0 326.0 L 118.0 335.0 Z",
      "position": {
        "x": 198.6,
        "y": 336
      },
      "badgeAnchor": {
        "x": 198.6,
        "y": 336
      },
      "adjacencies": [
        "greyveil",
        "hazewood",
        "highwatch",
        "shroud-hollow",
        "stormhold"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "gloamridge",
      "name": "Gloamridge",
      "regionId": "mistmarch",
      "shape": "M 251.0 511.0 L 250.0 511.0 L 249.0 517.0 L 245.0 520.0 L 242.0 535.0 L 247.0 539.0 L 251.0 545.0 L 254.0 547.0 L 264.0 547.0 L 267.0 549.0 L 268.0 555.0 L 264.0 561.0 L 264.0 567.0 L 259.0 569.0 L 256.0 572.0 L 256.0 578.0 L 253.0 583.0 L 252.0 591.0 L 246.0 596.0 L 245.0 602.0 L 248.0 607.0 L 246.0 614.0 L 244.0 615.0 L 244.0 618.0 L 251.0 627.0 L 252.0 631.0 L 252.0 637.0 L 256.0 642.0 L 260.0 653.0 L 263.0 655.0 L 272.0 654.0 L 277.0 658.0 L 284.0 658.0 L 293.0 653.0 L 295.0 649.0 L 295.0 640.0 L 292.0 636.0 L 281.0 633.0 L 282.0 627.0 L 290.0 627.0 L 295.0 621.0 L 299.0 618.0 L 306.0 618.0 L 312.0 614.0 L 316.0 606.0 L 316.0 594.0 L 324.0 587.0 L 324.0 574.0 L 323.0 571.0 L 327.0 567.0 L 329.0 558.0 L 336.0 558.0 L 339.0 554.0 L 345.0 552.0 L 349.0 553.0 L 360.0 543.0 L 362.0 538.0 L 362.0 529.0 L 356.0 524.0 L 351.0 524.0 L 344.0 520.0 L 340.0 513.0 L 329.0 513.0 L 325.0 511.0 L 322.0 507.0 L 322.0 503.0 L 318.0 499.0 L 302.0 500.0 L 299.0 499.0 L 295.0 494.0 L 287.0 494.0 L 280.0 497.0 L 279.0 504.0 L 274.0 508.0 L 262.0 507.0 L 254.0 508.0 Z",
      "position": {
        "x": 300.4,
        "y": 536.6
      },
      "badgeAnchor": {
        "x": 300.4,
        "y": 536.6
      },
      "adjacencies": [
        "kelpdown",
        "shroud-hollow",
        "vaporholt"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "greyveil",
      "name": "Greyveil",
      "regionId": "mistmarch",
      "shape": "M 91.0 493.0 L 100.0 481.0 L 102.0 480.0 L 113.0 480.0 L 117.0 478.0 L 121.0 470.0 L 130.0 470.0 L 135.0 465.0 L 135.0 457.0 L 140.0 453.0 L 151.0 452.0 L 158.0 447.0 L 159.0 437.0 L 163.0 432.0 L 169.0 430.0 L 174.0 430.0 L 185.0 424.0 L 186.0 421.0 L 187.0 421.0 L 187.0 417.0 L 182.0 414.0 L 177.0 414.0 L 173.0 410.0 L 172.0 403.0 L 175.0 399.0 L 175.0 390.0 L 173.0 385.0 L 170.0 383.0 L 164.0 383.0 L 161.0 386.0 L 156.0 387.0 L 152.0 382.0 L 150.0 382.0 L 146.0 376.0 L 144.0 369.0 L 142.0 368.0 L 139.0 361.0 L 140.0 356.0 L 140.0 346.0 L 137.0 342.0 L 133.0 342.0 L 129.0 339.0 L 121.0 337.0 L 116.0 338.0 L 114.0 333.0 L 106.0 326.0 L 95.0 320.0 L 80.0 320.0 L 78.0 322.0 L 73.0 321.0 L 57.0 321.0 L 52.0 320.0 L 49.0 323.0 L 49.0 328.0 L 51.0 330.0 L 51.0 338.0 L 55.0 342.0 L 55.0 346.0 L 64.0 358.0 L 64.0 360.0 L 58.0 360.0 L 54.0 362.0 L 51.0 367.0 L 35.0 367.0 L 31.0 370.0 L 31.0 381.0 L 35.0 386.0 L 32.0 386.0 L 28.0 389.0 L 27.0 396.0 L 28.0 400.0 L 38.0 404.0 L 39.0 406.0 L 46.0 408.0 L 44.0 413.0 L 44.0 420.0 L 54.0 426.0 L 59.0 427.0 L 58.0 440.0 L 59.0 443.0 L 64.0 446.0 L 64.0 449.0 L 58.0 451.0 L 54.0 458.0 L 54.0 468.0 L 56.0 474.0 L 65.0 478.0 L 69.0 485.0 L 78.0 486.0 L 81.0 491.0 L 85.0 493.0 Z",
      "position": {
        "x": 108,
        "y": 411.6
      },
      "badgeAnchor": {
        "x": 108,
        "y": 411.6
      },
      "adjacencies": [
        "duskfen",
        "fogmere"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "hazewood",
      "name": "Hazewood",
      "regionId": "mistmarch",
      "shape": "M 259.0 331.0 L 259.0 332.0 L 254.0 336.0 L 254.0 342.0 L 258.0 346.0 L 260.0 351.0 L 259.0 363.0 L 263.0 367.0 L 264.0 372.0 L 266.0 373.0 L 269.0 379.0 L 269.0 387.0 L 266.0 394.0 L 263.0 395.0 L 266.0 406.0 L 267.0 406.0 L 271.0 411.0 L 272.0 419.0 L 278.0 423.0 L 282.0 424.0 L 286.0 429.0 L 291.0 430.0 L 297.0 438.0 L 296.0 450.0 L 299.0 453.0 L 299.0 456.0 L 304.0 462.0 L 315.0 462.0 L 323.0 458.0 L 332.0 458.0 L 336.0 452.0 L 336.0 449.0 L 340.0 446.0 L 342.0 447.0 L 355.0 447.0 L 360.0 449.0 L 365.0 454.0 L 365.0 455.0 L 374.0 454.0 L 381.0 458.0 L 387.0 457.0 L 391.0 454.0 L 397.0 454.0 L 399.0 456.0 L 404.0 456.0 L 404.0 454.0 L 409.0 447.0 L 418.0 447.0 L 427.0 444.0 L 428.0 436.0 L 436.0 432.0 L 436.0 426.0 L 430.0 419.0 L 430.0 409.0 L 431.0 409.0 L 430.0 398.0 L 429.0 398.0 L 426.0 393.0 L 422.0 392.0 L 418.0 388.0 L 409.0 384.0 L 405.0 377.0 L 405.0 374.0 L 402.0 371.0 L 402.0 363.0 L 399.0 357.0 L 391.0 349.0 L 390.0 345.0 L 386.0 342.0 L 386.0 341.0 L 380.0 341.0 L 377.0 344.0 L 371.0 347.0 L 361.0 347.0 L 358.0 354.0 L 343.0 349.0 L 338.0 343.0 L 336.0 343.0 L 332.0 337.0 L 323.0 337.0 L 320.0 336.0 L 317.0 332.0 L 310.0 328.0 L 303.0 328.0 L 298.0 334.0 L 288.0 335.0 L 286.0 341.0 L 280.0 341.0 L 272.0 336.0 Z",
      "position": {
        "x": 328.6,
        "y": 397.1
      },
      "badgeAnchor": {
        "x": 328.6,
        "y": 397.1
      },
      "adjacencies": [
        "cloudbreak",
        "fogmere",
        "highwatch",
        "lightning-ford",
        "shroud-hollow"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "shroud-hollow",
      "name": "Shroud Hollow",
      "regionId": "mistmarch",
      "shape": "M 187.0 416.0 L 187.0 421.0 L 189.0 421.0 L 193.0 425.0 L 195.0 430.0 L 200.0 433.0 L 208.0 433.0 L 213.0 436.0 L 215.0 439.0 L 213.0 446.0 L 213.0 457.0 L 223.0 465.0 L 224.0 475.0 L 222.0 480.0 L 216.0 486.0 L 217.0 495.0 L 219.0 497.0 L 219.0 499.0 L 222.0 500.0 L 233.0 500.0 L 239.0 503.0 L 243.0 508.0 L 248.0 511.0 L 251.0 511.0 L 254.0 508.0 L 262.0 507.0 L 274.0 508.0 L 279.0 504.0 L 280.0 497.0 L 287.0 494.0 L 295.0 494.0 L 299.0 499.0 L 302.0 500.0 L 318.0 499.0 L 322.0 503.0 L 322.0 507.0 L 325.0 511.0 L 329.0 513.0 L 340.0 513.0 L 344.0 520.0 L 351.0 524.0 L 356.0 524.0 L 362.0 529.0 L 369.0 536.0 L 369.0 539.0 L 373.0 541.0 L 382.0 541.0 L 392.0 535.0 L 395.0 530.0 L 395.0 518.0 L 393.0 513.0 L 389.0 508.0 L 389.0 498.0 L 383.0 491.0 L 375.0 487.0 L 371.0 479.0 L 368.0 477.0 L 364.0 471.0 L 362.0 471.0 L 361.0 465.0 L 365.0 458.0 L 365.0 454.0 L 360.0 449.0 L 355.0 447.0 L 342.0 447.0 L 340.0 446.0 L 336.0 449.0 L 336.0 452.0 L 332.0 458.0 L 323.0 458.0 L 315.0 462.0 L 304.0 462.0 L 299.0 456.0 L 299.0 453.0 L 296.0 450.0 L 297.0 438.0 L 291.0 430.0 L 286.0 429.0 L 282.0 424.0 L 278.0 423.0 L 272.0 419.0 L 271.0 411.0 L 267.0 406.0 L 265.0 406.0 L 261.0 409.0 L 256.0 409.0 L 251.0 401.0 L 242.0 402.0 L 238.0 399.0 L 236.0 392.0 L 223.0 393.0 L 221.0 395.0 L 222.0 403.0 L 218.0 405.0 L 211.0 405.0 L 208.0 410.0 L 202.0 410.0 L 199.0 407.0 L 194.0 407.0 L 192.0 412.0 Z",
      "position": {
        "x": 260.9,
        "y": 464.1
      },
      "badgeAnchor": {
        "x": 260.9,
        "y": 464.1
      },
      "adjacencies": [
        "duskfen",
        "fogmere",
        "gloamridge",
        "hazewood",
        "lightning-ford",
        "vaporholt"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "vaporholt",
      "name": "Vaporholt",
      "regionId": "mistmarch",
      "shape": "M 219.0 499.0 L 219.0 500.0 L 213.0 508.0 L 208.0 510.0 L 206.0 514.0 L 202.0 514.0 L 198.0 518.0 L 191.0 518.0 L 185.0 512.0 L 180.0 512.0 L 178.0 510.0 L 167.0 509.0 L 162.0 511.0 L 162.0 517.0 L 157.0 522.0 L 153.0 528.0 L 152.0 535.0 L 144.0 539.0 L 144.0 544.0 L 147.0 547.0 L 147.0 568.0 L 145.0 572.0 L 146.0 578.0 L 148.0 578.0 L 150.0 579.0 L 158.0 593.0 L 161.0 597.0 L 166.0 598.0 L 171.0 593.0 L 177.0 593.0 L 192.0 609.0 L 197.0 617.0 L 206.0 618.0 L 209.0 616.0 L 218.0 616.0 L 221.0 619.0 L 226.0 619.0 L 230.0 615.0 L 242.0 615.0 L 244.0 616.0 L 244.0 615.0 L 246.0 614.0 L 248.0 607.0 L 245.0 602.0 L 246.0 596.0 L 252.0 591.0 L 253.0 583.0 L 256.0 578.0 L 256.0 572.0 L 259.0 569.0 L 264.0 567.0 L 264.0 561.0 L 268.0 555.0 L 267.0 549.0 L 264.0 547.0 L 254.0 547.0 L 251.0 545.0 L 247.0 539.0 L 242.0 535.0 L 245.0 520.0 L 249.0 517.0 L 250.0 511.0 L 248.0 511.0 L 243.0 508.0 L 239.0 503.0 L 233.0 500.0 L 222.0 500.0 Z",
      "position": {
        "x": 207.2,
        "y": 561.2
      },
      "badgeAnchor": {
        "x": 207.2,
        "y": 561.2
      },
      "adjacencies": [
        "duskfen",
        "gloamridge",
        "kelpdown",
        "shroud-hollow"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "fernshallow",
      "name": "Fernshallow",
      "regionId": "kelpwold",
      "shape": "M 105.0 866.0 L 108.0 864.0 L 114.0 864.0 L 119.0 866.0 L 127.0 874.0 L 128.0 878.0 L 135.0 884.0 L 141.0 886.0 L 144.0 890.0 L 148.0 892.0 L 155.0 892.0 L 157.0 885.0 L 159.0 883.0 L 172.0 883.0 L 179.0 890.0 L 186.0 891.0 L 191.0 888.0 L 193.0 884.0 L 201.0 884.0 L 204.0 877.0 L 204.0 864.0 L 210.0 860.0 L 213.0 860.0 L 216.0 857.0 L 223.0 856.0 L 225.0 851.0 L 216.0 841.0 L 216.0 838.0 L 213.0 835.0 L 213.0 831.0 L 223.0 826.0 L 226.0 823.0 L 226.0 814.0 L 220.0 812.0 L 212.0 812.0 L 204.0 805.0 L 199.0 805.0 L 195.0 808.0 L 189.0 807.0 L 185.0 803.0 L 177.0 804.0 L 177.0 805.0 L 169.0 816.0 L 159.0 817.0 L 153.0 824.0 L 149.0 832.0 L 145.0 832.0 L 143.0 829.0 L 133.0 830.0 L 132.0 822.0 L 129.0 816.0 L 129.0 807.0 L 127.0 804.0 L 119.0 800.0 L 117.0 797.0 L 101.0 797.0 L 101.0 796.0 L 86.0 796.0 L 83.0 801.0 L 83.0 808.0 L 78.0 806.0 L 71.0 806.0 L 68.0 808.0 L 68.0 814.0 L 49.0 819.0 L 42.0 824.0 L 42.0 829.0 L 40.0 833.0 L 40.0 845.0 L 42.0 849.0 L 48.0 854.0 L 58.0 854.0 L 67.0 862.0 L 79.0 862.0 L 86.0 859.0 L 94.0 860.0 L 97.0 863.0 L 100.0 863.0 L 102.0 866.0 Z",
      "position": {
        "x": 174.8,
        "y": 850.9
      },
      "badgeAnchor": {
        "x": 174.8,
        "y": 850.9
      },
      "adjacencies": [
        "greenmarsh",
        "mossbank",
        "scalecrest",
        "seagrass-lea"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "greenmarsh",
      "name": "Greenmarsh",
      "regionId": "kelpwold",
      "shape": "M 226.0 815.0 L 226.0 823.0 L 223.0 826.0 L 213.0 831.0 L 213.0 835.0 L 216.0 838.0 L 216.0 841.0 L 225.0 851.0 L 223.0 856.0 L 216.0 857.0 L 213.0 860.0 L 210.0 860.0 L 204.0 864.0 L 204.0 877.0 L 201.0 884.0 L 200.0 884.0 L 208.0 894.0 L 220.0 905.0 L 233.0 908.0 L 239.0 905.0 L 240.0 903.0 L 248.0 903.0 L 257.0 908.0 L 261.0 914.0 L 262.0 919.0 L 265.0 922.0 L 273.0 923.0 L 278.0 927.0 L 283.0 928.0 L 283.0 927.0 L 285.0 927.0 L 291.0 920.0 L 296.0 918.0 L 306.0 919.0 L 314.0 916.0 L 316.0 916.0 L 311.0 909.0 L 311.0 905.0 L 306.0 900.0 L 300.0 899.0 L 300.0 888.0 L 291.0 883.0 L 285.0 876.0 L 280.0 872.0 L 284.0 871.0 L 288.0 866.0 L 294.0 864.0 L 298.0 855.0 L 294.0 850.0 L 287.0 848.0 L 285.0 844.0 L 288.0 841.0 L 288.0 832.0 L 290.0 830.0 L 290.0 819.0 L 287.0 813.0 L 283.0 810.0 L 271.0 810.0 L 265.0 804.0 L 262.0 804.0 L 255.0 808.0 L 254.0 812.0 L 245.0 817.0 L 238.0 812.0 L 232.0 812.0 Z",
      "position": {
        "x": 255.6,
        "y": 852.9
      },
      "badgeAnchor": {
        "x": 255.6,
        "y": 852.9
      },
      "adjacencies": [
        "driftspire",
        "fangmouth",
        "fernshallow",
        "mossbank",
        "scalecrest"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "kelpdown",
      "name": "Kelpdown",
      "regionId": "kelpwold",
      "shape": "M 145.0 578.0 L 144.0 580.0 L 144.0 589.0 L 142.0 594.0 L 143.0 594.0 L 146.0 599.0 L 146.0 609.0 L 144.0 612.0 L 144.0 617.0 L 146.0 620.0 L 146.0 628.0 L 142.0 632.0 L 142.0 636.0 L 139.0 640.0 L 130.0 640.0 L 128.0 642.0 L 128.0 647.0 L 132.0 649.0 L 136.0 657.0 L 144.0 662.0 L 151.0 662.0 L 155.0 667.0 L 161.0 671.0 L 174.0 671.0 L 178.0 677.0 L 179.0 682.0 L 177.0 687.0 L 172.0 693.0 L 169.0 694.0 L 155.0 694.0 L 154.0 692.0 L 148.0 693.0 L 148.0 706.0 L 146.0 708.0 L 146.0 715.0 L 136.0 724.0 L 136.0 726.0 L 143.0 732.0 L 145.0 739.0 L 152.0 744.0 L 161.0 745.0 L 161.0 744.0 L 164.0 742.0 L 175.0 738.0 L 187.0 738.0 L 192.0 736.0 L 194.0 733.0 L 210.0 735.0 L 214.0 732.0 L 215.0 726.0 L 224.0 721.0 L 236.0 721.0 L 240.0 719.0 L 245.0 712.0 L 251.0 707.0 L 259.0 705.0 L 266.0 698.0 L 266.0 692.0 L 273.0 692.0 L 278.0 687.0 L 278.0 679.0 L 280.0 677.0 L 285.0 677.0 L 290.0 673.0 L 290.0 665.0 L 287.0 663.0 L 279.0 664.0 L 259.0 664.0 L 256.0 666.0 L 247.0 665.0 L 244.0 662.0 L 248.0 654.0 L 247.0 643.0 L 252.0 639.0 L 252.0 631.0 L 251.0 627.0 L 244.0 618.0 L 244.0 616.0 L 242.0 615.0 L 230.0 615.0 L 226.0 619.0 L 221.0 619.0 L 218.0 616.0 L 209.0 616.0 L 206.0 618.0 L 197.0 617.0 L 192.0 609.0 L 177.0 593.0 L 171.0 593.0 L 166.0 598.0 L 161.0 597.0 L 158.0 593.0 L 150.0 579.0 L 148.0 578.0 Z",
      "position": {
        "x": 207.7,
        "y": 655
      },
      "badgeAnchor": {
        "x": 207.7,
        "y": 655
      },
      "adjacencies": [
        "duskfen",
        "gloamridge",
        "mossbank",
        "seagrass-lea",
        "vaporholt",
        "weedwater"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "mossbank",
      "name": "Mossbank",
      "regionId": "kelpwold",
      "shape": "M 161.0 744.0 L 161.0 749.0 L 161.0 758.0 L 165.0 762.0 L 171.0 763.0 L 176.0 768.0 L 176.0 776.0 L 172.0 782.0 L 172.0 788.0 L 177.0 796.0 L 177.0 804.0 L 185.0 803.0 L 189.0 807.0 L 195.0 808.0 L 199.0 805.0 L 204.0 805.0 L 212.0 812.0 L 220.0 812.0 L 226.0 814.0 L 226.0 815.0 L 232.0 812.0 L 238.0 812.0 L 245.0 817.0 L 254.0 812.0 L 255.0 808.0 L 262.0 804.0 L 265.0 804.0 L 265.0 789.0 L 268.0 786.0 L 268.0 777.0 L 267.0 772.0 L 276.0 773.0 L 280.0 770.0 L 280.0 759.0 L 279.0 756.0 L 269.0 747.0 L 272.0 744.0 L 272.0 735.0 L 263.0 728.0 L 260.0 724.0 L 260.0 708.0 L 259.0 705.0 L 251.0 707.0 L 245.0 712.0 L 240.0 719.0 L 236.0 721.0 L 224.0 721.0 L 215.0 726.0 L 214.0 732.0 L 210.0 735.0 L 194.0 733.0 L 192.0 736.0 L 187.0 738.0 L 175.0 738.0 L 164.0 742.0 Z",
      "position": {
        "x": 226.5,
        "y": 771.7
      },
      "badgeAnchor": {
        "x": 226.5,
        "y": 771.7
      },
      "adjacencies": [
        "fernshallow",
        "greenmarsh",
        "kelpdown",
        "seagrass-lea"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "seagrass-lea",
      "name": "Seagrass Lea",
      "regionId": "kelpwold",
      "shape": "M 101.0 796.0 L 101.0 797.0 L 117.0 797.0 L 119.0 800.0 L 127.0 804.0 L 129.0 807.0 L 129.0 816.0 L 132.0 822.0 L 133.0 830.0 L 143.0 829.0 L 145.0 832.0 L 149.0 832.0 L 153.0 824.0 L 159.0 817.0 L 169.0 816.0 L 177.0 805.0 L 177.0 796.0 L 172.0 788.0 L 172.0 782.0 L 176.0 776.0 L 176.0 768.0 L 171.0 763.0 L 165.0 762.0 L 161.0 758.0 L 161.0 749.0 L 161.0 745.0 L 152.0 744.0 L 145.0 739.0 L 143.0 732.0 L 136.0 726.0 L 136.0 725.0 L 134.0 725.0 L 129.0 720.0 L 119.0 722.0 L 116.0 719.0 L 104.0 719.0 L 98.0 712.0 L 91.0 708.0 L 82.0 708.0 L 82.0 709.0 L 71.0 709.0 L 64.0 704.0 L 56.0 704.0 L 47.0 699.0 L 40.0 699.0 L 34.0 703.0 L 34.0 709.0 L 32.0 711.0 L 32.0 722.0 L 36.0 725.0 L 43.0 725.0 L 43.0 728.0 L 46.0 729.0 L 47.0 733.0 L 52.0 735.0 L 55.0 741.0 L 63.0 747.0 L 62.0 755.0 L 58.0 763.0 L 58.0 772.0 L 61.0 774.0 L 70.0 773.0 L 71.0 782.0 L 79.0 786.0 L 84.0 790.0 L 88.0 796.0 Z",
      "position": {
        "x": 105.3,
        "y": 757.9
      },
      "badgeAnchor": {
        "x": 105.3,
        "y": 757.9
      },
      "adjacencies": [
        "fernshallow",
        "kelpdown",
        "mossbank",
        "weedwater"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "weedwater",
      "name": "Weedwater",
      "regionId": "kelpwold",
      "shape": "M 47.0 699.0 L 56.0 704.0 L 64.0 704.0 L 71.0 709.0 L 82.0 709.0 L 82.0 708.0 L 91.0 708.0 L 98.0 712.0 L 104.0 719.0 L 116.0 719.0 L 119.0 722.0 L 129.0 720.0 L 134.0 725.0 L 136.0 725.0 L 136.0 724.0 L 146.0 715.0 L 146.0 708.0 L 148.0 706.0 L 148.0 693.0 L 154.0 692.0 L 155.0 694.0 L 169.0 694.0 L 172.0 693.0 L 177.0 687.0 L 179.0 682.0 L 178.0 677.0 L 174.0 671.0 L 161.0 671.0 L 155.0 667.0 L 151.0 662.0 L 144.0 662.0 L 136.0 657.0 L 132.0 649.0 L 128.0 647.0 L 128.0 642.0 L 130.0 640.0 L 139.0 640.0 L 142.0 636.0 L 142.0 632.0 L 146.0 628.0 L 146.0 620.0 L 144.0 617.0 L 144.0 612.0 L 146.0 609.0 L 146.0 599.0 L 143.0 594.0 L 131.0 594.0 L 128.0 600.0 L 120.0 601.0 L 110.0 593.0 L 104.0 596.0 L 95.0 596.0 L 91.0 600.0 L 87.0 600.0 L 84.0 603.0 L 76.0 604.0 L 74.0 601.0 L 71.0 590.0 L 68.0 588.0 L 61.0 589.0 L 59.0 595.0 L 55.0 596.0 L 50.0 600.0 L 49.0 603.0 L 43.0 603.0 L 36.0 607.0 L 32.0 612.0 L 32.0 622.0 L 34.0 626.0 L 31.0 629.0 L 31.0 645.0 L 34.0 649.0 L 41.0 651.0 L 41.0 655.0 L 38.0 658.0 L 38.0 669.0 L 35.0 671.0 L 35.0 679.0 L 37.0 681.0 L 37.0 690.0 L 40.0 695.0 L 47.0 696.0 Z",
      "position": {
        "x": 85.6,
        "y": 662.6
      },
      "badgeAnchor": {
        "x": 85.6,
        "y": 662.6
      },
      "adjacencies": [
        "duskfen",
        "kelpdown",
        "seagrass-lea"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "amberlight",
      "name": "Amberlight",
      "regionId": "amberstrand",
      "shape": "M 874.0 600.0 L 872.0 606.0 L 872.0 617.0 L 874.0 622.0 L 874.0 627.0 L 876.0 631.0 L 882.0 635.0 L 882.0 642.0 L 886.0 646.0 L 893.0 646.0 L 894.0 657.0 L 898.0 660.0 L 903.0 660.0 L 896.0 666.0 L 896.0 674.0 L 898.0 678.0 L 907.0 685.0 L 915.0 686.0 L 916.0 692.0 L 920.0 698.0 L 928.0 702.0 L 928.0 705.0 L 922.0 703.0 L 917.0 709.0 L 918.0 716.0 L 926.0 720.0 L 932.0 725.0 L 948.0 725.0 L 951.0 726.0 L 954.0 733.0 L 959.0 736.0 L 959.0 747.0 L 962.0 752.0 L 967.0 752.0 L 975.0 748.0 L 977.0 744.0 L 977.0 735.0 L 983.0 726.0 L 983.0 718.0 L 985.0 715.0 L 986.0 715.0 L 986.0 703.0 L 990.0 700.0 L 996.0 698.0 L 997.0 688.0 L 1000.0 685.0 L 1006.0 684.0 L 1011.0 678.0 L 1013.0 672.0 L 1012.0 672.0 L 1007.0 668.0 L 1002.0 662.0 L 1002.0 654.0 L 998.0 650.0 L 995.0 644.0 L 992.0 643.0 L 971.0 643.0 L 970.0 635.0 L 972.0 635.0 L 977.0 628.0 L 977.0 623.0 L 969.0 617.0 L 968.0 610.0 L 966.0 608.0 L 966.0 599.0 L 964.0 596.0 L 964.0 592.0 L 960.0 591.0 L 957.0 587.0 L 957.0 584.0 L 954.0 581.0 L 952.0 576.0 L 946.0 576.0 L 941.0 579.0 L 936.0 579.0 L 932.0 576.0 L 925.0 576.0 L 922.0 585.0 L 919.0 587.0 L 915.0 594.0 L 910.0 595.0 L 901.0 587.0 L 899.0 583.0 L 892.0 583.0 L 889.0 590.0 L 881.0 598.0 Z",
      "position": {
        "x": 930.5,
        "y": 630.7
      },
      "badgeAnchor": {
        "x": 930.5,
        "y": 630.7
      },
      "adjacencies": [
        "abyss-gate",
        "dune-harbour",
        "goldsand",
        "honeycove",
        "sunreef"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "dune-harbour",
      "name": "Dune Harbour",
      "regionId": "amberstrand",
      "shape": "M 839.0 852.0 L 845.0 857.0 L 847.0 862.0 L 850.0 864.0 L 856.0 865.0 L 858.0 870.0 L 866.0 876.0 L 875.0 877.0 L 877.0 875.0 L 881.0 876.0 L 883.0 879.0 L 887.0 880.0 L 887.0 879.0 L 890.0 877.0 L 890.0 873.0 L 893.0 868.0 L 893.0 855.0 L 894.0 851.0 L 898.0 846.0 L 899.0 839.0 L 903.0 832.0 L 909.0 831.0 L 919.0 835.0 L 919.0 833.0 L 922.0 830.0 L 927.0 830.0 L 930.0 828.0 L 937.0 828.0 L 945.0 825.0 L 950.0 820.0 L 950.0 815.0 L 954.0 812.0 L 958.0 812.0 L 966.0 824.0 L 971.0 828.0 L 982.0 814.0 L 984.0 810.0 L 990.0 807.0 L 991.0 802.0 L 988.0 800.0 L 980.0 789.0 L 978.0 783.0 L 974.0 780.0 L 963.0 781.0 L 958.0 778.0 L 958.0 771.0 L 961.0 768.0 L 963.0 759.0 L 963.0 752.0 L 962.0 752.0 L 959.0 747.0 L 959.0 736.0 L 954.0 733.0 L 951.0 726.0 L 948.0 725.0 L 932.0 725.0 L 926.0 720.0 L 918.0 716.0 L 917.0 709.0 L 922.0 703.0 L 922.0 701.0 L 909.0 693.0 L 898.0 694.0 L 894.0 698.0 L 894.0 710.0 L 891.0 714.0 L 891.0 728.0 L 895.0 731.0 L 901.0 733.0 L 904.0 737.0 L 897.0 740.0 L 894.0 745.0 L 894.0 761.0 L 882.0 765.0 L 875.0 771.0 L 875.0 781.0 L 880.0 785.0 L 884.0 790.0 L 887.0 802.0 L 884.0 800.0 L 873.0 800.0 L 869.0 803.0 L 867.0 811.0 L 862.0 808.0 L 856.0 808.0 L 851.0 810.0 L 849.0 806.0 L 845.0 803.0 L 844.0 798.0 L 840.0 795.0 L 827.0 795.0 L 824.0 797.0 L 824.0 810.0 L 827.0 811.0 L 827.0 832.0 L 829.0 835.0 L 837.0 842.0 L 840.0 843.0 L 839.0 850.0 Z",
      "position": {
        "x": 922.5,
        "y": 789.8
      },
      "badgeAnchor": {
        "x": 922.5,
        "y": 789.8
      },
      "adjacencies": [
        "amberlight",
        "coralgate",
        "honeycove",
        "lantern-key",
        "tridentfall"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "goldsand",
      "name": "Goldsand",
      "regionId": "amberstrand",
      "shape": "M 1082.0 489.0 L 1074.0 498.0 L 1067.0 503.0 L 1065.0 507.0 L 1053.0 510.0 L 1050.0 514.0 L 1050.0 527.0 L 1047.0 533.0 L 1038.0 543.0 L 1028.0 543.0 L 1025.0 541.0 L 1018.0 541.0 L 1013.0 543.0 L 1002.0 543.0 L 998.0 545.0 L 985.0 545.0 L 984.0 546.0 L 984.0 547.0 L 984.0 555.0 L 990.0 560.0 L 990.0 565.0 L 985.0 566.0 L 973.0 577.0 L 970.0 583.0 L 968.0 590.0 L 964.0 591.0 L 964.0 596.0 L 966.0 599.0 L 966.0 608.0 L 968.0 610.0 L 969.0 617.0 L 977.0 623.0 L 977.0 628.0 L 972.0 635.0 L 970.0 635.0 L 971.0 643.0 L 992.0 643.0 L 995.0 644.0 L 998.0 650.0 L 1002.0 654.0 L 1002.0 662.0 L 1007.0 668.0 L 1012.0 672.0 L 1015.0 672.0 L 1021.0 668.0 L 1024.0 664.0 L 1032.0 660.0 L 1032.0 658.0 L 1038.0 653.0 L 1038.0 639.0 L 1045.0 633.0 L 1045.0 631.0 L 1053.0 623.0 L 1069.0 623.0 L 1072.0 620.0 L 1078.0 619.0 L 1077.0 608.0 L 1073.0 604.0 L 1073.0 601.0 L 1077.0 598.0 L 1078.0 587.0 L 1081.0 581.0 L 1081.0 578.0 L 1085.0 576.0 L 1086.0 572.0 L 1084.0 570.0 L 1084.0 563.0 L 1087.0 561.0 L 1088.0 556.0 L 1097.0 549.0 L 1103.0 549.0 L 1107.0 546.0 L 1111.0 546.0 L 1119.0 542.0 L 1121.0 535.0 L 1125.0 533.0 L 1132.0 532.0 L 1138.0 529.0 L 1141.0 526.0 L 1135.0 520.0 L 1120.0 520.0 L 1118.0 517.0 L 1118.0 507.0 L 1117.0 505.0 L 1110.0 501.0 L 1104.0 495.0 L 1103.0 490.0 L 1099.0 488.0 L 1094.0 488.0 L 1092.0 490.0 Z",
      "position": {
        "x": 1028.4,
        "y": 586.8
      },
      "badgeAnchor": {
        "x": 1028.4,
        "y": 586.8
      },
      "adjacencies": [
        "abyss-gate",
        "amberlight",
        "saffron-cape",
        "suckerstone",
        "sunreef"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "honeycove",
      "name": "Honeycove",
      "regionId": "amberstrand",
      "shape": "M 985.0 715.0 L 983.0 718.0 L 983.0 726.0 L 977.0 735.0 L 977.0 744.0 L 975.0 748.0 L 967.0 752.0 L 963.0 752.0 L 963.0 759.0 L 961.0 768.0 L 958.0 771.0 L 958.0 778.0 L 963.0 781.0 L 974.0 780.0 L 978.0 783.0 L 980.0 789.0 L 988.0 800.0 L 991.0 802.0 L 990.0 807.0 L 984.0 810.0 L 982.0 814.0 L 971.0 828.0 L 966.0 824.0 L 958.0 812.0 L 954.0 812.0 L 950.0 815.0 L 950.0 820.0 L 945.0 825.0 L 937.0 828.0 L 930.0 828.0 L 927.0 830.0 L 922.0 830.0 L 919.0 833.0 L 919.0 836.0 L 930.0 840.0 L 934.0 844.0 L 934.0 849.0 L 931.0 852.0 L 931.0 866.0 L 938.0 871.0 L 937.0 880.0 L 944.0 882.0 L 948.0 886.0 L 948.0 896.0 L 956.0 904.0 L 957.0 908.0 L 951.0 913.0 L 951.0 921.0 L 954.0 923.0 L 956.0 929.0 L 962.0 935.0 L 962.0 933.0 L 971.0 933.0 L 978.0 930.0 L 980.0 927.0 L 984.0 927.0 L 994.0 921.0 L 996.0 921.0 L 1002.0 910.0 L 1007.0 909.0 L 1013.0 902.0 L 1013.0 897.0 L 1011.0 891.0 L 1022.0 891.0 L 1026.0 888.0 L 1026.0 880.0 L 1024.0 876.0 L 1032.0 873.0 L 1039.0 866.0 L 1039.0 854.0 L 1046.0 851.0 L 1047.0 849.0 L 1052.0 849.0 L 1056.0 847.0 L 1056.0 837.0 L 1050.0 833.0 L 1049.0 824.0 L 1050.0 821.0 L 1053.0 821.0 L 1057.0 824.0 L 1064.0 824.0 L 1068.0 820.0 L 1068.0 814.0 L 1073.0 814.0 L 1076.0 811.0 L 1076.0 802.0 L 1070.0 796.0 L 1070.0 782.0 L 1068.0 777.0 L 1063.0 774.0 L 1059.0 769.0 L 1049.0 769.0 L 1043.0 771.0 L 1039.0 766.0 L 1034.0 757.0 L 1034.0 755.0 L 1028.0 752.0 L 1022.0 740.0 L 1017.0 736.0 L 1017.0 734.0 L 1011.0 729.0 L 996.0 724.0 L 992.0 721.0 L 990.0 715.0 Z",
      "position": {
        "x": 981.4,
        "y": 865.6
      },
      "badgeAnchor": {
        "x": 981.4,
        "y": 865.6
      },
      "adjacencies": [
        "amberlight",
        "coralgate",
        "dune-harbour",
        "sunreef"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "saffron-cape",
      "name": "Saffron Cape",
      "regionId": "amberstrand",
      "shape": "M 1078.0 619.0 L 1077.0 608.0 L 1073.0 604.0 L 1073.0 601.0 L 1077.0 598.0 L 1078.0 587.0 L 1081.0 581.0 L 1081.0 578.0 L 1085.0 576.0 L 1086.0 572.0 L 1084.0 570.0 L 1084.0 563.0 L 1087.0 561.0 L 1088.0 556.0 L 1097.0 549.0 L 1103.0 549.0 L 1107.0 546.0 L 1111.0 546.0 L 1119.0 542.0 L 1121.0 535.0 L 1125.0 533.0 L 1132.0 532.0 L 1138.0 529.0 L 1141.0 526.0 L 1144.0 527.0 L 1144.0 535.0 L 1150.0 535.0 L 1154.0 537.0 L 1156.0 541.0 L 1156.0 555.0 L 1163.0 556.0 L 1167.0 561.0 L 1172.0 565.0 L 1173.0 568.0 L 1173.0 578.0 L 1178.0 580.0 L 1180.0 583.0 L 1180.0 596.0 L 1182.0 597.0 L 1185.0 609.0 L 1185.0 624.0 L 1189.0 631.0 L 1189.0 637.0 L 1184.0 640.0 L 1174.0 640.0 L 1175.0 648.0 L 1180.0 648.0 L 1184.0 651.0 L 1184.0 659.0 L 1181.0 664.0 L 1181.0 675.0 L 1176.0 684.0 L 1171.0 686.0 L 1171.0 703.0 L 1169.0 709.0 L 1165.0 712.0 L 1163.0 717.0 L 1157.0 720.0 L 1151.0 725.0 L 1149.0 731.0 L 1146.0 733.0 L 1140.0 733.0 L 1135.0 730.0 L 1135.0 734.0 L 1131.0 740.0 L 1131.0 746.0 L 1126.0 750.0 L 1117.0 745.0 L 1117.0 743.0 L 1111.0 736.0 L 1110.0 731.0 L 1107.0 725.0 L 1107.0 713.0 L 1109.0 707.0 L 1112.0 704.0 L 1116.0 703.0 L 1111.0 690.0 L 1104.0 684.0 L 1104.0 665.0 L 1103.0 660.0 L 1107.0 658.0 L 1110.0 651.0 L 1110.0 645.0 L 1112.0 641.0 L 1118.0 638.0 L 1122.0 639.0 L 1128.0 638.0 L 1118.0 627.0 L 1110.0 627.0 L 1107.0 629.0 L 1099.0 629.0 L 1094.0 627.0 L 1086.0 619.0 Z",
      "position": {
        "x": 1126.8,
        "y": 585.7
      },
      "badgeAnchor": {
        "x": 1126.8,
        "y": 585.7
      },
      "adjacencies": [
        "goldsand"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "sunreef",
      "name": "Sunreef",
      "regionId": "amberstrand",
      "shape": "M 1053.0 623.0 L 1045.0 631.0 L 1045.0 633.0 L 1038.0 639.0 L 1038.0 653.0 L 1032.0 658.0 L 1032.0 660.0 L 1024.0 664.0 L 1021.0 668.0 L 1015.0 672.0 L 1013.0 672.0 L 1011.0 678.0 L 1006.0 684.0 L 1000.0 685.0 L 997.0 688.0 L 996.0 698.0 L 990.0 700.0 L 986.0 703.0 L 986.0 715.0 L 990.0 715.0 L 992.0 721.0 L 996.0 724.0 L 1011.0 729.0 L 1017.0 734.0 L 1017.0 736.0 L 1022.0 740.0 L 1028.0 752.0 L 1034.0 755.0 L 1034.0 757.0 L 1039.0 766.0 L 1043.0 771.0 L 1049.0 769.0 L 1059.0 769.0 L 1065.0 765.0 L 1070.0 765.0 L 1077.0 761.0 L 1077.0 754.0 L 1070.0 747.0 L 1075.0 747.0 L 1087.0 741.0 L 1100.0 740.0 L 1104.0 737.0 L 1104.0 727.0 L 1102.0 725.0 L 1100.0 715.0 L 1100.0 698.0 L 1095.0 692.0 L 1090.0 678.0 L 1089.0 671.0 L 1092.0 666.0 L 1092.0 663.0 L 1097.0 659.0 L 1099.0 655.0 L 1099.0 649.0 L 1093.0 645.0 L 1090.0 645.0 L 1085.0 642.0 L 1080.0 642.0 L 1073.0 634.0 L 1065.0 631.0 L 1061.0 627.0 Z",
      "position": {
        "x": 1050.5,
        "y": 703.1
      },
      "badgeAnchor": {
        "x": 1050.5,
        "y": 703.1
      },
      "adjacencies": [
        "amberlight",
        "goldsand",
        "honeycove"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "coralgate",
      "name": "Coralgate",
      "regionId": "tritonmere",
      "shape": "M 887.0 879.0 L 887.0 881.0 L 889.0 883.0 L 889.0 896.0 L 892.0 899.0 L 892.0 904.0 L 887.0 908.0 L 882.0 918.0 L 879.0 920.0 L 879.0 928.0 L 881.0 931.0 L 888.0 937.0 L 889.0 941.0 L 883.0 947.0 L 878.0 947.0 L 875.0 952.0 L 870.0 956.0 L 870.0 963.0 L 868.0 965.0 L 868.0 969.0 L 875.0 975.0 L 875.0 983.0 L 870.0 987.0 L 867.0 992.0 L 867.0 998.0 L 873.0 1007.0 L 876.0 1010.0 L 876.0 1012.0 L 884.0 1011.0 L 891.0 1004.0 L 897.0 1004.0 L 904.0 1010.0 L 918.0 1014.0 L 918.0 1010.0 L 922.0 1008.0 L 927.0 1011.0 L 934.0 1011.0 L 938.0 1008.0 L 938.0 998.0 L 944.0 992.0 L 944.0 981.0 L 942.0 978.0 L 943.0 972.0 L 951.0 972.0 L 955.0 969.0 L 956.0 964.0 L 962.0 959.0 L 962.0 950.0 L 959.0 948.0 L 964.0 943.0 L 964.0 937.0 L 962.0 935.0 L 956.0 929.0 L 954.0 923.0 L 951.0 921.0 L 951.0 913.0 L 957.0 908.0 L 956.0 904.0 L 948.0 896.0 L 948.0 886.0 L 944.0 882.0 L 937.0 880.0 L 938.0 871.0 L 931.0 866.0 L 931.0 852.0 L 934.0 849.0 L 934.0 844.0 L 930.0 840.0 L 919.0 836.0 L 919.0 835.0 L 909.0 831.0 L 903.0 832.0 L 899.0 839.0 L 898.0 846.0 L 894.0 851.0 L 893.0 855.0 L 893.0 868.0 L 890.0 873.0 L 890.0 877.0 Z",
      "position": {
        "x": 923.7,
        "y": 942.9
      },
      "badgeAnchor": {
        "x": 923.7,
        "y": 942.9
      },
      "adjacencies": [
        "dune-harbour",
        "honeycove",
        "shellmark",
        "tidewell",
        "tridentfall"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "merrow-rest",
      "name": "Merrow Rest",
      "regionId": "tritonmere",
      "shape": "M 749.0 986.0 L 761.0 979.0 L 770.0 979.0 L 775.0 982.0 L 788.0 981.0 L 790.0 985.0 L 790.0 991.0 L 796.0 992.0 L 808.0 984.0 L 808.0 978.0 L 814.0 972.0 L 818.0 970.0 L 818.0 966.0 L 815.0 962.0 L 816.0 951.0 L 812.0 948.0 L 803.0 938.0 L 801.0 934.0 L 801.0 925.0 L 800.0 923.0 L 792.0 917.0 L 792.0 913.0 L 785.0 902.0 L 781.0 903.0 L 778.0 910.0 L 775.0 910.0 L 771.0 907.0 L 766.0 907.0 L 754.0 912.0 L 751.0 909.0 L 740.0 909.0 L 734.0 915.0 L 728.0 914.0 L 726.0 912.0 L 720.0 912.0 L 716.0 915.0 L 707.0 915.0 L 704.0 919.0 L 693.0 919.0 L 688.0 916.0 L 683.0 916.0 L 681.0 914.0 L 669.0 914.0 L 665.0 918.0 L 654.0 916.0 L 654.0 917.0 L 643.0 917.0 L 639.0 921.0 L 639.0 931.0 L 642.0 933.0 L 650.0 933.0 L 656.0 937.0 L 660.0 938.0 L 660.0 945.0 L 663.0 949.0 L 668.0 952.0 L 673.0 952.0 L 678.0 948.0 L 689.0 948.0 L 701.0 962.0 L 709.0 961.0 L 714.0 953.0 L 717.0 951.0 L 722.0 951.0 L 719.0 957.0 L 719.0 964.0 L 722.0 967.0 L 730.0 967.0 L 736.0 964.0 L 736.0 969.0 L 739.0 973.0 L 738.0 982.0 L 742.0 986.0 Z",
      "position": {
        "x": 767.3,
        "y": 943.9
      },
      "badgeAnchor": {
        "x": 767.3,
        "y": 943.9
      },
      "adjacencies": [
        "lantern-key",
        "shellmark",
        "tridentfall"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "nautilus-bay",
      "name": "Nautilus Bay",
      "regionId": "tritonmere",
      "shape": "M 732.0 1026.0 L 728.0 1031.0 L 726.0 1031.0 L 720.0 1042.0 L 711.0 1046.0 L 708.0 1049.0 L 708.0 1053.0 L 703.0 1061.0 L 691.0 1060.0 L 686.0 1066.0 L 680.0 1070.0 L 680.0 1079.0 L 676.0 1080.0 L 669.0 1089.0 L 664.0 1090.0 L 658.0 1096.0 L 656.0 1100.0 L 656.0 1109.0 L 647.0 1112.0 L 646.0 1114.0 L 640.0 1117.0 L 640.0 1126.0 L 647.0 1129.0 L 656.0 1129.0 L 661.0 1128.0 L 665.0 1130.0 L 673.0 1131.0 L 681.0 1136.0 L 691.0 1136.0 L 696.0 1130.0 L 702.0 1126.0 L 718.0 1126.0 L 721.0 1124.0 L 738.0 1124.0 L 745.0 1123.0 L 754.0 1127.0 L 761.0 1128.0 L 765.0 1131.0 L 771.0 1131.0 L 775.0 1129.0 L 775.0 1126.0 L 774.0 1126.0 L 774.0 1116.0 L 777.0 1111.0 L 782.0 1108.0 L 783.0 1100.0 L 792.0 1095.0 L 794.0 1092.0 L 803.0 1091.0 L 808.0 1096.0 L 811.0 1096.0 L 811.0 1080.0 L 815.0 1077.0 L 815.0 1073.0 L 809.0 1069.0 L 804.0 1062.0 L 802.0 1062.0 L 802.0 1061.0 L 789.0 1063.0 L 786.0 1059.0 L 778.0 1053.0 L 770.0 1053.0 L 765.0 1049.0 L 760.0 1049.0 L 753.0 1041.0 L 751.0 1041.0 L 744.0 1032.0 L 740.0 1031.0 L 736.0 1027.0 Z",
      "position": {
        "x": 737.4,
        "y": 1082.7
      },
      "badgeAnchor": {
        "x": 737.4,
        "y": 1082.7
      },
      "adjacencies": [
        "shellmark",
        "tidewell"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "shellmark",
      "name": "Shellmark",
      "regionId": "tritonmere",
      "shape": "M 818.0 969.0 L 818.0 970.0 L 814.0 972.0 L 808.0 978.0 L 808.0 984.0 L 796.0 992.0 L 790.0 991.0 L 790.0 985.0 L 788.0 981.0 L 775.0 982.0 L 770.0 979.0 L 761.0 979.0 L 749.0 986.0 L 745.0 986.0 L 742.0 989.0 L 742.0 996.0 L 740.0 999.0 L 740.0 1010.0 L 733.0 1017.0 L 732.0 1026.0 L 736.0 1027.0 L 740.0 1031.0 L 744.0 1032.0 L 751.0 1041.0 L 753.0 1041.0 L 760.0 1049.0 L 765.0 1049.0 L 770.0 1053.0 L 778.0 1053.0 L 786.0 1059.0 L 789.0 1063.0 L 802.0 1061.0 L 802.0 1052.0 L 806.0 1045.0 L 814.0 1039.0 L 816.0 1027.0 L 823.0 1023.0 L 829.0 1022.0 L 833.0 1023.0 L 840.0 1019.0 L 841.0 1017.0 L 846.0 1017.0 L 856.0 1012.0 L 865.0 1012.0 L 870.0 1015.0 L 876.0 1013.0 L 876.0 1010.0 L 873.0 1007.0 L 867.0 998.0 L 867.0 992.0 L 870.0 987.0 L 875.0 983.0 L 875.0 975.0 L 868.0 969.0 L 868.0 968.0 L 862.0 966.0 L 857.0 958.0 L 852.0 955.0 L 847.0 963.0 L 843.0 965.0 L 838.0 973.0 L 832.0 973.0 L 829.0 970.0 Z",
      "position": {
        "x": 780.1,
        "y": 1021.1
      },
      "badgeAnchor": {
        "x": 780.1,
        "y": 1021.1
      },
      "adjacencies": [
        "coralgate",
        "merrow-rest",
        "nautilus-bay",
        "tidewell",
        "tridentfall"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "tidewell",
      "name": "Tidewell",
      "regionId": "tritonmere",
      "shape": "M 876.0 1012.0 L 876.0 1013.0 L 870.0 1015.0 L 865.0 1012.0 L 856.0 1012.0 L 846.0 1017.0 L 841.0 1017.0 L 840.0 1019.0 L 833.0 1023.0 L 829.0 1022.0 L 823.0 1023.0 L 816.0 1027.0 L 814.0 1039.0 L 806.0 1045.0 L 802.0 1052.0 L 802.0 1062.0 L 804.0 1062.0 L 809.0 1069.0 L 815.0 1073.0 L 815.0 1077.0 L 811.0 1080.0 L 811.0 1096.0 L 808.0 1096.0 L 803.0 1091.0 L 794.0 1092.0 L 792.0 1095.0 L 783.0 1100.0 L 782.0 1108.0 L 777.0 1111.0 L 774.0 1116.0 L 774.0 1126.0 L 775.0 1126.0 L 783.0 1127.0 L 791.0 1124.0 L 801.0 1123.0 L 804.0 1125.0 L 821.0 1125.0 L 824.0 1123.0 L 830.0 1122.0 L 834.0 1119.0 L 839.0 1113.0 L 843.0 1110.0 L 847.0 1110.0 L 849.0 1115.0 L 856.0 1119.0 L 862.0 1126.0 L 867.0 1129.0 L 874.0 1129.0 L 880.0 1124.0 L 881.0 1119.0 L 881.0 1106.0 L 877.0 1101.0 L 876.0 1097.0 L 881.0 1096.0 L 886.0 1092.0 L 886.0 1083.0 L 891.0 1083.0 L 894.0 1081.0 L 897.0 1075.0 L 906.0 1076.0 L 905.0 1080.0 L 900.0 1086.0 L 900.0 1093.0 L 902.0 1096.0 L 907.0 1097.0 L 912.0 1101.0 L 917.0 1101.0 L 921.0 1099.0 L 926.0 1090.0 L 931.0 1090.0 L 936.0 1085.0 L 936.0 1078.0 L 940.0 1071.0 L 946.0 1071.0 L 949.0 1069.0 L 949.0 1062.0 L 945.0 1057.0 L 945.0 1054.0 L 942.0 1050.0 L 942.0 1047.0 L 936.0 1043.0 L 929.0 1044.0 L 926.0 1048.0 L 919.0 1044.0 L 913.0 1044.0 L 906.0 1048.0 L 900.0 1047.0 L 901.0 1039.0 L 906.0 1035.0 L 906.0 1024.0 L 911.0 1024.0 L 918.0 1019.0 L 918.0 1014.0 L 904.0 1010.0 L 897.0 1004.0 L 891.0 1004.0 L 884.0 1011.0 Z",
      "position": {
        "x": 853.3,
        "y": 1058.3
      },
      "badgeAnchor": {
        "x": 853.3,
        "y": 1058.3
      },
      "adjacencies": [
        "coralgate",
        "nautilus-bay",
        "shellmark"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "tridentfall",
      "name": "Tridentfall",
      "regionId": "tritonmere",
      "shape": "M 785.0 902.0 L 792.0 913.0 L 792.0 917.0 L 800.0 923.0 L 801.0 925.0 L 801.0 934.0 L 803.0 938.0 L 812.0 948.0 L 816.0 951.0 L 815.0 962.0 L 818.0 966.0 L 818.0 969.0 L 829.0 970.0 L 832.0 973.0 L 838.0 973.0 L 843.0 965.0 L 847.0 963.0 L 852.0 955.0 L 857.0 958.0 L 862.0 966.0 L 868.0 968.0 L 868.0 965.0 L 870.0 963.0 L 870.0 956.0 L 875.0 952.0 L 878.0 947.0 L 883.0 947.0 L 889.0 941.0 L 888.0 937.0 L 881.0 931.0 L 879.0 928.0 L 879.0 920.0 L 882.0 918.0 L 887.0 908.0 L 892.0 904.0 L 892.0 899.0 L 889.0 896.0 L 889.0 883.0 L 887.0 881.0 L 887.0 880.0 L 883.0 879.0 L 881.0 876.0 L 877.0 875.0 L 875.0 877.0 L 866.0 876.0 L 858.0 870.0 L 856.0 865.0 L 850.0 864.0 L 847.0 862.0 L 845.0 857.0 L 839.0 852.0 L 836.0 851.0 L 831.0 856.0 L 828.0 862.0 L 819.0 861.0 L 813.0 865.0 L 812.0 875.0 L 813.0 878.0 L 805.0 878.0 L 801.0 881.0 L 799.0 888.0 L 792.0 888.0 L 788.0 891.0 L 788.0 899.0 Z",
      "position": {
        "x": 839.2,
        "y": 909.9
      },
      "badgeAnchor": {
        "x": 839.2,
        "y": 909.9
      },
      "adjacencies": [
        "coralgate",
        "dune-harbour",
        "merrow-rest",
        "shellmark"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "drakesfoot",
      "name": "Drakesfoot",
      "regionId": "wyrmtail",
      "shape": "M 440.0 1029.0 L 443.0 1034.0 L 443.0 1043.0 L 438.0 1050.0 L 438.0 1055.0 L 440.0 1057.0 L 440.0 1065.0 L 435.0 1072.0 L 436.0 1080.0 L 436.0 1082.0 L 442.0 1086.0 L 458.0 1086.0 L 462.0 1089.0 L 467.0 1095.0 L 467.0 1102.0 L 465.0 1104.0 L 466.0 1110.0 L 469.0 1112.0 L 470.0 1116.0 L 473.0 1118.0 L 473.0 1124.0 L 465.0 1131.0 L 465.0 1136.0 L 468.0 1138.0 L 478.0 1138.0 L 493.0 1136.0 L 495.0 1137.0 L 497.0 1143.0 L 507.0 1152.0 L 509.0 1157.0 L 525.0 1157.0 L 532.0 1158.0 L 544.0 1155.0 L 546.0 1153.0 L 553.0 1153.0 L 557.0 1148.0 L 564.0 1143.0 L 565.0 1141.0 L 570.0 1141.0 L 576.0 1137.0 L 580.0 1137.0 L 586.0 1142.0 L 598.0 1142.0 L 603.0 1139.0 L 613.0 1139.0 L 615.0 1141.0 L 623.0 1141.0 L 626.0 1138.0 L 626.0 1131.0 L 623.0 1127.0 L 623.0 1121.0 L 617.0 1113.0 L 605.0 1107.0 L 601.0 1101.0 L 594.0 1095.0 L 590.0 1094.0 L 588.0 1083.0 L 585.0 1081.0 L 583.0 1076.0 L 579.0 1074.0 L 572.0 1067.0 L 564.0 1064.0 L 550.0 1064.0 L 545.0 1059.0 L 538.0 1059.0 L 530.0 1054.0 L 530.0 1049.0 L 522.0 1044.0 L 519.0 1044.0 L 519.0 1037.0 L 513.0 1032.0 L 505.0 1031.0 L 497.0 1019.0 L 495.0 1019.0 L 491.0 1013.0 L 488.0 1011.0 L 488.0 1006.0 L 484.0 1001.0 L 473.0 1001.0 L 467.0 1003.0 L 461.0 1007.0 L 461.0 1015.0 L 458.0 1019.0 L 452.0 1022.0 L 445.0 1022.0 L 440.0 1026.0 Z",
      "position": {
        "x": 531.8,
        "y": 1107.7
      },
      "badgeAnchor": {
        "x": 531.8,
        "y": 1107.7
      },
      "adjacencies": [
        "driftspire",
        "serpent-coil",
        "wyrmtip"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "fangmouth",
      "name": "Fangmouth",
      "regionId": "wyrmtail",
      "shape": "M 314.0 916.0 L 306.0 919.0 L 296.0 918.0 L 291.0 920.0 L 285.0 927.0 L 283.0 927.0 L 283.0 930.0 L 286.0 934.0 L 288.0 940.0 L 288.0 950.0 L 281.0 960.0 L 282.0 966.0 L 286.0 969.0 L 289.0 979.0 L 286.0 985.0 L 283.0 987.0 L 281.0 992.0 L 273.0 999.0 L 269.0 1001.0 L 261.0 1001.0 L 259.0 999.0 L 253.0 999.0 L 247.0 1001.0 L 241.0 1010.0 L 235.0 1015.0 L 235.0 1019.0 L 233.0 1022.0 L 233.0 1035.0 L 234.0 1037.0 L 242.0 1044.0 L 246.0 1045.0 L 253.0 1051.0 L 261.0 1055.0 L 260.0 1068.0 L 262.0 1072.0 L 270.0 1078.0 L 286.0 1078.0 L 286.0 1077.0 L 288.0 1076.0 L 292.0 1066.0 L 303.0 1060.0 L 304.0 1053.0 L 307.0 1048.0 L 314.0 1046.0 L 321.0 1046.0 L 325.0 1044.0 L 330.0 1044.0 L 337.0 1036.0 L 339.0 1035.0 L 352.0 1035.0 L 355.0 1037.0 L 360.0 1037.0 L 369.0 1042.0 L 373.0 1047.0 L 378.0 1047.0 L 381.0 1049.0 L 386.0 1049.0 L 392.0 1047.0 L 395.0 1044.0 L 396.0 1036.0 L 407.0 1026.0 L 411.0 1019.0 L 407.0 1014.0 L 407.0 1011.0 L 403.0 1008.0 L 391.0 1007.0 L 390.0 998.0 L 387.0 993.0 L 383.0 991.0 L 382.0 980.0 L 381.0 978.0 L 371.0 972.0 L 366.0 967.0 L 372.0 963.0 L 377.0 954.0 L 377.0 944.0 L 373.0 940.0 L 363.0 940.0 L 359.0 943.0 L 359.0 947.0 L 351.0 947.0 L 346.0 936.0 L 337.0 931.0 L 333.0 930.0 L 330.0 926.0 L 325.0 925.0 L 318.0 921.0 L 317.0 916.0 Z",
      "position": {
        "x": 330.7,
        "y": 992.5
      },
      "badgeAnchor": {
        "x": 330.7,
        "y": 992.5
      },
      "adjacencies": [
        "driftspire",
        "greenmarsh",
        "scalecrest",
        "serpent-coil"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "scalecrest",
      "name": "Scalecrest",
      "regionId": "wyrmtail",
      "shape": "M 105.0 866.0 L 105.0 884.0 L 112.0 888.0 L 114.0 891.0 L 110.0 895.0 L 110.0 905.0 L 115.0 910.0 L 120.0 910.0 L 124.0 915.0 L 131.0 920.0 L 143.0 920.0 L 148.0 922.0 L 149.0 930.0 L 155.0 934.0 L 155.0 937.0 L 152.0 942.0 L 152.0 950.0 L 156.0 955.0 L 157.0 959.0 L 167.0 965.0 L 172.0 964.0 L 176.0 965.0 L 175.0 977.0 L 180.0 985.0 L 188.0 989.0 L 202.0 989.0 L 207.0 987.0 L 207.0 995.0 L 213.0 1001.0 L 222.0 1001.0 L 224.0 1003.0 L 225.0 1009.0 L 228.0 1013.0 L 235.0 1015.0 L 241.0 1010.0 L 247.0 1001.0 L 253.0 999.0 L 259.0 999.0 L 261.0 1001.0 L 269.0 1001.0 L 273.0 999.0 L 281.0 992.0 L 283.0 987.0 L 286.0 985.0 L 289.0 979.0 L 286.0 969.0 L 282.0 966.0 L 281.0 960.0 L 288.0 950.0 L 288.0 940.0 L 286.0 934.0 L 283.0 930.0 L 283.0 928.0 L 278.0 927.0 L 273.0 923.0 L 265.0 922.0 L 262.0 919.0 L 261.0 914.0 L 257.0 908.0 L 248.0 903.0 L 240.0 903.0 L 239.0 905.0 L 233.0 908.0 L 220.0 905.0 L 208.0 894.0 L 200.0 884.0 L 193.0 884.0 L 191.0 888.0 L 186.0 891.0 L 179.0 890.0 L 172.0 883.0 L 159.0 883.0 L 157.0 885.0 L 155.0 892.0 L 148.0 892.0 L 144.0 890.0 L 141.0 886.0 L 135.0 884.0 L 128.0 878.0 L 127.0 874.0 L 119.0 866.0 L 114.0 864.0 L 108.0 864.0 Z",
      "position": {
        "x": 233.3,
        "y": 952.1
      },
      "badgeAnchor": {
        "x": 233.3,
        "y": 952.1
      },
      "adjacencies": [
        "fangmouth",
        "fernshallow",
        "greenmarsh"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "serpent-coil",
      "name": "Serpent Coil",
      "regionId": "wyrmtail",
      "shape": "M 411.0 1019.0 L 407.0 1026.0 L 396.0 1036.0 L 395.0 1044.0 L 392.0 1047.0 L 386.0 1049.0 L 381.0 1049.0 L 378.0 1047.0 L 373.0 1047.0 L 369.0 1042.0 L 360.0 1037.0 L 355.0 1037.0 L 352.0 1035.0 L 339.0 1035.0 L 337.0 1036.0 L 330.0 1044.0 L 325.0 1044.0 L 321.0 1046.0 L 314.0 1046.0 L 307.0 1048.0 L 304.0 1053.0 L 303.0 1060.0 L 292.0 1066.0 L 288.0 1076.0 L 286.0 1077.0 L 286.0 1089.0 L 289.0 1091.0 L 295.0 1091.0 L 292.0 1095.0 L 287.0 1098.0 L 287.0 1109.0 L 293.0 1115.0 L 299.0 1115.0 L 303.0 1111.0 L 306.0 1111.0 L 304.0 1116.0 L 304.0 1121.0 L 308.0 1124.0 L 307.0 1128.0 L 310.0 1135.0 L 316.0 1140.0 L 321.0 1141.0 L 325.0 1138.0 L 333.0 1137.0 L 334.0 1134.0 L 341.0 1130.0 L 348.0 1130.0 L 351.0 1128.0 L 365.0 1129.0 L 368.0 1128.0 L 371.0 1124.0 L 371.0 1121.0 L 374.0 1118.0 L 381.0 1116.0 L 389.0 1116.0 L 391.0 1118.0 L 398.0 1118.0 L 402.0 1114.0 L 410.0 1111.0 L 418.0 1102.0 L 424.0 1101.0 L 430.0 1093.0 L 430.0 1087.0 L 436.0 1083.0 L 436.0 1080.0 L 435.0 1072.0 L 440.0 1065.0 L 440.0 1057.0 L 438.0 1055.0 L 438.0 1050.0 L 443.0 1043.0 L 443.0 1034.0 L 440.0 1029.0 L 435.0 1023.0 L 431.0 1022.0 L 425.0 1017.0 L 418.0 1016.0 Z",
      "position": {
        "x": 346.4,
        "y": 1084.3
      },
      "badgeAnchor": {
        "x": 346.4,
        "y": 1084.3
      },
      "adjacencies": [
        "drakesfoot",
        "driftspire",
        "fangmouth",
        "wyrmtip"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "wyrmtip",
      "name": "Wyrmtip",
      "regionId": "wyrmtail",
      "shape": "M 436.0 1082.0 L 436.0 1083.0 L 430.0 1087.0 L 430.0 1093.0 L 424.0 1101.0 L 418.0 1102.0 L 410.0 1111.0 L 402.0 1114.0 L 398.0 1118.0 L 391.0 1118.0 L 389.0 1116.0 L 381.0 1116.0 L 374.0 1118.0 L 371.0 1121.0 L 371.0 1124.0 L 368.0 1128.0 L 365.0 1129.0 L 351.0 1128.0 L 348.0 1130.0 L 341.0 1130.0 L 334.0 1134.0 L 333.0 1137.0 L 325.0 1138.0 L 321.0 1141.0 L 315.0 1141.0 L 310.0 1144.0 L 309.0 1147.0 L 302.0 1149.0 L 298.0 1155.0 L 298.0 1169.0 L 291.0 1172.0 L 288.0 1176.0 L 287.0 1182.0 L 283.0 1188.0 L 282.0 1196.0 L 278.0 1201.0 L 272.0 1201.0 L 269.0 1203.0 L 269.0 1214.0 L 273.0 1222.0 L 275.0 1223.0 L 285.0 1223.0 L 287.0 1221.0 L 291.0 1222.0 L 294.0 1228.0 L 300.0 1232.0 L 311.0 1232.0 L 319.0 1224.0 L 320.0 1218.0 L 322.0 1217.0 L 322.0 1208.0 L 321.0 1208.0 L 321.0 1196.0 L 322.0 1194.0 L 329.0 1199.0 L 339.0 1199.0 L 345.0 1194.0 L 345.0 1185.0 L 355.0 1184.0 L 359.0 1181.0 L 360.0 1173.0 L 367.0 1173.0 L 368.0 1179.0 L 371.0 1181.0 L 379.0 1181.0 L 384.0 1179.0 L 388.0 1184.0 L 392.0 1186.0 L 402.0 1186.0 L 409.0 1179.0 L 412.0 1184.0 L 417.0 1188.0 L 424.0 1188.0 L 428.0 1185.0 L 432.0 1175.0 L 444.0 1176.0 L 456.0 1168.0 L 465.0 1168.0 L 468.0 1172.0 L 472.0 1174.0 L 495.0 1174.0 L 500.0 1172.0 L 505.0 1166.0 L 506.0 1162.0 L 509.0 1160.0 L 509.0 1157.0 L 507.0 1152.0 L 497.0 1143.0 L 495.0 1137.0 L 493.0 1136.0 L 478.0 1138.0 L 468.0 1138.0 L 465.0 1136.0 L 465.0 1131.0 L 473.0 1124.0 L 473.0 1118.0 L 470.0 1116.0 L 469.0 1112.0 L 466.0 1110.0 L 465.0 1104.0 L 467.0 1102.0 L 467.0 1095.0 L 462.0 1089.0 L 458.0 1086.0 L 442.0 1086.0 Z",
      "position": {
        "x": 430,
        "y": 1139.9
      },
      "badgeAnchor": {
        "x": 430,
        "y": 1139.9
      },
      "adjacencies": [
        "drakesfoot",
        "serpent-coil"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "barnacle-key",
      "name": "Barnacle Key",
      "regionId": "leviathans-spine",
      "shape": "M 511.0 756.0 L 506.0 761.0 L 502.0 763.0 L 496.0 763.0 L 489.0 767.0 L 487.0 774.0 L 484.0 777.0 L 485.0 784.0 L 485.0 793.0 L 484.0 801.0 L 485.0 803.0 L 493.0 808.0 L 495.0 813.0 L 501.0 817.0 L 511.0 817.0 L 514.0 815.0 L 520.0 814.0 L 527.0 806.0 L 531.0 805.0 L 535.0 799.0 L 535.0 793.0 L 540.0 783.0 L 540.0 775.0 L 537.0 769.0 L 525.0 763.0 L 525.0 761.0 L 517.0 756.0 Z",
      "position": {
        "x": 510.3,
        "y": 786.7
      },
      "badgeAnchor": {
        "x": 510.3,
        "y": 786.7
      },
      "adjacencies": [
        "gullrock",
        "hookjaw",
        "knuckle-isle"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "driftspire",
      "name": "Driftspire",
      "regionId": "leviathans-spine",
      "shape": "M 428.0 855.0 L 424.0 860.0 L 424.0 874.0 L 425.0 882.0 L 423.0 887.0 L 421.0 887.0 L 415.0 895.0 L 415.0 906.0 L 425.0 917.0 L 421.0 924.0 L 417.0 928.0 L 416.0 939.0 L 417.0 939.0 L 417.0 950.0 L 416.0 950.0 L 416.0 959.0 L 418.0 965.0 L 420.0 966.0 L 420.0 972.0 L 416.0 978.0 L 416.0 989.0 L 418.0 995.0 L 421.0 999.0 L 435.0 1005.0 L 438.0 1008.0 L 444.0 1008.0 L 447.0 1006.0 L 449.0 999.0 L 453.0 1000.0 L 467.0 1000.0 L 473.0 995.0 L 472.0 985.0 L 466.0 981.0 L 463.0 968.0 L 466.0 963.0 L 466.0 956.0 L 461.0 951.0 L 457.0 945.0 L 455.0 938.0 L 454.0 926.0 L 461.0 920.0 L 462.0 914.0 L 464.0 914.0 L 469.0 907.0 L 469.0 897.0 L 468.0 894.0 L 461.0 888.0 L 455.0 886.0 L 452.0 881.0 L 449.0 879.0 L 445.0 873.0 L 439.0 858.0 L 435.0 855.0 Z",
      "position": {
        "x": 441.9,
        "y": 977.2
      },
      "badgeAnchor": {
        "x": 441.9,
        "y": 977.2
      },
      "adjacencies": [
        "drakesfoot",
        "fangmouth",
        "greenmarsh",
        "gullrock",
        "hookjaw",
        "serpent-coil"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "finback",
      "name": "Finback",
      "regionId": "leviathans-spine",
      "shape": "M 722.0 496.0 L 716.0 504.0 L 708.0 504.0 L 704.0 506.0 L 696.0 514.0 L 688.0 516.0 L 686.0 520.0 L 686.0 531.0 L 688.0 534.0 L 688.0 547.0 L 691.0 551.0 L 695.0 553.0 L 707.0 553.0 L 712.0 562.0 L 713.0 562.0 L 713.0 579.0 L 724.0 589.0 L 733.0 589.0 L 737.0 587.0 L 742.0 582.0 L 742.0 571.0 L 748.0 565.0 L 749.0 559.0 L 746.0 551.0 L 738.0 544.0 L 739.0 536.0 L 743.0 532.0 L 743.0 528.0 L 749.0 519.0 L 750.0 508.0 L 742.0 500.0 L 734.0 496.0 Z",
      "position": {
        "x": 715.5,
        "y": 529.1
      },
      "badgeAnchor": {
        "x": 715.5,
        "y": 529.1
      },
      "adjacencies": [
        "abyss-gate",
        "coilhaven",
        "deepgrasp",
        "great-leviathan",
        "longrib",
        "crownhaven"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "great-leviathan",
      "name": "Great Leviathan",
      "regionId": "leviathans-spine",
      "shape": "M 555.0 541.0 L 550.0 545.0 L 540.0 544.0 L 531.0 549.0 L 531.0 552.0 L 524.0 555.0 L 522.0 559.0 L 522.0 566.0 L 519.0 570.0 L 519.0 580.0 L 525.0 585.0 L 521.0 587.0 L 515.0 594.0 L 515.0 605.0 L 516.0 608.0 L 512.0 612.0 L 511.0 623.0 L 512.0 625.0 L 519.0 628.0 L 519.0 640.0 L 523.0 644.0 L 540.0 644.0 L 544.0 648.0 L 544.0 661.0 L 548.0 665.0 L 549.0 669.0 L 554.0 672.0 L 560.0 672.0 L 567.0 665.0 L 570.0 654.0 L 573.0 651.0 L 578.0 651.0 L 585.0 647.0 L 585.0 650.0 L 590.0 655.0 L 604.0 655.0 L 611.0 651.0 L 613.0 646.0 L 613.0 639.0 L 616.0 635.0 L 616.0 624.0 L 609.0 620.0 L 607.0 617.0 L 612.0 612.0 L 626.0 612.0 L 632.0 608.0 L 632.0 599.0 L 640.0 595.0 L 643.0 590.0 L 642.0 577.0 L 639.0 572.0 L 634.0 570.0 L 634.0 565.0 L 627.0 561.0 L 624.0 558.0 L 615.0 557.0 L 609.0 564.0 L 604.0 564.0 L 599.0 569.0 L 599.0 574.0 L 586.0 568.0 L 585.0 563.0 L 579.0 555.0 L 575.0 554.0 L 571.0 546.0 L 564.0 541.0 Z",
      "position": {
        "x": 563.9,
        "y": 606.8
      },
      "badgeAnchor": {
        "x": 563.9,
        "y": 606.8
      },
      "adjacencies": [
        "crownhaven",
        "finback",
        "knuckle-isle",
        "lightning-ford",
        "longrib",
        "skyreach"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "gullrock",
      "name": "Gullrock",
      "regionId": "leviathans-spine",
      "shape": "M 462.0 801.0 L 453.0 809.0 L 449.0 809.0 L 445.0 812.0 L 443.0 817.0 L 443.0 832.0 L 440.0 837.0 L 440.0 847.0 L 444.0 852.0 L 452.0 859.0 L 458.0 861.0 L 463.0 861.0 L 469.0 857.0 L 479.0 855.0 L 481.0 853.0 L 485.0 854.0 L 490.0 851.0 L 492.0 842.0 L 497.0 837.0 L 497.0 827.0 L 492.0 823.0 L 488.0 812.0 L 482.0 809.0 L 474.0 801.0 Z",
      "position": {
        "x": 468.3,
        "y": 831.2
      },
      "badgeAnchor": {
        "x": 468.3,
        "y": 831.2
      },
      "adjacencies": [
        "barnacle-key",
        "driftspire",
        "hookjaw"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "hookjaw",
      "name": "Hookjaw",
      "regionId": "leviathans-spine",
      "shape": "M 611.0 896.0 L 597.0 896.0 L 591.0 901.0 L 581.0 901.0 L 575.0 898.0 L 569.0 898.0 L 558.0 905.0 L 558.0 913.0 L 562.0 916.0 L 572.0 916.0 L 578.0 919.0 L 580.0 924.0 L 587.0 929.0 L 587.0 936.0 L 591.0 938.0 L 611.0 938.0 L 611.0 939.0 L 621.0 939.0 L 625.0 935.0 L 625.0 922.0 L 631.0 914.0 L 631.0 906.0 L 627.0 903.0 L 624.0 903.0 L 623.0 897.0 L 619.0 895.0 Z",
      "position": {
        "x": 604.5,
        "y": 917.3
      },
      "badgeAnchor": {
        "x": 604.5,
        "y": 917.3
      },
      "adjacencies": [
        "barnacle-key",
        "driftspire",
        "gullrock",
        "knuckle-isle",
        "lantern-key"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "knuckle-isle",
      "name": "Knuckle Isle",
      "regionId": "leviathans-spine",
      "shape": "M 575.0 731.0 L 567.0 733.0 L 561.0 741.0 L 561.0 749.0 L 555.0 751.0 L 551.0 755.0 L 551.0 760.0 L 549.0 763.0 L 549.0 771.0 L 552.0 780.0 L 559.0 785.0 L 566.0 785.0 L 567.0 787.0 L 574.0 790.0 L 583.0 790.0 L 586.0 788.0 L 604.0 788.0 L 609.0 787.0 L 613.0 784.0 L 613.0 779.0 L 617.0 773.0 L 617.0 760.0 L 619.0 753.0 L 617.0 749.0 L 610.0 747.0 L 606.0 736.0 L 600.0 732.0 L 589.0 732.0 L 589.0 731.0 Z",
      "position": {
        "x": 585.9,
        "y": 760.2
      },
      "badgeAnchor": {
        "x": 585.9,
        "y": 760.2
      },
      "adjacencies": [
        "barnacle-key",
        "great-leviathan",
        "hookjaw",
        "longrib"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "lantern-key",
      "name": "Lantern Key",
      "regionId": "tritonmere",
      "shape": "M 773.0 843.0 L 765.0 846.0 L 756.0 846.0 L 754.0 847.0 L 747.0 859.0 L 743.0 864.0 L 744.0 878.0 L 748.0 882.0 L 753.0 883.0 L 775.0 883.0 L 781.0 884.0 L 791.0 881.0 L 802.0 869.0 L 803.0 867.0 L 803.0 858.0 L 802.0 858.0 L 802.0 847.0 L 796.0 843.0 Z",
      "position": {
        "x": 779.8,
        "y": 863.3
      },
      "badgeAnchor": {
        "x": 779.8,
        "y": 863.3
      },
      "adjacencies": [
        "dune-harbour",
        "hookjaw",
        "merrow-rest"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "longrib",
      "name": "Longrib",
      "regionId": "leviathans-spine",
      "shape": "M 744.0 592.0 L 740.0 595.0 L 727.0 595.0 L 723.0 599.0 L 719.0 600.0 L 716.0 605.0 L 715.0 617.0 L 704.0 622.0 L 701.0 628.0 L 701.0 640.0 L 705.0 643.0 L 711.0 644.0 L 714.0 648.0 L 714.0 654.0 L 707.0 658.0 L 704.0 658.0 L 699.0 661.0 L 696.0 669.0 L 696.0 686.0 L 688.0 693.0 L 677.0 693.0 L 668.0 696.0 L 665.0 699.0 L 665.0 718.0 L 667.0 725.0 L 676.0 730.0 L 677.0 732.0 L 688.0 735.0 L 695.0 734.0 L 701.0 730.0 L 705.0 721.0 L 716.0 721.0 L 720.0 719.0 L 725.0 712.0 L 725.0 693.0 L 733.0 689.0 L 735.0 686.0 L 738.0 677.0 L 747.0 677.0 L 752.0 672.0 L 751.0 667.0 L 751.0 654.0 L 748.0 647.0 L 745.0 644.0 L 745.0 640.0 L 751.0 634.0 L 751.0 622.0 L 750.0 619.0 L 756.0 614.0 L 761.0 606.0 L 761.0 597.0 L 760.0 594.0 L 756.0 591.0 Z",
      "position": {
        "x": 686.6,
        "y": 713.1
      },
      "badgeAnchor": {
        "x": 686.6,
        "y": 713.1
      },
      "adjacencies": [
        "finback",
        "great-leviathan",
        "knuckle-isle"
      ],
      "ownerId": "",
      "armies": 0
    }
  ],
  "geometryVersion": "v1-6ad8fcca-c0552648",
  "seaRoutes": [
    {
      "aId": "crownhaven",
      "bId": "great-leviathan",
      "from": {
        "x": 624,
        "y": 554
      },
      "to": {
        "x": 624,
        "y": 558
      }
    },
    {
      "aId": "crownhaven",
      "bId": "finback",
      "from": {
        "x": 718,
        "y": 493
      },
      "to": {
        "x": 722,
        "y": 496
      }
    },
    {
      "aId": "lightning-ford",
      "bId": "great-leviathan",
      "from": {
        "x": 534,
        "y": 473
      },
      "to": {
        "x": 555,
        "y": 541
      }
    },
    {
      "aId": "skyreach",
      "bId": "great-leviathan",
      "from": {
        "x": 601,
        "y": 482
      },
      "to": {
        "x": 564,
        "y": 541
      }
    },
    {
      "aId": "abyss-gate",
      "bId": "finback",
      "from": {
        "x": 824,
        "y": 555
      },
      "to": {
        "x": 749,
        "y": 559
      }
    },
    {
      "aId": "coilhaven",
      "bId": "finback",
      "from": {
        "x": 734,
        "y": 479
      },
      "to": {
        "x": 734,
        "y": 496
      }
    },
    {
      "aId": "deepgrasp",
      "bId": "finback",
      "from": {
        "x": 803,
        "y": 514
      },
      "to": {
        "x": 750,
        "y": 508
      }
    },
    {
      "aId": "greenmarsh",
      "bId": "driftspire",
      "from": {
        "x": 316,
        "y": 916
      },
      "to": {
        "x": 415,
        "y": 906
      }
    },
    {
      "aId": "dune-harbour",
      "bId": "lantern-key",
      "from": {
        "x": 827,
        "y": 832
      },
      "to": {
        "x": 802,
        "y": 847
      }
    },
    {
      "aId": "merrow-rest",
      "bId": "lantern-key",
      "from": {
        "x": 785,
        "y": 902
      },
      "to": {
        "x": 781,
        "y": 884
      }
    },
    {
      "aId": "drakesfoot",
      "bId": "driftspire",
      "from": {
        "x": 467,
        "y": 1003
      },
      "to": {
        "x": 467,
        "y": 1000
      }
    },
    {
      "aId": "fangmouth",
      "bId": "driftspire",
      "from": {
        "x": 407,
        "y": 1011
      },
      "to": {
        "x": 421,
        "y": 999
      }
    },
    {
      "aId": "serpent-coil",
      "bId": "driftspire",
      "from": {
        "x": 435,
        "y": 1023
      },
      "to": {
        "x": 438,
        "y": 1008
      }
    },
    {
      "aId": "barnacle-key",
      "bId": "gullrock",
      "from": {
        "x": 493,
        "y": 808
      },
      "to": {
        "x": 488,
        "y": 812
      }
    },
    {
      "aId": "barnacle-key",
      "bId": "hookjaw",
      "from": {
        "x": 520,
        "y": 814
      },
      "to": {
        "x": 569,
        "y": 898
      }
    },
    {
      "aId": "barnacle-key",
      "bId": "knuckle-isle",
      "from": {
        "x": 540,
        "y": 775
      },
      "to": {
        "x": 549,
        "y": 771
      }
    },
    {
      "aId": "driftspire",
      "bId": "gullrock",
      "from": {
        "x": 439,
        "y": 858
      },
      "to": {
        "x": 444,
        "y": 852
      }
    },
    {
      "aId": "driftspire",
      "bId": "hookjaw",
      "from": {
        "x": 469,
        "y": 907
      },
      "to": {
        "x": 558,
        "y": 905
      }
    },
    {
      "aId": "finback",
      "bId": "great-leviathan",
      "from": {
        "x": 688,
        "y": 547
      },
      "to": {
        "x": 642,
        "y": 577
      }
    },
    {
      "aId": "finback",
      "bId": "longrib",
      "from": {
        "x": 724,
        "y": 589
      },
      "to": {
        "x": 727,
        "y": 595
      }
    },
    {
      "aId": "great-leviathan",
      "bId": "knuckle-isle",
      "from": {
        "x": 560,
        "y": 672
      },
      "to": {
        "x": 575,
        "y": 731
      }
    },
    {
      "aId": "great-leviathan",
      "bId": "longrib",
      "from": {
        "x": 643,
        "y": 590
      },
      "to": {
        "x": 704,
        "y": 622
      }
    },
    {
      "aId": "gullrock",
      "bId": "hookjaw",
      "from": {
        "x": 490,
        "y": 851
      },
      "to": {
        "x": 558,
        "y": 905
      }
    },
    {
      "aId": "hookjaw",
      "bId": "knuckle-isle",
      "from": {
        "x": 597,
        "y": 896
      },
      "to": {
        "x": 583,
        "y": 790
      }
    },
    {
      "aId": "hookjaw",
      "bId": "lantern-key",
      "from": {
        "x": 631,
        "y": 906
      },
      "to": {
        "x": 744,
        "y": 878
      }
    },
    {
      "aId": "knuckle-isle",
      "bId": "longrib",
      "from": {
        "x": 617,
        "y": 749
      },
      "to": {
        "x": 667,
        "y": 725
      }
    }
  ]
}
